
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("bIHey", function(module, exports) {

$parcel$export(module.exports, "default", () => $8056f8a8baf9b7da$export$2e2bcd8739ae039);

var $74BVL = parcelRequire("74BVL");
let $8056f8a8baf9b7da$var$shouldInitilizeGlobalErrorHandler = true;
const $8056f8a8baf9b7da$var$errors = [];
let $8056f8a8baf9b7da$var$push = (name, labelStack, errorType, errorMessage, errorStack)=>{
    $8056f8a8baf9b7da$var$errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack
    });
};
const $8056f8a8baf9b7da$export$ebe081a8c9bf8176 = (sinkFunc)=>{
    $8056f8a8baf9b7da$var$push = sinkFunc;
    $8056f8a8baf9b7da$var$errors.forEach((e)=>{
        sinkFunc(e.name, e.labelStack, e.errorType, e.errorMessage, e.errorStack);
    });
    $8056f8a8baf9b7da$var$errors.length = 0;
};
const $8056f8a8baf9b7da$var$handleError = (e)=>{
    if (e.error?.UFOhasCaught === undefined) try {
        if (e.error instanceof Error) $8056f8a8baf9b7da$var$push('GlobalErrorHandler', null, e.error.name, e.error.message, e.error.stack);
        else if (e.error) {
            const hint = JSON.stringify(e.error).slice(0, 50);
            $8056f8a8baf9b7da$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
        } else if (e.message !== undefined) {
            const hint = e.message.slice(0, 50);
            $8056f8a8baf9b7da$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
        }
        if (e.error && typeof e.error === 'object') e.error.UFOhasCaught = true;
    // eslint-disable-next-line no-empty
    } catch (e) {}
};
const $8056f8a8baf9b7da$var$handlePromiseRejection = (e)=>{
    if (e.reason instanceof Error) $8056f8a8baf9b7da$var$push('GlobalErrorHandler', null, e.reason.name, e.reason.message, e.reason.stack);
    else if (e.reason) try {
        const hint = JSON.stringify(e.reason).slice(0, 50);
        $8056f8a8baf9b7da$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
    // eslint-disable-next-line no-empty
    } catch (e) {}
};
const $8056f8a8baf9b7da$var$setupUFOGlobalErrorHandler = ()=>{
    if ($8056f8a8baf9b7da$var$shouldInitilizeGlobalErrorHandler) {
        (0, $74BVL.bind)(window, {
            type: 'error',
            listener: (e)=>$8056f8a8baf9b7da$var$handleError(e)
        });
        (0, $74BVL.bind)(window, {
            type: 'unhandledrejection',
            listener: $8056f8a8baf9b7da$var$handlePromiseRejection
        });
        $8056f8a8baf9b7da$var$shouldInitilizeGlobalErrorHandler = false;
    }
};
var $8056f8a8baf9b7da$export$2e2bcd8739ae039 = $8056f8a8baf9b7da$var$setupUFOGlobalErrorHandler;

});

parcelRegister("1qnta", function(module, exports) {

$parcel$export(module.exports, "setActiveTrace", () => $a00f173b2a75093f$export$a1002be327997103);
$parcel$export(module.exports, "getActiveTrace", () => $a00f173b2a75093f$export$b6ac780db3a3cc77);
$parcel$export(module.exports, "clearActiveTrace", () => $a00f173b2a75093f$export$17ab21d7be720b);
$parcel$export(module.exports, "getActiveTraceHttpRequestHeaders", () => $a00f173b2a75093f$export$6e17cce6446848f9);

var $tjkVj = parcelRequire("tjkVj");
const $a00f173b2a75093f$var$state = {
    context: null
};
const $a00f173b2a75093f$export$a1002be327997103 = (traceId, spanId, type)=>{
    $a00f173b2a75093f$var$state.context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
};
const $a00f173b2a75093f$export$b6ac780db3a3cc77 = ()=>$a00f173b2a75093f$var$state.context || undefined;
const $a00f173b2a75093f$export$17ab21d7be720b = ()=>{
    $a00f173b2a75093f$var$state.context = null;
};
const $a00f173b2a75093f$export$6e17cce6446848f9 = (_url)=>{
    if ($a00f173b2a75093f$var$state.context === null) return null;
    const { traceId: traceId, spanId: spanId } = $a00f173b2a75093f$var$state.context;
    return (0, $tjkVj.makeTraceHttpRequestHeaders)(traceId, spanId);
};

});
parcelRegister("tjkVj", function(module, exports) {

$parcel$export(module.exports, "makeTraceHttpRequestHeaders", () => $cbf5a07d883d434c$export$1115c5277eb10d5e);
const $cbf5a07d883d434c$export$1115c5277eb10d5e = (traceId, spanId)=>({
        'X-B3-TraceId': traceId,
        'X-B3-SpanId': spanId
    });

});


parcelRegister("acbV3", function(module, exports) {

$parcel$export(module.exports, "browserMetrics", () => $57c25359163b6fe1$export$c08e7affcf78b064);

var $gwwta = parcelRequire("gwwta");

var $ayvjR = parcelRequire("ayvjR");

var $5Bdpp = parcelRequire("5Bdpp");

var $au6tI = parcelRequire("au6tI");

var $67ejG = parcelRequire("67ejG");

var $eBTRG = parcelRequire("eBTRG");

var $cQ9wm = parcelRequire("cQ9wm");

var $b5Sjr = parcelRequire("b5Sjr");
const $57c25359163b6fe1$var$makeBrowserMetrics = ()=>{
    const bm = {
        init (config) {
            (0, $au6tI.visibilityChangeObserver).start();
            if (config.events[(0, $b5Sjr.BMEventsType).WEB_VITALS]?.enabled) (0, $67ejG.webVitalsObserver).start();
            if (config.debug) {
                (0, $ayvjR.logger).enable();
                (0, $cQ9wm.submitter).setDebug(true);
                (0, $5Bdpp.pageLoadMetaMetric).setDebug(true);
            }
            (0, $cQ9wm.submitter).configure(config);
            if (config.ssr?.getDoneMark) (0, $gwwta.SSRGetDoneMark).setGetDoneMark(config.ssr.getDoneMark);
        },
        setRoute (newRoute) {
            (0, $eBTRG.Route).setRoute(newRoute);
        },
        startPageLoad (params) {
            (0, $5Bdpp.pageLoadMetaMetric).startPageLoad({
                isInitial: false,
                cancelStarted: true,
                ...params
            });
        },
        getPageLoadMetric () {
            return 0, $5Bdpp.pageLoadMetaMetric;
        },
        experimental__addPageLoadTimingFromPerformanceMarks (name, startMark, stopMark, initialOnly = true) {
            if (initialOnly && !(0, $5Bdpp.pageLoadMetaMetric).isInitialLoad()) return;
            const start = performance.getEntriesByName(startMark);
            const stop = performance.getEntriesByName(stopMark);
            if (start.length > 0 && stop.length > 0) {
                if ((0, $5Bdpp.pageLoadMetaMetric).isDebugMode()) try {
                    performance.measure(name, startMark, stopMark);
                } catch (e) {}
                const pageLoadData = (0, $5Bdpp.pageLoadMetaMetric).getData();
                if (pageLoadData.start !== null) {
                    const startMark = start[start.length - 1];
                    const timing = {
                        startTime: Math.round(startMark.startTime - pageLoadData.start),
                        duration: Math.round(stop[stop.length - 1].startTime - startMark.startTime)
                    };
                    (0, $5Bdpp.pageLoadMetaMetric).experimental__addExplicitTiming(name, timing);
                }
            }
        }
    };
    return bm;
};
const $57c25359163b6fe1$export$c08e7affcf78b064 = $57c25359163b6fe1$var$makeBrowserMetrics();

});
parcelRegister("gwwta", function(module, exports) {

$parcel$export(module.exports, "SSRGetDoneMark", () => $3625ce05545f37ca$export$9e87a201397ac0a9);
const $3625ce05545f37ca$export$9e87a201397ac0a9 = {
    getDoneMark: ()=>null,
    setGetDoneMark: (fn)=>{
        $3625ce05545f37ca$export$9e87a201397ac0a9.getDoneMark = fn;
    }
};

});

parcelRegister("ayvjR", function(module, exports) {

$parcel$export(module.exports, "logger", () => $35bacc31ebafd656$export$af88d00dbe7f521);
const $35bacc31ebafd656$export$af88d00dbe7f521 = {
    enabled: false,
    enable () {
        this.enabled = true;
    },
    log (...args) {
        if (this.enabled) // eslint-disable-next-line no-console
        console.log('BM log: ', ...args);
    },
    logCond (condition, ...args) {
        if (this.enabled && condition && args.length > 1) this.log(...args);
    }
};

});

parcelRegister("5Bdpp", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetaMetric", () => $4cc9a206b8a92019$export$24b7a1a311eb05dc);

var $b5Sjr = parcelRequire("b5Sjr");

var $csrXc = parcelRequire("csrXc");

var $hW7BM = parcelRequire("hW7BM");
class $4cc9a206b8a92019$export$9609608c00ea5077 extends (0, $hW7BM.BasePageLoadMetric) {
    startPageLoad({ cancelStarted: cancelStarted, ...startPageLoadParams } = {
        isInitial: false,
        cancelStarted: false
    }) {
        if (cancelStarted || this.state !== (0, $csrXc.MetricState).STARTED) super.startPageLoad(startPageLoadParams);
    }
    setActive(metric) {
        this.activePageLoadMetric = metric;
    }
    setDebug(debug) {
        this.config.debug = debug;
    }
    isDebugMode() {
        return this.config.debug;
    }
    isInitialLoad() {
        return this.isInitial;
    }
    clear() {
        this.activePageLoadMetric && this.activePageLoadMetric.cancel();
        super.clear();
    }
    include(metric) {
        if (!this.config.include) this.config.include = [
            metric
        ];
        else this.config.include.push(metric);
    }
    experimental__addExplicitTiming(name, timing) {
        if (this.explicitTimings === null) this.explicitTimings = {};
        this.explicitTimings[name] = timing;
    }
    constructor(...args){
        super(...args);
        this.activePageLoadMetric = null;
    }
}
const $4cc9a206b8a92019$export$24b7a1a311eb05dc = new $4cc9a206b8a92019$export$9609608c00ea5077({
    type: (0, $b5Sjr.BMEventsType).PAGE_LOAD,
    key: 'page_load_meta_metric'
});

});
parcelRegister("b5Sjr", function(module, exports) {

$parcel$export(module.exports, "BMEventsType", () => $e1818e2d34bbcded$export$9c73e297d4be9159);
$parcel$export(module.exports, "StorableBMEventsType", () => $e1818e2d34bbcded$export$9b7037ec30489597);
$parcel$export(module.exports, "BMPageLoadMetrics", () => $e1818e2d34bbcded$export$74c1fb0997d51e2a);
$parcel$export(module.exports, "BMPageSegmentLoadMetrics", () => $e1818e2d34bbcded$export$88195ac8200d03a6);
$parcel$export(module.exports, "BMInteractionMetrics", () => $e1818e2d34bbcded$export$6e28252a002afdb2);
$parcel$export(module.exports, "PageSegmentPageLoadMetricsOptions", () => $e1818e2d34bbcded$export$474154836bfd8dd9);
$parcel$export(module.exports, "PageVisibleFields", () => $e1818e2d34bbcded$export$e89802082dab5633);
$parcel$export(module.exports, "PageVisibleValueOrigin", () => $e1818e2d34bbcded$export$983b017156c2aee2);
$parcel$export(module.exports, "isDetailedPageLoadSlo", () => $e1818e2d34bbcded$export$5866f95702a15142);
$parcel$export(module.exports, "isDetailedPageSegmentLoadSlo", () => $e1818e2d34bbcded$export$f087a59bd717e49d);
$parcel$export(module.exports, "isInteractionMetricsSlo", () => $e1818e2d34bbcded$export$b10c1d9a7db7765b);
$parcel$export(module.exports, "IncludeSSRFeatureFlagsConfig", () => $e1818e2d34bbcded$export$60c0193054fc3040);

var $csrXc = parcelRequire("csrXc");
var $e1818e2d34bbcded$export$9c73e297d4be9159;
(function(BMEventsType) {
    BMEventsType["PAGE_LOAD"] = "PAGE_LOAD";
    BMEventsType["PAGE_SEGMENT_LOAD"] = "PAGE_SEGMENT_LOAD";
    BMEventsType["INLINE_RESULT"] = "INLINE_RESULT";
    BMEventsType["CUSTOM"] = "CUSTOM";
    BMEventsType["WEB_VITALS"] = "WEB_VITALS";
})($e1818e2d34bbcded$export$9c73e297d4be9159 || ($e1818e2d34bbcded$export$9c73e297d4be9159 = {}));
var $e1818e2d34bbcded$export$9b7037ec30489597;
(function(StorableBMEventsType) {
    StorableBMEventsType["PAGE_LOAD"] = "page-load";
    StorableBMEventsType["PAGE_SEGMENT_LOAD"] = "page-segment-load";
    StorableBMEventsType["INLINE_RESULT"] = "inline-result";
    StorableBMEventsType["CUSTOM"] = "custom";
    StorableBMEventsType["WEB_VITALS"] = "web-vitals";
})($e1818e2d34bbcded$export$9b7037ec30489597 || ($e1818e2d34bbcded$export$9b7037ec30489597 = {}));
var $e1818e2d34bbcded$export$74c1fb0997d51e2a;
(function(BMPageLoadMetrics) {
    BMPageLoadMetrics["fmp"] = "fmp";
    BMPageLoadMetrics["tti"] = "tti";
})($e1818e2d34bbcded$export$74c1fb0997d51e2a || ($e1818e2d34bbcded$export$74c1fb0997d51e2a = {}));
var $e1818e2d34bbcded$export$88195ac8200d03a6;
(function(BMPageSegmentLoadMetrics) {
    BMPageSegmentLoadMetrics["fmp"] = "fmp";
    BMPageSegmentLoadMetrics["tti"] = "tti";
})($e1818e2d34bbcded$export$88195ac8200d03a6 || ($e1818e2d34bbcded$export$88195ac8200d03a6 = {}));
var $e1818e2d34bbcded$export$6e28252a002afdb2;
(function(BMInteractionMetrics) {
    BMInteractionMetrics["response"] = "response";
    BMInteractionMetrics["result"] = "result";
})($e1818e2d34bbcded$export$6e28252a002afdb2 || ($e1818e2d34bbcded$export$6e28252a002afdb2 = {}));
var $e1818e2d34bbcded$export$474154836bfd8dd9;
(function(PageSegmentPageLoadMetricsOptions) {
    PageSegmentPageLoadMetricsOptions["OFF"] = "OFF";
    PageSegmentPageLoadMetricsOptions["IF_PRESENT"] = "IF_PRESENT";
    PageSegmentPageLoadMetricsOptions["WAIT_UNTIL_PRESENT"] = "WAIT_UNTIL_PRESENT";
})($e1818e2d34bbcded$export$474154836bfd8dd9 || ($e1818e2d34bbcded$export$474154836bfd8dd9 = {}));
var $e1818e2d34bbcded$export$e89802082dab5633;
(function(PageVisibleFields) {
    PageVisibleFields["pageVisibleState"] = "page-visible-state";
    PageVisibleFields["pageVisibleValue"] = "page-visible-value";
})($e1818e2d34bbcded$export$e89802082dab5633 || ($e1818e2d34bbcded$export$e89802082dab5633 = {}));
var $e1818e2d34bbcded$export$983b017156c2aee2;
(function(PageVisibleValueOrigin) {
    PageVisibleValueOrigin["documentHidden"] = "document-hidden";
    PageVisibleValueOrigin["pageVisibleState"] = "page-visible-state";
})($e1818e2d34bbcded$export$983b017156c2aee2 || ($e1818e2d34bbcded$export$983b017156c2aee2 = {}));
const $e1818e2d34bbcded$export$5866f95702a15142 = (data)=>{
    return Boolean(data.initial);
};
const $e1818e2d34bbcded$export$f087a59bd717e49d = (data)=>{
    return Boolean(data.initial);
};
const $e1818e2d34bbcded$export$153c4c72fa5eeece = (data)=>{
    const obj = data;
    return Boolean(obj.fmp !== undefined || obj.tti !== undefined);
};
const $e1818e2d34bbcded$export$b10c1d9a7db7765b = (data)=>{
    const obj = data;
    return Boolean(obj.result !== undefined || obj.response !== undefined);
};
var $e1818e2d34bbcded$export$60c0193054fc3040;
(function(IncludeSSRFeatureFlagsConfig) {
    IncludeSSRFeatureFlagsConfig["NEVER"] = "never";
    IncludeSSRFeatureFlagsConfig["WHEN_FMP"] = "when-fmp";
    IncludeSSRFeatureFlagsConfig["WHEN_AVAILABLE"] = "when-available";
})($e1818e2d34bbcded$export$60c0193054fc3040 || ($e1818e2d34bbcded$export$60c0193054fc3040 = {}));

});
parcelRegister("csrXc", function(module, exports) {

$parcel$export(module.exports, "MetricState", () => $f586aa52fa25bf82$export$1e458f18c0c7bfe3);
$parcel$export(module.exports, "PageVisibleState", () => $f586aa52fa25bf82$export$a12c67b37a306b13);
$parcel$export(module.exports, "BaseMetric", () => $f586aa52fa25bf82$export$2bce4ffdd840e878);

var $b7nlA = parcelRequire("b7nlA");

var $ayvjR = parcelRequire("ayvjR");

var $au6tI = parcelRequire("au6tI");

var $3mFxu = parcelRequire("3mFxu");
var $f586aa52fa25bf82$export$1e458f18c0c7bfe3;
(function(MetricState) {
    MetricState["NOT_STARTED"] = "not-started";
    MetricState["STARTED"] = "started";
    MetricState["FINISHED"] = "finished";
    MetricState["CANCELLED"] = "cancelled";
})($f586aa52fa25bf82$export$1e458f18c0c7bfe3 || ($f586aa52fa25bf82$export$1e458f18c0c7bfe3 = {}));
var $f586aa52fa25bf82$export$a12c67b37a306b13;
(function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["MIXED"] = "mixed";
    PageVisibleState["HIDDEN"] = "hidden";
})($f586aa52fa25bf82$export$a12c67b37a306b13 || ($f586aa52fa25bf82$export$a12c67b37a306b13 = {}));
function $f586aa52fa25bf82$var$getPageVisibleState() {
    return typeof document !== 'undefined' && document.visibilityState === 'visible' ? "visible" : "hidden";
}
class $f586aa52fa25bf82$export$2bce4ffdd840e878 {
    static{
        this.FMP = 'fmp';
    }
    constructor(config){
        this.state = "not-started";
        this.startTime = null;
        this.stopTime = null;
        this.marks = {};
        this.onStopCallbacks = [];
        this.custom = null;
        this.submetrics = [];
        this.route = null;
        this.untilOnStopCallback = null;
        this.pageVisibleState = $f586aa52fa25bf82$var$getPageVisibleState();
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = "mixed";
        };
        this.config = config;
        this.key = config.key.replace(/ /gi, '-');
        this.type = config.type;
        this.config.timings?.forEach((entry)=>{
            if ((0, $b7nlA.restrictedTimingKeys).includes(entry.key)) {
                // eslint-disable-next-line no-console
                console.warn(`Entry ${entry.key} is restricted and has been renamed to custom__${entry.key}`);
                entry.key = `custom__${entry.key}`;
            }
        });
    }
    get untilMetrics() {
        const { until: until } = this.config;
        if (!until) return [];
        else if (Array.isArray(until)) return this.getConfiguredUntilMetricArray(until);
        return this.getConfiguredUntilMetricArray([
            until
        ]);
    }
    start({ startTime: startTime = window.performance.now() } = {}) {
        this.clear();
        (0, $ayvjR.logger).logCond(!!this.config.debug, this.key, startTime);
        this.state = "started";
        this.startTime = startTime;
        this.pageVisibleState = $f586aa52fa25bf82$var$getPageVisibleState();
        (0, $au6tI.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
        this.watchUntil();
    }
    stop(stopArguments = {}) {
        const { stopTime: stopTime = window.performance.now() } = stopArguments;
        if (this.state !== "started" || this.startTime === null) {
            (0, $ayvjR.logger).log(`metric ${this.config.key} has been stopped while not being started before; current state: ${this.state}`);
            return false;
        }
        if (stopTime < this.startTime) {
            (0, $ayvjR.logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${this.startTime}; stopTime: ${stopTime}`);
            return false;
        }
        this.stopTime = stopTime;
        this.state = "finished";
        this.handleStop(stopArguments);
        (0, $au6tI.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return true;
    }
    handleStop(stopArguments) {
        const { customData: customData = null } = stopArguments;
        if (customData) this.custom = {
            ...this.custom,
            ...customData
        };
        this.config.include && this.config.include.forEach((metric)=>{
            const included = metric.getData();
            if (included.state === "finished" && included.start !== null && included.start >= (this.startTime || 0)) this.addSubMetric(metric.getData());
        });
        this.onStopCallbacks.forEach(([success])=>{
            success(stopArguments);
        });
        this.onStopCallbacks = [];
        (0, $ayvjR.logger).logCond(!!this.config.debug, this.key, this.config.debug && this.getData());
    }
    mark(mark, timestamp = window.performance.now()) {
        this.marks[mark] = timestamp;
    }
    cancel() {
        if (this.state !== "started") return;
        this.state = "cancelled";
        this.cancelUntil();
        this.onStopCallbacks.forEach(([, cancel])=>{
            cancel();
        });
        this.onStopCallbacks = [];
        (0, $au6tI.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
    }
    merge(mergeData) {
        this.state = mergeData.state;
        this.pageVisibleState = mergeData.pageVisibleState;
        this.startTime = mergeData.start;
        this.stopTime = mergeData.stop;
        this.marks = {
            ...this.marks,
            ...mergeData.marks
        };
        this.submetrics = [
            ...this.submetrics,
            ...mergeData.submetrics
        ];
        this.onStopCallbacks = [
            ...this.onStopCallbacks,
            ...mergeData.onStopCallbacks
        ];
    }
    onStop(success, cancel) {
        this.onStopCallbacks.push([
            success,
            cancel
        ]);
    }
    removeOnStopCallback(success) {
        const index = this.onStopCallbacks.findIndex(([successCallback])=>{
            return success === successCallback;
        });
        if (index > -1) this.onStopCallbacks.splice(index, 1);
    }
    getData() {
        return {
            key: this.key,
            state: this.state,
            start: this.startTime,
            stop: this.stopTime,
            //todo ranges
            // ranges: this.makeRanges()
            marks: this.marks,
            // todo make copy
            custom: this.custom,
            submetrics: this.submetrics,
            config: this.config,
            route: this.route,
            pageVisibleState: this.pageVisibleState,
            type: this.config.type
        };
    }
    getDataToMerge() {
        return {
            ...this.getData(),
            onStopCallbacks: this.onStopCallbacks
        };
    }
    addSubMetric(data) {
        this.submetrics.push(data);
    }
    /**
	 *
	 * @param metric
	 * The array of Until metrics can be of two types
	 * This function returns an UntilExperience
	 */ getConfiguredUntilMetric(metricOrConfig) {
        return metricOrConfig instanceof $f586aa52fa25bf82$export$2bce4ffdd840e878 ? (0, $3mFxu.UntilExperience).fromMetric(metricOrConfig) : (0, $3mFxu.UntilExperience).fromConfig(metricOrConfig);
    }
    getConfiguredUntilMetricArray(metricArray) {
        if (!metricArray.length) return [];
        return metricArray.map((metric)=>this.getConfiguredUntilMetric(metric));
    }
    isUntilFinished() {
        return this.untilMetrics.every((metric)=>metric.experience.getData().state === "finished");
    }
    handleAllUntilFinished() {
        // Order by ascending stop time
        const sorted = [
            ...this.untilMetrics
        ].sort((m1, m2)=>{
            return m1.getDependencyStopTime() - m2.getDependencyStopTime();
        });
        // Find the latest page segment to become fully interactive
        const latestFullyInteractiveSegment = [
            ...this.untilMetrics
        ].reduce((currentLatestSegment, metric)=>{
            const currentLatestStopTime = currentLatestSegment?.getFullyInteractiveStopTime() ?? 0;
            const metricStopTime = metric.getFullyInteractiveStopTime() ?? 0;
            return metricStopTime > currentLatestStopTime ? metric : currentLatestSegment;
        }, undefined);
        // Accumulate the custom data from each metric, later metrics take priority
        const accumulatedCustomData = {};
        sorted.forEach((metric)=>{
            Object.assign(accumulatedCustomData, metric.experience.getData().custom);
        });
        const latestSegment = sorted[sorted.length - 1];
        const latestFullyInteractiveStopTime = latestFullyInteractiveSegment?.getFullyInteractiveStopTime();
        this.stop({
            stopTime: latestSegment.getDependencyStopTime(),
            customData: {
                ...accumulatedCustomData,
                segment: latestSegment.getKey(),
                segmentOverrided: latestSegment.getIsSegmentLoadOverrided(),
                ...latestFullyInteractiveStopTime ? {
                    latestFullyInteractiveSegment: latestFullyInteractiveSegment?.getKey(),
                    latestFullyInteractiveStopTime: latestFullyInteractiveStopTime
                } : {}
            }
        });
    }
    watchUntil() {
        if (!this.untilMetrics.length) return;
        if (this.isUntilFinished()) {
            // Already finished, handle it immediately
            this.handleAllUntilFinished();
            return;
        }
        // If not currently finished, register stop callbacks to re-check
        this.untilOnStopCallback = ()=>{
            if (this.isUntilFinished()) this.handleAllUntilFinished();
        };
        this.untilMetrics.forEach((metric)=>{
            if (metric.experience.getData().state !== "finished") metric.experience.onStop(this.untilOnStopCallback, ()=>this.cancel());
        });
    }
    cancelUntil() {
        this.untilMetrics.forEach((metric)=>{
            if (metric.experience.getData().state !== "cancelled" && this.untilOnStopCallback) metric.experience.removeOnStopCallback(this.untilOnStopCallback);
        });
    }
    clear() {
        // todo before clearing - handle cancelling existing onStop / unsubscribe submetrics
        this.cancelUntil();
        this.state = "not-started";
        this.startTime = null;
        this.stopTime = null;
        this.marks = {};
        this.custom = null;
        this.submetrics = [];
        this.route = null;
        this.pageVisibleState = $f586aa52fa25bf82$var$getPageVisibleState();
    }
}

});
parcelRegister("b7nlA", function(module, exports) {

$parcel$export(module.exports, "restrictedTimingKeys", () => $40a962fee982978b$export$1d17377365286b00);
$parcel$export(module.exports, "clsWaitTimeMs", () => $40a962fee982978b$export$df21d285cfcda81e);
const $40a962fee982978b$export$1d17377365286b00 = [
    'ssr'
];
const $40a962fee982978b$export$df21d285cfcda81e = 7500;

});

parcelRegister("au6tI", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $b28b443bca73f9fb$export$13e680397ec8f3eb);
class $b28b443bca73f9fb$var$VisibilityChangeObserver {
    start() {
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $b28b443bca73f9fb$export$13e680397ec8f3eb = new $b28b443bca73f9fb$var$VisibilityChangeObserver();

});

parcelRegister("3mFxu", function(module, exports) {

$parcel$export(module.exports, "UntilExperience", () => $69f3034ee586576d$export$3fcc0936ee2cc852);
class $69f3034ee586576d$export$3fcc0936ee2cc852 {
    static{
        this.FMP = 'fmp';
    }
    static fromConfig(config) {
        return new $69f3034ee586576d$export$3fcc0936ee2cc852(config.experience, config.useFmpAsUntilStopTime);
    }
    static fromMetric(metric) {
        return new $69f3034ee586576d$export$3fcc0936ee2cc852(metric);
    }
    constructor(experience, useFmpAsUntilStopTime){
        this.experience = experience;
        this.useFmpAsUntilStopTime = useFmpAsUntilStopTime;
    }
    /**
	 * If FMP mark is present, return that
	 * otherwise return the eventual load
	 */ getFmp() {
        const { marks: marks, stop: stop } = this.experience.getData();
        return marks[$69f3034ee586576d$export$3fcc0936ee2cc852.FMP] ?? stop;
    }
    getDependencyStopTime() {
        if (this.useFmpAsUntilStopTime) return this.getFmp();
        return this.experience.getData().stop;
    }
    /**
	 * Get the time it takes for a segment to become fully interactable,
	 * regardless of whether it uses the FMP as the stop time. (Eventual load)
	 */ getFullyInteractiveStopTime() {
        return this.experience.getData().stop;
    }
    getIsSegmentLoadOverrided() {
        if (this.useFmpAsUntilStopTime) {
            const { marks: marks } = this.experience.getData();
            return marks[$69f3034ee586576d$export$3fcc0936ee2cc852.FMP] ? true : false;
        }
        return false;
    }
    getKey() {
        return this.experience.getData().key;
    }
}

});



parcelRegister("hW7BM", function(module, exports) {

$parcel$export(module.exports, "BasePageLoadMetric", () => $c251f9023b3f555e$export$fd1447b187f590fe);

var $ayvjR = parcelRequire("ayvjR");

var $csrXc = parcelRequire("csrXc");
class $c251f9023b3f555e$export$fd1447b187f590fe extends (0, $csrXc.BaseMetric) {
    static{
        this.FMP = 'fmp';
    }
    constructor(args){
        super(args);
        this.isInitial = true;
        this.explicitTimings = null;
        this.config = args;
    }
    start({} = {}) {
        // please use startPageLoad
        return;
    }
    startPageLoad(params = {
        isInitial: false
    }) {
        // todo this should update meta page load metric
        this.isInitial = params.isInitial;
        if (params.isInitial) super.start({
            startTime: 0
        });
        else super.start(params);
        (0, $ayvjR.logger).logCond(!!this.config.debug, this.key, this.startTime);
    }
    stopPageLoad(pageLoadMetaMetricData, stopArguments = {
        stopTime: window.performance.now()
    }) {
        if (pageLoadMetaMetricData.state !== (0, $csrXc.MetricState).STARTED || pageLoadMetaMetricData.start === null || stopArguments.stopTime === undefined) {
            (0, $ayvjR.logger).log(`meta metric has been stopped while not being started before; current state: ${this.state}`);
            return false;
        }
        if (stopArguments.stopTime < pageLoadMetaMetricData.start) {
            (0, $ayvjR.logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${pageLoadMetaMetricData.start}; stopTime: ${stopArguments.stopTime}`);
            return false;
        }
        this.merge(pageLoadMetaMetricData);
        this.stopTime = stopArguments.stopTime;
        this.state = (0, $csrXc.MetricState).FINISHED;
        this.handleStop(stopArguments);
        return true;
    }
    handleStop(stopArguments) {
        const { until: until } = this.config;
        const fmpWasMarked = $c251f9023b3f555e$export$fd1447b187f590fe.FMP in this.marks;
        if (!fmpWasMarked && until) {
            // Extract the maximum FMP value from the until metrics
            const untilArr = Array.isArray(until) ? this.getConfiguredUntilMetricArray(until) : this.getConfiguredUntilMetricArray([
                until
            ]);
            const untilFmpMarks = untilArr.map((metric)=>metric.getFmp());
            if (untilFmpMarks.every(Number.isFinite)) this.markFMP(Math.max(...untilFmpMarks));
        }
        super.handleStop(stopArguments);
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $c251f9023b3f555e$export$fd1447b187f590fe.FMP) return;
        super.mark(mark, timestamp);
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
        this.explicitTimings = this.explicitTimings || mergeData.explicitTimings ? {
            ...mergeData.explicitTimings,
            ...this.explicitTimings
        } : null;
    }
    markFMP(timestamp) {
        super.mark($c251f9023b3f555e$export$fd1447b187f590fe.FMP, timestamp);
    }
    getPageLoadData() {
        return {
            isInitial: this.isInitial,
            explicitTimings: this.explicitTimings
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageLoadData()
        };
    }
    clear() {
        this.explicitTimings = null;
        super.clear();
    }
}

});


parcelRegister("67ejG", function(module, exports) {

$parcel$export(module.exports, "webVitalsObserver", () => $a7a56a32db542645$export$253d38dccbb37615);


class $a7a56a32db542645$var$WebVitalsObserver {
    start() {
        this.ttciDetermined = this.registerTTCI();
        this.webVitalsDetermined = this.registerWebVitals();
    }
    async registerWebVitals() {
        try {
            const { getCLS: getCLS, getFCP: getFCP, getFID: getFID, getLCP: getLCP, getTTFB: getTTFB } = await (parcelRequire("2k4zQ"));
            await Promise.all([
                getTTFB,
                getFID,
                getFCP,
                getLCP,
                getCLS
            ].map((fx)=>new Promise((resolve)=>{
                    fx(({ name: name, value: value })=>{
                        // round FCP, FID, LCP, TTFB to nearest integer.
                        // CLS is rounded to two decimal places.
                        const metricName = name.toLowerCase();
                        const metricValue = metricName === 'cls' ? parseFloat(value.toFixed(2)) : Math.round(value);
                        this.data[`metric:${metricName}`] = metricValue;
                        resolve();
                    });
                })));
        } catch (e) {}
    }
    async registerTTCI() {
        try {
            const ttiPolyfill = await (parcelRequire("1ZPZR"));
            await ttiPolyfill.getFirstConsistentlyInteractive().then((value)=>{
                // according to the docs:
                // If no TTI value can be found, or if the browser doesn't support all the APIs required to detect TTI,
                // the promise resolves to null.
                this.data['metric:ttci'] = typeof value === 'number' ? Math.round(value) : value;
                return true;
            });
        } catch (e) {}
    }
    constructor(){
        this.data = {
            'metric:ttci': null,
            'metric:ttfb': null,
            'metric:fid': null,
            'metric:fcp': null,
            'metric:lcp': null,
            'metric:cls': null
        };
    }
}
const $a7a56a32db542645$export$253d38dccbb37615 = new $a7a56a32db542645$var$WebVitalsObserver();

});
parcelRegister("2k4zQ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jX4xj');
        const value = parcelRequire('66CK0');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jX4xj").then(()=>parcelRequire('66CK0'));
}

});
parcelRegister("chRvw", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    const retry_state = {};
    module.exports = async function(id) {
        if (!globalThis.navigator.onLine) await new Promise((res)=>{
            const callback = ()=>(globalThis.removeEventListener('online', callback), res());
            globalThis.addEventListener('online', callback);
        });
        let bundle_src = (parcelRequire("bjqNS")).resolve(id);
        let src = bundle_src;
        retry_state[bundle_src] = retry_state[bundle_src] || {
            should_retry: false,
            param: undefined
        };
        if (retry_state[bundle_src].should_retry) retry_state[bundle_src].param = Date.now();
        if (retry_state[bundle_src].param) src = src + "?retry=" + retry_state[bundle_src].param;
        try {
            retry_state[bundle_src].should_retry = false;
            return await import(src);
        } catch (error) {
            retry_state[bundle_src].should_retry = true;
            throw error;
        }
    };
} else {
    "use strict";
    function load(id) {
        // eslint-disable-next-line no-undef
        return import((parcelRequire("bjqNS")).resolve(id));
    }
    module.exports = load;
}

});
parcelRegister("bjqNS", function(module, exports) {

$parcel$export(module.exports, "register", () => $83c642ad29ddccba$export$6503ec6e8aabbaf, (v) => $83c642ad29ddccba$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $83c642ad29ddccba$export$f7ad0328861e2f03, (v) => $83c642ad29ddccba$export$f7ad0328861e2f03 = v);
var $83c642ad29ddccba$export$6503ec6e8aabbaf;
var $83c642ad29ddccba$export$f7ad0328861e2f03;
"use strict";
var $83c642ad29ddccba$var$mapping = new Map();
function $83c642ad29ddccba$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$83c642ad29ddccba$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $83c642ad29ddccba$var$resolve(id) {
    var resolved = $83c642ad29ddccba$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$83c642ad29ddccba$export$6503ec6e8aabbaf = $83c642ad29ddccba$var$register;
$83c642ad29ddccba$export$f7ad0328861e2f03 = $83c642ad29ddccba$var$resolve;

});



parcelRegister("1ZPZR", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('7YsqQ');
        const value = parcelRequire('691IB');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("7YsqQ").then(()=>parcelRequire('691IB'));
}

});


parcelRegister("eBTRG", function(module, exports) {

$parcel$export(module.exports, "Route", () => $331aa9745c8e8d6e$export$e7b0ac011bb776c6);
const $331aa9745c8e8d6e$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute (newRoute) {
        this.route = newRoute;
    },
    getRoute () {
        return this.route;
    }
};

});

parcelRegister("cQ9wm", function(module, exports) {

$parcel$export(module.exports, "submitter", () => $a36ad2097159a14f$export$c21a25872e3f5a2b);

var $fVaJL = parcelRequire("fVaJL");

var $b5Sjr = parcelRequire("b5Sjr");

var $fOcYr = parcelRequire("fOcYr");

var $2lyt0 = parcelRequire("2lyt0");
const $a36ad2097159a14f$export$c21a25872e3f5a2b = {
    debug: false,
    config: {
        gasv3: undefined,
        configChunk: null,
        useVisibleState: false,
        histogram: {},
        enableReactUFOTracker: false
    },
    configure (config) {
        this.config.gasv3 = config.endpoints.eventPipelineClient;
        this.config.enableReactUFOTracker = config.enableReactUFOTracker;
        this.config.configChunk = (0, $2lyt0.makeShareableGlobalConfig)(config);
        if (config.events.all && config.events.all.sfxEvents) this.config.useVisibleState = config.events.all.sfxEvents.activeTab === (0, $b5Sjr.PageVisibleFields).pageVisibleState;
    },
    setDebug (debug) {
        this.debug = debug;
    },
    async queue (data) {
        if (this.config.enableReactUFOTracker) (0, $fVaJL.addBrowserMetricEvent)(data);
        if (!this.config.configChunk) {
            // eslint-disable-next-line no-console
            this.debug && console.warn('Submitter is not configured');
            return null;
        }
        const chunk = await this.config.configChunk;
        const payload = await (0, $fOcYr.eventDataProcessor)(chunk[data.config.type], data);
        if (payload === null) return;
        if (this.config.gasv3 !== undefined) {
            const client = await this.config.gasv3;
            const attributes = {
                task: payload['event:key'],
                properties: payload
            };
            client && client.sendOperationalEvent({
                actionSubject: 'performance',
                attributes: attributes,
                source: 'performance',
                action: 'measured'
            });
        }
    }
};

});
parcelRegister("fVaJL", function(module, exports) {

$parcel$export(module.exports, "getActiveInteraction", () => $d466734eefe9df8e$export$2b3954d2e8509985);
$parcel$export(module.exports, "updatePageLoadInteractionName", () => $d466734eefe9df8e$export$f6f1cf5bedf83c71);
$parcel$export(module.exports, "addMetadata", () => $d466734eefe9df8e$export$12f2b6cb85d59904);
$parcel$export(module.exports, "addCustomData", () => $d466734eefe9df8e$export$e4380431c2bdabee);
$parcel$export(module.exports, "addCustomTiming", () => $d466734eefe9df8e$export$27cacb7d7f3fe20a);
$parcel$export(module.exports, "addMark", () => $d466734eefe9df8e$export$728e28c22a0fba4);
$parcel$export(module.exports, "addSpan", () => $d466734eefe9df8e$export$2c1d6e17cfa9bbc7);
$parcel$export(module.exports, "addSpanToAll", () => $d466734eefe9df8e$export$943a8b2b5d6b1809);
$parcel$export(module.exports, "extractModuleName", () => $d466734eefe9df8e$export$f5a8f10de74904da);
$parcel$export(module.exports, "addHold", () => $d466734eefe9df8e$export$7606887303596f82);
$parcel$export(module.exports, "addHoldByID", () => $d466734eefe9df8e$export$10582acd678c213);
$parcel$export(module.exports, "removeHoldByID", () => $d466734eefe9df8e$export$4983dfbbb996f7ae);
$parcel$export(module.exports, "getCurrentInteractionType", () => $d466734eefe9df8e$export$2df109852219d16e);
$parcel$export(module.exports, "ModuleLoadingProfiler", () => $d466734eefe9df8e$export$9591b52b33ccc510);
$parcel$export(module.exports, "addError", () => $d466734eefe9df8e$export$239c33984d9b1367);
$parcel$export(module.exports, "addErrorToAll", () => $d466734eefe9df8e$export$7379c15afd3840fa);
$parcel$export(module.exports, "addProfilerTimings", () => $d466734eefe9df8e$export$53d6f611de951a13);
$parcel$export(module.exports, "sinkInteractionHandler", () => $d466734eefe9df8e$export$9e614a29a1ac213e);
$parcel$export(module.exports, "tryComplete", () => $d466734eefe9df8e$export$673be905888f8839);
$parcel$export(module.exports, "abort", () => $d466734eefe9df8e$export$5def58af4fd46132);
$parcel$export(module.exports, "abortByNewInteraction", () => $d466734eefe9df8e$export$c4a545284f55edf2);
$parcel$export(module.exports, "abortAll", () => $d466734eefe9df8e$export$614a7af2affc5dff);
$parcel$export(module.exports, "addOnCancelCallback", () => $d466734eefe9df8e$export$7b9261a96cfe427b);
$parcel$export(module.exports, "addNewInteraction", () => $d466734eefe9df8e$export$1a1ed1e1fdb2006b);
$parcel$export(module.exports, "addBrowserMetricEvent", () => $d466734eefe9df8e$export$4a759336b50e86e3);
$parcel$export(module.exports, "addApdexToAll", () => $d466734eefe9df8e$export$ad216cc25852d44b);
$parcel$export(module.exports, "addApdex", () => $d466734eefe9df8e$export$35220fd6cdd1b731);
$parcel$export(module.exports, "addRequestInfo", () => $d466734eefe9df8e$export$57d55b4569823d8f);
$parcel$export(module.exports, "addSegment", () => $d466734eefe9df8e$export$1c43f9ac826b6462);
$parcel$export(module.exports, "removeSegment", () => $d466734eefe9df8e$export$d0365e48b58231c3);
$parcel$export(module.exports, "addRedirect", () => $d466734eefe9df8e$export$bbf14d79614d9818);

var $hompL = parcelRequire("hompL");

var $dZdw5 = parcelRequire("dZdw5");

var $4vWWq = parcelRequire("4vWWq");

var $cd3ip = parcelRequire("cd3ip");

var $1qnta = parcelRequire("1qnta");

var $3WQZN = parcelRequire("3WQZN");

var $gnIbC = parcelRequire("gnIbC");

var $5TiXm = parcelRequire("5TiXm");

var $hV9Mh = parcelRequire("hV9Mh");
const $d466734eefe9df8e$var$PreviousInteractionLog = {
    name: undefined,
    isAborted: undefined
};
const $d466734eefe9df8e$var$interactionQueue = [];
const $d466734eefe9df8e$var$segmentCache = new Map();
const $d466734eefe9df8e$var$CLEANUP_TIMEOUT = 60000;
const $d466734eefe9df8e$var$CLEANUP_TIMEOUT_AFTER_APDEX = 15000;
const $d466734eefe9df8e$var$segmentObservers = [];
function $d466734eefe9df8e$export$2b3954d2e8509985() {
    const interactionId = (0, $gnIbC.getInteractionId)();
    if (!interactionId.current) return;
    return (0, $hV9Mh.default).get(interactionId.current);
}
function $d466734eefe9df8e$var$labelStackToString(labelStack, name) {
    const stack = [
        ...labelStack ?? []
    ];
    if (name) stack.push({
        name: name
    });
    return stack.map((l)=>l.name)?.join('/');
}
function $d466734eefe9df8e$var$labelStackToIdString(labelStack) {
    return labelStack?.map((l)=>'segmentId' in l ? `${l.name}:${l.segmentId}` : `${l.name}`)?.join('/');
}
function $d466734eefe9df8e$var$addSegmentObserver(observer) {
    $d466734eefe9df8e$var$segmentObservers.push(observer);
    for (const segmentInfo of $d466734eefe9df8e$var$segmentCache.values())observer.onAdd(segmentInfo);
}
function $d466734eefe9df8e$var$removeSegmentObserver(observer) {
    const index = $d466734eefe9df8e$var$segmentObservers.findIndex((obs)=>obs === observer);
    if (index !== -1) $d466734eefe9df8e$var$segmentObservers.splice(index, 1);
}
function $d466734eefe9df8e$export$cd7f480d6b8286c3(interactionId) {
    (0, $hV9Mh.default).delete(interactionId);
}
function $d466734eefe9df8e$export$f6f1cf5bedf83c71(ufoName, routeName = ufoName) {
    const interaction = $d466734eefe9df8e$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function $d466734eefe9df8e$export$12f2b6cb85d59904(interactionId, data) {
    const interaction = (0, $hV9Mh.default).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((key)=>{
        interaction.metaData[key] = data[key];
    });
}
function $d466734eefe9df8e$export$e4380431c2bdabee(interactionId, labelStack, data) {
    const interaction = (0, $hV9Mh.default).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((i)=>{
        interaction.customData.push({
            labelStack: labelStack,
            data: {
                [i]: data[i]
            }
        });
    });
}
function $d466734eefe9df8e$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    const interaction = (0, $hV9Mh.default).get(interactionId);
    if (interaction != null) {
        interaction.customTimings.push({
            labelStack: labelStack,
            data: data
        });
        var e;
    }
}
function $d466734eefe9df8e$export$728e28c22a0fba4(interactionId, type, name, labelStack, time = performance.now()) {
    const interaction = (0, $hV9Mh.default).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
}
function $d466734eefe9df8e$export$c4b23cc624bd2fb(type, name, labelStack, time = performance.now()) {
    (0, $hV9Mh.default).forEach((interaction)=>{
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
}
function $d466734eefe9df8e$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start, end = performance.now(), size) {
    const interaction = (0, $hV9Mh.default).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        var e;
    }
}
function $d466734eefe9df8e$export$943a8b2b5d6b1809(type, name, labelStack, start, end = performance.now(), size = 0) {
    (0, $hV9Mh.default).forEach((interaction)=>{
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    var e;
}
function $d466734eefe9df8e$export$9e04fe1a58571ec(moduleId, timestamp) {
    $d466734eefe9df8e$export$c4b23cc624bd2fb('bundle_preload', moduleId, null, timestamp);
}
function $d466734eefe9df8e$export$6f228d1fdc911d7(identifier, start, end) {
    $d466734eefe9df8e$export$943a8b2b5d6b1809('bundle_load', identifier, null, start, end - start);
}
const $d466734eefe9df8e$var$moduleLoadingRequests = {};
function $d466734eefe9df8e$export$f5a8f10de74904da(input) {
    let result = input ?? '';
    result = result.replace(/^\.\/src\/packages\//, '');
    result = result.replace(/^\.\/node_modules\//, '');
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
    return result;
}
function $d466734eefe9df8e$export$7606887303596f82(interactionId, labelStack, name) {
    const interaction = (0, $hV9Mh.default).get(interactionId);
    const id = (0, $hompL.v4)();
    if (interaction != null) {
        const start = performance.now();
        interaction.holdActive.set(id, {
            labelStack: labelStack,
            name: name,
            start: start
        });
        return ()=>{
            const end = performance.now();
            var e;
            const currentInteraction = (0, $hV9Mh.default).get(interactionId);
            const currentHold = interaction.holdActive.get(id);
            if (currentInteraction != null && currentHold != null) {
                currentInteraction.holdInfo.push({
                    ...currentHold,
                    end: end
                });
                interaction.holdActive.delete(id);
            }
        };
    }
    return ()=>{};
}
function $d466734eefe9df8e$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    const interaction = (0, $hV9Mh.default).get(interactionId);
    if (interaction != null) {
        const start = performance.now();
        interaction.holdActive.set(id, {
            labelStack: labelStack,
            name: name,
            start: start,
            ignoreOnSubmit: ignoreOnSubmit
        });
    }
    return ()=>{};
}
function $d466734eefe9df8e$export$4983dfbbb996f7ae(interactionId, id) {
    const interaction = (0, $hV9Mh.default).get(interactionId);
    if (interaction != null) {
        const end = performance.now();
        const currentInteraction = (0, $hV9Mh.default).get(interactionId);
        const currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            currentInteraction.holdInfo.push({
                ...currentHold,
                end: end
            });
            interaction.holdActive.delete(id);
        }
    }
}
function $d466734eefe9df8e$export$2df109852219d16e(interactionId) {
    const interaction = (0, $hV9Mh.default).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
const $d466734eefe9df8e$export$9591b52b33ccc510 = {
    onPreload (moduleId, _priority) {
        $d466734eefe9df8e$export$9e04fe1a58571ec($d466734eefe9df8e$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart (info) {
        const timeoutId = setTimeout(()=>{
            delete $d466734eefe9df8e$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        const request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $d466734eefe9df8e$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete (info) {
        const request = $d466734eefe9df8e$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $d466734eefe9df8e$var$moduleLoadingRequests[info.identifier];
            $d466734eefe9df8e$export$6f228d1fdc911d7($d466734eefe9df8e$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted (id, moduleId) {
        const interactionId = (0, $gnIbC.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $d466734eefe9df8e$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted (id) {
        const interactionId = (0, $gnIbC.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $d466734eefe9df8e$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $d466734eefe9df8e$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError) {
    const interaction = (0, $hV9Mh.default).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError
    });
}
function $d466734eefe9df8e$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack) {
    (0, $hV9Mh.default).forEach((interaction)=>{
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack
        });
    });
}
const $d466734eefe9df8e$export$53d6f611de951a13 = (interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime)=>{
    const interaction = (0, $hV9Mh.default).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
};
const $d466734eefe9df8e$var$pushToQueue = (id, data)=>{
    $d466734eefe9df8e$var$interactionQueue.push({
        id: id,
        data: data
    });
};
let $d466734eefe9df8e$var$handleInteraction = $d466734eefe9df8e$var$pushToQueue;
function $d466734eefe9df8e$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach((cleanUpCallback)=>{
        cleanUpCallback();
    });
}
const $d466734eefe9df8e$var$finishInteraction = (id, data, endTime = performance.now())=>{
    // eslint-disable-next-line no-param-reassign
    data.end = endTime;
    try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${data.ufoName} [ttai]`, {
            start: data.start,
            end: data.end
        });
    } catch (e) {
    // do nothing
    }
    if (data.featureFlags) // eslint-disable-next-line no-param-reassign
    data.featureFlags.during = Object.fromEntries((0, $3WQZN.currentFeatureFlagsAccessed));
    (0, $1qnta.clearActiveTrace)();
    $d466734eefe9df8e$var$callCleanUpCallbacks(data);
    $d466734eefe9df8e$export$cd7f480d6b8286c3(id);
    $d466734eefe9df8e$var$PreviousInteractionLog.name = data.ufoName || 'unknown';
    $d466734eefe9df8e$var$PreviousInteractionLog.isAborted = data.abortReason != null;
    if (data.ufoName) $d466734eefe9df8e$var$handleInteraction(id, data);
    var profilerTiming, e;
};
const $d466734eefe9df8e$export$9e614a29a1ac213e = (sinkFn)=>{
    if ($d466734eefe9df8e$var$handleInteraction === $d466734eefe9df8e$var$pushToQueue) {
        $d466734eefe9df8e$var$handleInteraction = sinkFn;
        $d466734eefe9df8e$var$interactionQueue.forEach((interaction)=>{
            sinkFn(interaction.id, interaction.data);
        });
        $d466734eefe9df8e$var$interactionQueue.length = 0;
    }
};
function $d466734eefe9df8e$export$673be905888f8839(interactionId, endTime) {
    const interaction = (0, $hV9Mh.default).get(interactionId);
    if (interaction != null) {
        const noMoreHolds = interaction.holdActive.size === 0;
        if (noMoreHolds) $d466734eefe9df8e$var$finishInteraction(interactionId, interaction, endTime);
    }
}
function $d466734eefe9df8e$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach((cancelCallback)=>{
        cancelCallback();
    });
}
function $d466734eefe9df8e$export$5def58af4fd46132(interactionId, abortReason) {
    const interaction = (0, $hV9Mh.default).get(interactionId);
    if (interaction != null) {
        $d466734eefe9df8e$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $d466734eefe9df8e$var$finishInteraction(interactionId, interaction);
    }
}
function $d466734eefe9df8e$export$c4a545284f55edf2(interactionId, interactionName) {
    (0, $cd3ip.cancelTTVC)();
    const interaction = (0, $hV9Mh.default).get(interactionId);
    if (interaction != null) {
        $d466734eefe9df8e$var$callCancelCallbacks(interaction);
        interaction.abortReason = 'new_interaction';
        interaction.abortedByInteractionName = interactionName;
        $d466734eefe9df8e$var$finishInteraction(interactionId, interaction);
    }
}
function $d466734eefe9df8e$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    (0, $cd3ip.cancelTTVC)();
    (0, $hV9Mh.default).forEach((interaction, interactionId)=>{
        const noMoreHolds = interaction.holdActive.size === 0;
        if (!noMoreHolds) {
            $d466734eefe9df8e$var$callCancelCallbacks(interaction);
            // eslint-disable-next-line no-param-reassign
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) // eslint-disable-next-line no-param-reassign
            interaction.abortedByInteractionName = abortedByInteractionName;
        }
        $d466734eefe9df8e$var$finishInteraction(interactionId, interaction);
    });
}
function $d466734eefe9df8e$export$7b9261a96cfe427b(id, cancelCallback) {
    const interaction = (0, $hV9Mh.default).get(id);
    interaction?.cancelCallbacks.push(cancelCallback);
}
function $d466734eefe9df8e$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName, trace = null) {
    let previousTime = startTime;
    let timeoutTime = $d466734eefe9df8e$var$CLEANUP_TIMEOUT;
    const timerID = setTimeout(()=>{
        $d466734eefe9df8e$export$5def58af4fd46132(interactionId, 'timeout');
    }, $d466734eefe9df8e$var$CLEANUP_TIMEOUT);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        const currentTime = performance.now();
        const timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        const newTimerID = setTimeout(()=>{
            $d466734eefe9df8e$export$5def58af4fd46132(interactionId, 'timeout');
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    const addFeatureFlagsToInteraction = (0, $dZdw5.default)((0, $4vWWq.getCapabilityRate)('feature_flag_access'));
    const metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        type: type,
        previousInteractionName: $d466734eefe9df8e$var$PreviousInteractionLog.name,
        isPreviousInteractionAborted: $d466734eefe9df8e$var$PreviousInteractionLog.isAborted === true,
        marks: [],
        customData: [],
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdActive: new Map(),
        // measure when we execute this code
        // from this we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName ?? ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: Object.fromEntries((0, $3WQZN.allFeatureFlagsAccessed)),
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace
    };
    if (addFeatureFlagsToInteraction) (0, $3WQZN.currentFeatureFlagsAccessed).clear();
    (0, $hV9Mh.default).set(interactionId, metrics);
    const segmentObserver = {
        onAdd (segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove () {}
    };
    $d466734eefe9df8e$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(()=>{
        $d466734eefe9df8e$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(()=>{
        clearTimeout(metrics.timerID);
    });
    const awaitBM3TTIList = (0, $4vWWq.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $d466734eefe9df8e$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === 'transition') (0, $5TiXm.getVCObserver)().start({
        startTime: startTime
    });
}
function $d466734eefe9df8e$export$4a759336b50e86e3(event) {
    const interaction = $d466734eefe9df8e$export$2b3954d2e8509985();
    if (interaction) {
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === 'page_load' || interaction.type === 'transition') && event.config?.type === 'PAGE_LOAD') {
            interaction.changeTimeout($d466734eefe9df8e$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $d466734eefe9df8e$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
        }
    }
}
function $d466734eefe9df8e$export$ad216cc25852d44b(apdex) {
    (0, $hV9Mh.default).forEach((interaction, key)=>{
        interaction.apdex.push(apdex);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdex.key} [bm3_tti]`, {
                start: apdex.startTime ?? interaction.start,
                end: apdex.stopTime
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') {
            interaction.changeTimeout($d466734eefe9df8e$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $d466734eefe9df8e$export$4983dfbbb996f7ae(key, interaction.ufoName);
        }
    });
}
function $d466734eefe9df8e$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    const interaction = (0, $hV9Mh.default).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdexInfo.key} [bm3_tti]`, {
                start: apdexInfo.startTime ?? interaction.start,
                end: apdexInfo.stopTime
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') {
            interaction.changeTimeout($d466734eefe9df8e$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $d466734eefe9df8e$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
        }
    }
}
function $d466734eefe9df8e$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    const interaction = (0, $hV9Mh.default).get(interactionId);
    if (interaction != null) interaction.requestInfo.push({
        labelStack: labelStack,
        ...requestInfo
    });
}
function $d466734eefe9df8e$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $d466734eefe9df8e$var$getSegmentCacheKey(labelStack) {
    return labelStack.map((l)=>{
        if ($d466734eefe9df8e$var$isSegmentLabel(l)) return `${l.name}_${l.segmentId}`;
        return l.name;
    }).join('|');
}
function $d466734eefe9df8e$export$1c43f9ac826b6462(labelStack) {
    const key = $d466734eefe9df8e$var$getSegmentCacheKey(labelStack);
    const existingSegment = $d466734eefe9df8e$var$segmentCache.get(key);
    if (!existingSegment) {
        const segmentInfo = {
            labelStack: labelStack
        };
        $d466734eefe9df8e$var$segmentCache.set(key, segmentInfo);
        $d466734eefe9df8e$var$segmentObservers.forEach((observer)=>{
            observer.onAdd(segmentInfo);
        });
    }
}
function $d466734eefe9df8e$export$d0365e48b58231c3(labelStack) {
    const key = $d466734eefe9df8e$var$getSegmentCacheKey(labelStack);
    const segmentInfo = $d466734eefe9df8e$var$segmentCache.get(key);
    if (segmentInfo) {
        $d466734eefe9df8e$var$segmentCache.delete(JSON.stringify(labelStack));
        $d466734eefe9df8e$var$segmentObservers.forEach((observer)=>{
            observer.onRemove(segmentInfo);
        });
    }
}
function $d466734eefe9df8e$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    const interaction = (0, $hV9Mh.default).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        var e;
    }
}

});
parcelRegister("dZdw5", function(module, exports) {

$parcel$export(module.exports, "default", () => $9851cf8ef7bfa69a$export$2e2bcd8739ae039);
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ function $9851cf8ef7bfa69a$export$2e2bcd8739ae039(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}

});

parcelRegister("4vWWq", function(module, exports) {

$parcel$export(module.exports, "setUFOConfig", () => $e07a03c9c51ce18f$export$10d6139a8fb42158);
$parcel$export(module.exports, "getConfig", () => $e07a03c9c51ce18f$export$44487a86467333c3);
$parcel$export(module.exports, "getInteractionRate", () => $e07a03c9c51ce18f$export$9466a8f085fa7d4e);
$parcel$export(module.exports, "getCapabilityRate", () => $e07a03c9c51ce18f$export$29b9ffb14861a1d);
$parcel$export(module.exports, "getTypingPerformanceTracingMethod", () => $e07a03c9c51ce18f$export$7e32aae12bf9b50f);
$parcel$export(module.exports, "getAwaitBM3TTIList", () => $e07a03c9c51ce18f$export$2d311b3fd18dcab1);
$parcel$export(module.exports, "getUfoNameOverrides", () => $e07a03c9c51ce18f$export$4f4649ef27b6f5d6);
$parcel$export(module.exports, "getDoNotAbortActivePressInteraction", () => $e07a03c9c51ce18f$export$3c170167645a0eff);
$parcel$export(module.exports, "getDoNotAbortActivePressInteractionOnTransition", () => $e07a03c9c51ce18f$export$d6dc9444bd15f70f);
let $e07a03c9c51ce18f$var$config;
function $e07a03c9c51ce18f$export$10d6139a8fb42158(newConfig) {
    $e07a03c9c51ce18f$var$config = newConfig;
}
function $e07a03c9c51ce18f$export$44487a86467333c3() {
    return $e07a03c9c51ce18f$var$config;
}
function $e07a03c9c51ce18f$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$e07a03c9c51ce18f$var$config) return 0;
        const { killswitch: killswitch, rates: rates, rules: rules, kind: kind, autoGeneratedRate: autoGeneratedRate } = $e07a03c9c51ce18f$var$config;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(let i = 0; i < rules.length; i++){
            const rule = rules[i];
            const { test: test, rate: rate } = rule;
            if (test != null && rate != null) {
                const regexp = new RegExp(test, 'ig');
                if (regexp.test(name)) return rate;
            }
        }
        const isAutogenerated = name?.startsWith('auto-generated');
        if (isAutogenerated) {
            const rate = autoGeneratedRate;
            if (rate != null) return rate;
        }
        if (kind != null) {
            const rate = kind[interactionKind];
            if (rate != null) return rate;
        }
        return 0;
    } catch (e) {
        // Fallback
        return 0;
    }
}
function $e07a03c9c51ce18f$export$29b9ffb14861a1d(capability) {
    try {
        if (!$e07a03c9c51ce18f$var$config) return 0;
        const { capability: capabilityRate } = $e07a03c9c51ce18f$var$config;
        if (capabilityRate != null) {
            const rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        return 0;
    }
}
const $e07a03c9c51ce18f$var$validTypingMethods = [
    'timeout',
    'timeoutNoAlloc',
    'mutationObserver'
];
function $e07a03c9c51ce18f$export$7e32aae12bf9b50f() {
    const defaultMethod = 'timeout';
    try {
        if (!$e07a03c9c51ce18f$var$config) return defaultMethod;
        const { typingMethod: typingMethod } = $e07a03c9c51ce18f$var$config;
        if (typingMethod != null && $e07a03c9c51ce18f$var$validTypingMethods.find((m)=>m === typingMethod)) return typingMethod;
        else return defaultMethod;
    } catch (e) {
        return defaultMethod;
    }
}
function $e07a03c9c51ce18f$export$2d311b3fd18dcab1() {
    try {
        if (!$e07a03c9c51ce18f$var$config) return [];
        const { awaitBM3TTI: awaitBM3TTI } = $e07a03c9c51ce18f$var$config;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch (e) {
        return [];
    }
}
function $e07a03c9c51ce18f$export$e2ea675800536898() {
    try {
        if (!$e07a03c9c51ce18f$var$config) return false;
        const { removePageSegmentsUFOPrefixes: removePageSegmentsUFOPrefixes } = $e07a03c9c51ce18f$var$config;
        if (removePageSegmentsUFOPrefixes != null) return removePageSegmentsUFOPrefixes;
        else return false;
    } catch (e) {
        return false;
    }
}
function $e07a03c9c51ce18f$export$525ba53ca98e9db() {
    try {
        if (!$e07a03c9c51ce18f$var$config) return false;
        const { removeInteractionsUFOPrefixes: removeInteractionsUFOPrefixes } = $e07a03c9c51ce18f$var$config;
        if (removeInteractionsUFOPrefixes != null) return removeInteractionsUFOPrefixes;
        else return false;
    } catch (e) {
        return false;
    }
}
function $e07a03c9c51ce18f$export$4f4649ef27b6f5d6() {
    try {
        if (!$e07a03c9c51ce18f$var$config) return undefined;
        const { ufoNameOverrides: ufoNameOverrides } = $e07a03c9c51ce18f$var$config;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch (e) {
        return undefined;
    }
}
function $e07a03c9c51ce18f$export$3c170167645a0eff() {
    try {
        if (!$e07a03c9c51ce18f$var$config) return undefined;
        const { doNotAbortActivePressInteraction: doNotAbortActivePressInteraction } = $e07a03c9c51ce18f$var$config;
        return doNotAbortActivePressInteraction;
    } catch (e) {
        return undefined;
    }
}
function $e07a03c9c51ce18f$export$d6dc9444bd15f70f() {
    try {
        if (!$e07a03c9c51ce18f$var$config) return undefined;
        const { doNotAbortActivePressInteractionOnTransition: doNotAbortActivePressInteractionOnTransition } = $e07a03c9c51ce18f$var$config;
        return doNotAbortActivePressInteractionOnTransition;
    } catch (e) {
        return undefined;
    }
}

});

parcelRegister("cd3ip", function(module, exports) {

$parcel$export(module.exports, "initTTVC", () => $18abfe164f601b7b$export$86bcaecd2fb4e67a);
$parcel$export(module.exports, "getLastVisibleChangeTimestamp", () => $18abfe164f601b7b$export$c86ad43a55bd354b);
$parcel$export(module.exports, "cancelTTVC", () => $18abfe164f601b7b$export$42e7ba3cdfd3867d);

var $74BVL = parcelRequire("74BVL");

var $GWUpk = parcelRequire("GWUpk");

var $8Id26 = parcelRequire("8Id26");

var $8UbGj = parcelRequire("8UbGj");

var $7CMpS = parcelRequire("7CMpS");
let $18abfe164f601b7b$var$calculator;
const $18abfe164f601b7b$var$whenActivated = (callback)=>{
    if (document.prerendering) (0, $74BVL.bind)(window, {
        type: 'prerenderingchange',
        listener: callback,
        options: {
            capture: true
        }
    });
    else callback();
};
const $18abfe164f601b7b$export$86bcaecd2fb4e67a = (options)=>{
    // apply options
    (0, $GWUpk.setConfig)(options);
    (0, $8Id26.Logger).info('init()');
    $18abfe164f601b7b$var$calculator = (0, $7CMpS.getVisuallyCompleteCalculator)();
    $18abfe164f601b7b$var$whenActivated(()=>{
        $18abfe164f601b7b$var$calculator.start();
        // restart measurement for SPA navigation
        (0, $74BVL.bind)(window, {
            type: 'locationchange',
            listener: (event)=>void $18abfe164f601b7b$var$calculator.start(event.timeStamp)
        });
        // restart measurement on back/forward cache page restoration
        (0, $74BVL.bind)(window, {
            type: 'pageshow',
            listener: (event)=>{
                // abort if this is the initial pageload
                if (!event.persisted) return;
                $18abfe164f601b7b$var$calculator.start(event.timeStamp, true);
            }
        });
    });
};
const $18abfe164f601b7b$export$412a2c372c050ade = (successCallback, errorCallback)=>$18abfe164f601b7b$var$calculator?.onTTVC(successCallback, errorCallback);
const $18abfe164f601b7b$export$17a3d6a590b12a1f = ()=>$18abfe164f601b7b$var$calculator?.start(performance.now());
const $18abfe164f601b7b$export$c86ad43a55bd354b = ()=>$18abfe164f601b7b$var$calculator?.getLastVisibleChangeTimestamp();
const $18abfe164f601b7b$export$42e7ba3cdfd3867d = (eventType)=>$18abfe164f601b7b$var$calculator?.cancel(eventType);
const $18abfe164f601b7b$export$10f1999b2127f137 = ()=>{
    const networkIdleObservable = (0, $8UbGj.getNetworkIdleObservable)();
    networkIdleObservable.incrementAjaxCount();
};
const $18abfe164f601b7b$export$7921fe926596c495 = ()=>{
    const networkIdleObservable = (0, $8UbGj.getNetworkIdleObservable)();
    networkIdleObservable.decrementAjaxCount();
};

});
parcelRegister("GWUpk", function(module, exports) {

$parcel$export(module.exports, "CONFIG", () => $56dd87776e5d39b9$export$1630b5343357e8b5);
$parcel$export(module.exports, "setConfig", () => $56dd87776e5d39b9$export$940a7873bb071df8);
const $56dd87776e5d39b9$export$1630b5343357e8b5 = {
    /** Decide whether to log debug messages. */ DEBUG: false,
    /** A duration in ms to wait before declaring the page completely idle. */ IDLE_TIMEOUT: 200,
    /**
	 * A duration in ms to wait before assuming that a single network request
	 * was not instrumented correctly.
	 *
	 * If NETWORK_TIMEOUT is set to 0, disable this feature.
	 */ NETWORK_TIMEOUT: 60000
};
const $56dd87776e5d39b9$export$940a7873bb071df8 = (options)=>{
    if (options?.debug) $56dd87776e5d39b9$export$1630b5343357e8b5.DEBUG = options.debug;
    if (options?.idleTimeout) $56dd87776e5d39b9$export$1630b5343357e8b5.IDLE_TIMEOUT = options.idleTimeout;
    if (options?.networkTimeout) $56dd87776e5d39b9$export$1630b5343357e8b5.NETWORK_TIMEOUT = options.networkTimeout;
};

});

parcelRegister("8Id26", function(module, exports) {

$parcel$export(module.exports, "Logger", () => $9f7e634488c5d06e$export$efa9a398d6368992);

var $GWUpk = parcelRequire("GWUpk");
class $9f7e634488c5d06e$export$efa9a398d6368992 {
    static format(...messages) {
        return [
            '[ttvc]',
            ...messages,
            '::',
            performance.now()
        ];
    }
    /** Log a debug message to the console */ static debug(...messages) {
        if (!(0, $GWUpk.CONFIG).DEBUG) return;
        // eslint-disable-next-line no-console
        console.debug(...this.format(...messages));
    }
    /** Log a message to the console */ static info(...messages) {
        if (!(0, $GWUpk.CONFIG).DEBUG) return;
        // eslint-disable-next-line no-console
        console.info(...this.format(...messages));
    }
    /** Log a warning message to the console */ static warn(...messages) {
        if (!(0, $GWUpk.CONFIG).DEBUG) return;
        // eslint-disable-next-line no-console
        console.warn(...this.format(...messages));
    }
}

});

parcelRegister("8UbGj", function(module, exports) {

$parcel$export(module.exports, "getNetworkIdleObservable", () => $d19fc1ce912a0d6b$export$9f9afd45036ba033);

var $74BVL = parcelRequire("74BVL");

var $GWUpk = parcelRequire("GWUpk");

var $8Id26 = parcelRequire("8Id26");
/**
 * Alerts subscribers to the presence or absence of pending AJAX requests
 *
 * Use `increment` and `decrement` public methods to instrument your AJAX
 * requests.
 */ class $d19fc1ce912a0d6b$var$AjaxIdleObservable {
    constructor(){
        this.pendingRequests = 0;
        this.subscribers = new Set();
        this.didNetworkTimeOut = false;
        this.next = (message)=>{
            (0, $8Id26.Logger).debug('AjaxIdleObservable.next()', message);
            this.subscribers.forEach((subscriber)=>subscriber(message));
        };
        this.startCleanupTimeout = ()=>{
            if ((0, $GWUpk.CONFIG).NETWORK_TIMEOUT === 0) return;
            this.abortCleanupTimeout();
            const cleanup = ()=>{
                (0, $8Id26.Logger).warn('AjaxIdleObservable', '::', 'Timed out waiting for requests to resolve.', 'Make sure that incrementAjaxCount() is always matched with decrementAjaxCount().', '::', 'pendingRequests =', this.pendingRequests);
                this.didNetworkTimeOut = true;
                this.pendingRequests = 0;
                this.next('IDLE');
            };
            this.cleanupTimeout = window.setTimeout(cleanup, (0, $GWUpk.CONFIG).NETWORK_TIMEOUT);
        };
        this.abortCleanupTimeout = ()=>{
            window.clearTimeout(this.cleanupTimeout);
            this.cleanupTimeout = undefined;
        };
        /** call this whenever an instrumented AJAX request is triggered */ this.increment = ()=>{
            this.startCleanupTimeout();
            if (this.pendingRequests === 0) this.next('BUSY');
            this.pendingRequests += 1;
        };
        /** call this whenever an instrumented AJAX request is resolved */ this.decrement = ()=>{
            this.abortCleanupTimeout();
            if (this.pendingRequests === 1) this.next('IDLE');
            else this.startCleanupTimeout();
            this.pendingRequests = Math.max(this.pendingRequests - 1, 0);
            if (this.pendingRequests < 10) (0, $8Id26.Logger).debug('AjaxIdleObservable.decrement()', '::', 'pendingRequests =', this.pendingRequests);
        };
        this.subscribe = (subscriber)=>{
            this.subscribers.add(subscriber);
            const unsubscribe = ()=>{
                this.subscribers.delete(subscriber);
            };
            return unsubscribe;
        };
    }
}
/** Alerts subscribers to the presence or absence of pending resources */ class $d19fc1ce912a0d6b$var$ResourceLoadingIdleObservable {
    constructor(){
        this.pendingResources = new Set();
        this.subscribers = new Set();
        this.didNetworkTimeOut = false;
        this.next = (message)=>{
            (0, $8Id26.Logger).debug('ResourceLoadingIdleObservable.next()', message);
            this.subscribers.forEach((subscriber)=>subscriber(message));
        };
        this.startCleanupTimeout = ()=>{
            if ((0, $GWUpk.CONFIG).NETWORK_TIMEOUT === 0) return;
            this.abortCleanupTimeout();
            const cleanup = ()=>{
                (0, $8Id26.Logger).warn('ResourceLoadingIdleObservable', '::', 'Timed out waiting for resources to resolve.', 'Consider filing a bug report if this continues to occur.', '::', 'pendingResources =', this.pendingResources);
                this.didNetworkTimeOut = true;
                this.pendingResources = new Set();
                this.next('IDLE');
            };
            this.cleanupTimeout = window.setTimeout(cleanup, (0, $GWUpk.CONFIG).NETWORK_TIMEOUT);
        };
        this.abortCleanupTimeout = ()=>{
            window.clearTimeout(this.cleanupTimeout);
            this.cleanupTimeout = undefined;
        };
        this.add = (element)=>{
            // ignore elements without resources to load
            if (element instanceof HTMLImageElement && !element.src || element instanceof HTMLImageElement && element.complete || element instanceof HTMLLinkElement && !element.href || element instanceof HTMLScriptElement && !element.src || element instanceof HTMLIFrameElement && !element.src) return;
            this.startCleanupTimeout();
            if (this.pendingResources.size === 0) this.next('BUSY');
            this.pendingResources.add(element);
        };
        this.remove = (element)=>{
            this.abortCleanupTimeout();
            this.pendingResources.delete(element);
            if (this.pendingResources.size === 0) this.next('IDLE');
            else this.startCleanupTimeout();
            if (this.pendingResources.size < 10) (0, $8Id26.Logger).debug('ResourceLoadingIdleObservable.remove()', '::', 'pendingResources =', this.pendingResources);
        };
        this.subscribe = (subscriber)=>{
            this.subscribers.add(subscriber);
            const unsubscribe = ()=>{
                this.subscribers.delete(subscriber);
            };
            return unsubscribe;
        };
        // watch out for SSR
        if (typeof window !== 'undefined' && window?.MutationObserver) (0, $74BVL.bind)(window, {
            type: 'load',
            listener: ()=>{
                // watch for added or updated script tags
                const o = new MutationObserver((mutations)=>{
                    mutations.forEach((mutation)=>{
                        mutation.addedNodes.forEach((node)=>{
                            if (node instanceof HTMLScriptElement || node instanceof HTMLLinkElement || node instanceof HTMLImageElement || node instanceof HTMLIFrameElement) this.add(node);
                            else if (node.hasChildNodes() && node instanceof HTMLElement) // images may be mounted within large subtrees, this is less
                            // common with link/script elements
                            node.querySelectorAll('img').forEach(this.add);
                        });
                    });
                });
                // watch for new tags added anywhere in the document
                o.observe(window.document.documentElement, {
                    childList: true,
                    subtree: true
                });
                // as resources load, remove them from pendingResources
                [
                    'load',
                    'error'
                ].forEach((eventType)=>{
                    (0, $74BVL.bind)(window, {
                        type: eventType,
                        listener: (event)=>{
                            if (event.target instanceof HTMLScriptElement || event.target instanceof HTMLLinkElement || event.target instanceof HTMLImageElement || event.target instanceof HTMLIFrameElement) this.remove(event.target);
                        },
                        options: {
                            capture: true
                        }
                    });
                });
            }
        });
    }
}
class $d19fc1ce912a0d6b$export$daa8a0ee3e297bc8 {
    constructor(){
        this.ajaxIdleObservable = new $d19fc1ce912a0d6b$var$AjaxIdleObservable();
        this.resourceLoadingIdleObservable = new $d19fc1ce912a0d6b$var$ResourceLoadingIdleObservable();
        this.subscribers = new Set();
        // idle state
        this.ajaxIdle = true;
        this.scriptLoadingIdle = true;
        this.handleUpdate = (source)=>(message)=>{
                const wasIdle = this.ajaxIdle && this.scriptLoadingIdle;
                // update state
                if (source === 'AJAX') this.ajaxIdle = message === 'IDLE';
                if (source === 'RESOURCE_LOADING') this.scriptLoadingIdle = message === 'IDLE';
                // if this is a change, notify subscribers
                const isIdle = this.ajaxIdle && this.scriptLoadingIdle;
                if (wasIdle !== isIdle) this.next(isIdle ? 'IDLE' : 'BUSY');
            };
        this.next = (message)=>{
            (0, $8Id26.Logger).debug('NetworkIdleObservable.next()', message);
            this.subscribers.forEach((subscriber)=>subscriber(message));
        };
        this.incrementAjaxCount = ()=>this.ajaxIdleObservable.increment();
        this.decrementAjaxCount = ()=>this.ajaxIdleObservable.decrement();
        this.isIdle = ()=>this.ajaxIdle && this.scriptLoadingIdle;
        this.didNetworkTimeOut = ()=>this.ajaxIdleObservable.didNetworkTimeOut || this.resourceLoadingIdleObservable.didNetworkTimeOut;
        this.resetDidNetworkTimeOut = ()=>{
            this.ajaxIdleObservable.didNetworkTimeOut = false;
            this.resourceLoadingIdleObservable.didNetworkTimeOut = false;
        };
        this.subscribe = (subscriber)=>{
            this.subscribers.add(subscriber);
            const unsubscribe = ()=>{
                this.subscribers.delete(subscriber);
            };
            return unsubscribe;
        };
        this.ajaxIdleObservable.subscribe(this.handleUpdate('AJAX'));
        this.resourceLoadingIdleObservable.subscribe(this.handleUpdate('RESOURCE_LOADING'));
    }
}
// expose observable as a singleton
let $d19fc1ce912a0d6b$var$networkIdleObservable;
const $d19fc1ce912a0d6b$export$9f9afd45036ba033 = ()=>{
    if (!$d19fc1ce912a0d6b$var$networkIdleObservable) $d19fc1ce912a0d6b$var$networkIdleObservable = new $d19fc1ce912a0d6b$export$daa8a0ee3e297bc8();
    return $d19fc1ce912a0d6b$var$networkIdleObservable;
};

});

parcelRegister("7CMpS", function(module, exports) {

$parcel$export(module.exports, "getVisuallyCompleteCalculator", () => $72f485bb216b4c01$export$90e17c8c7646069e);

var $74BVL = parcelRequire("74BVL");

var $f3FBs = parcelRequire("f3FBs");

var $bDlaU = parcelRequire("bDlaU");

var $8Id26 = parcelRequire("8Id26");

var $iLF45 = parcelRequire("iLF45");

var $3C9bt = parcelRequire("3C9bt");

var $l1659 = parcelRequire("l1659");
const $72f485bb216b4c01$export$cbce095b92028433 = {
    NEW_NAVIGATION: 'NEW_NAVIGATION',
    VISIBILITY_CHANGE: 'VISIBILITY_CHANGE',
    USER_INTERACTION: 'USER_INTERACTION',
    MANUAL_CANCELLATION: 'MANUAL_CANCELLATION'
};
/**
 * Core of the TTVC calculation that ties viewport observers and network monitoring
 * into a singleton that facilitates communication of TTVC metric measurement and error
 * information to subscribers.
 */ class $72f485bb216b4c01$var$VisuallyCompleteCalculator {
    /**
	 * Determine whether the calculator should run in the current environment
	 */ static isSupportedEnvironment() {
        return window !== undefined && 'MutationObserver' in window && 'IntersectionObserver' in window && typeof document.querySelectorAll === 'function' && window.performance?.timing;
    }
    constructor(){
        // configuration
        this.debug = false;
        this.idleTimeout = 200;
        this.lastImageLoadTimestamp = -1;
        this.navigationCount = 0;
        // subscribers
        this.successSubscribers = new Set();
        this.errorSubscribers = new Set();
        this.unbindFunctions = [];
        /** subscribe to Visually Complete metrics */ this.onTTVC = (successSubscriber, errorSubscriber)=>{
            // register subscriber callbacks
            this.successSubscribers.add(successSubscriber);
            if (errorSubscriber) this.errorSubscribers.add(errorSubscriber);
            // return an unsubscribe function
            return ()=>{
                this.successSubscribers.delete(successSubscriber);
                if (errorSubscriber) this.errorSubscribers.delete(errorSubscriber);
            };
        };
        if (!$72f485bb216b4c01$var$VisuallyCompleteCalculator.isSupportedEnvironment()) throw new Error('VisuallyCompleteCalculator: This browser/runtime is not supported.');
        this.inViewportMutationObserver = new (0, $bDlaU.InViewportMutationObserver)((mutation)=>{
            if ((mutation.timestamp ?? 0) >= (this.lastMutation?.timestamp ?? 0)) this.lastMutation = mutation;
        });
        this.inViewportImageObserver = new (0, $f3FBs.InViewportImageObserver)((timestamp, img)=>{
            if (timestamp >= this.lastImageLoadTimestamp) {
                this.lastImageLoadTimestamp = timestamp;
                this.lastImageLoadTarget = img;
            }
        });
    }
    /**
	 * expose a method to abort the current TTVC measurement
	 * @param eventType - type of event that triggered cancellation (note that cancellationReason will be set to "MANUAL_CANCELLATION" regardless of this value).
	 */ cancel(eventType) {
        (0, $8Id26.Logger).info('VisuallyCompleteCalculator.cancel()', '::', 'index =', this.activeMeasurementIndex);
        if (this.activeMeasurementIndex) this.error({
            start: (0, $iLF45.getActivationStart)(),
            end: performance.now(),
            cancellationReason: $72f485bb216b4c01$export$cbce095b92028433.MANUAL_CANCELLATION,
            eventType: eventType,
            navigationType: (0, $iLF45.getNavigationType)(),
            lastVisibleChange: this.getLastVisibleChange()
        });
        this.activeMeasurementIndex = undefined;
    }
    /** begin measuring a new navigation */ async start(start = 0, isBfCacheRestore = false) {
        const navigationIndex = this.navigationCount += 1;
        this.activeMeasurementIndex = navigationIndex;
        (0, $8Id26.Logger).info('VisuallyCompleteCalculator.start()', '::', 'index =', navigationIndex);
        let navigationType = isBfCacheRestore ? 'back_forward' : start > 0 ? 'script' : (0, $iLF45.getNavigationType)();
        const activationStart = (0, $iLF45.getActivationStart)();
        if (activationStart > start) {
            start = activationStart;
            navigationType = 'prerender';
        }
        // setup
        const cancel = (e, cancellationReason)=>{
            if (this.activeMeasurementIndex === navigationIndex) {
                this.activeMeasurementIndex = undefined;
                this.error({
                    start: start,
                    end: performance.now(),
                    cancellationReason: cancellationReason,
                    eventType: e.type,
                    eventTarget: e.target || undefined,
                    navigationType: navigationType,
                    lastVisibleChange: this.getLastVisibleChange()
                });
            }
        };
        const cancelOnInteraction = (e)=>cancel(e, $72f485bb216b4c01$export$cbce095b92028433.USER_INTERACTION);
        const cancelOnNavigation = (e)=>cancel(e, $72f485bb216b4c01$export$cbce095b92028433.NEW_NAVIGATION);
        const cancelOnVisibilityChange = (e)=>cancel(e, $72f485bb216b4c01$export$cbce095b92028433.VISIBILITY_CHANGE);
        this.inViewportImageObserver.observe();
        this.inViewportMutationObserver.observe(document.documentElement);
        const pageHideUnbind = (0, $74BVL.bind)(window, {
            type: 'pagehide',
            listener: cancelOnNavigation
        });
        const visibilityChangeUnbind = (0, $74BVL.bind)(window, {
            type: 'visibilitychange',
            listener: cancelOnVisibilityChange
        });
        this.unbindFunctions.push(pageHideUnbind);
        this.unbindFunctions.push(visibilityChangeUnbind);
        // attach user interaction listeners next tick (we don't want to pick up the SPA navigation click)
        window.setTimeout(()=>{
            const clickUnbind = (0, $74BVL.bind)(window, {
                type: 'click',
                listener: cancelOnInteraction
            });
            const keydownUnbind = (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: cancelOnInteraction
            });
            this.unbindFunctions.push(clickUnbind);
            this.unbindFunctions.push(keydownUnbind);
        }, 0);
        // wait for page to be definitely DONE
        // - wait for window.on("load")
        await (0, $l1659.waitForPageLoad)();
        // - wait for simultaneous network and CPU idle
        const didNetworkTimeOut = await new Promise((0, $3C9bt.requestAllIdleCallback));
        // if this navigation's measurement hasn't been cancelled, record it.
        if (navigationIndex === this.activeMeasurementIndex) {
            // identify timestamp of last visible change
            const end = Math.max(start, this.lastImageLoadTimestamp, this.lastMutation?.timestamp ?? 0);
            // report result to subscribers
            this.next({
                start: start,
                end: end,
                duration: end - start,
                detail: {
                    navigationType: navigationType,
                    didNetworkTimeOut: didNetworkTimeOut,
                    lastVisibleChange: this.getLastVisibleChange()
                }
            });
        } else {
            (0, $8Id26.Logger).debug('VisuallyCompleteCalculator: Measurement discarded', '::', 'index =', navigationIndex);
            if (this.activeMeasurementIndex) this.error({
                start: start,
                end: performance.now(),
                cancellationReason: $72f485bb216b4c01$export$cbce095b92028433.NEW_NAVIGATION,
                navigationType: navigationType,
                lastVisibleChange: this.getLastVisibleChange()
            });
        }
        // cleanup
        this.unbindFunctions.forEach((unbind)=>{
            unbind();
        });
        this.unbindFunctions = [];
        // only disconnect observers if this is the most recent navigation
        if (navigationIndex === this.navigationCount) {
            this.inViewportImageObserver.disconnect();
            this.inViewportMutationObserver.disconnect();
        }
    }
    next(measurement) {
        if (measurement.end > Number.MAX_SAFE_INTEGER) {
            (0, $8Id26.Logger).warn('VisuallyCompleteCalculator.next()', '::', 'This browser reported a time larger than MAX_SAFE_INTEGER. We are ignoring it.', '::', measurement);
            return;
        }
        (0, $8Id26.Logger).debug('VisuallyCompleteCalculator.next()', '::', 'lastImageLoadTimestamp =', this.lastImageLoadTimestamp, 'lastMutationTimestamp =', this.lastMutation?.timestamp ?? 0, '::', 'index =', this.activeMeasurementIndex);
        (0, $8Id26.Logger).info('TTVC:', measurement, '::', 'index =', this.activeMeasurementIndex);
        this.successSubscribers.forEach((subscriber)=>subscriber(measurement));
    }
    error(error) {
        (0, $8Id26.Logger).debug('VisuallyCompleteCalculator.error()', '::', 'cancellationReason =', error.cancellationReason, '::', 'eventType =', error.eventType || 'none', '::', 'index =', this.activeMeasurementIndex);
        this.errorSubscribers.forEach((subscriber)=>subscriber(error));
    }
    getLastVisibleChange() {
        return this.lastImageLoadTimestamp > (this.lastMutation?.timestamp ?? 0) ? this.lastImageLoadTarget : this.lastMutation;
    }
    getLastVisibleChangeTimestamp() {
        return this.lastImageLoadTimestamp > (this.lastMutation?.timestamp ?? 0) ? this.lastImageLoadTimestamp : this.lastMutation?.timestamp ?? 0;
    }
}
// export calculator singleton
let $72f485bb216b4c01$var$calculator;
const $72f485bb216b4c01$export$90e17c8c7646069e = ()=>{
    if (!$72f485bb216b4c01$var$calculator) $72f485bb216b4c01$var$calculator = new $72f485bb216b4c01$var$VisuallyCompleteCalculator();
    return $72f485bb216b4c01$var$calculator;
};

});
parcelRegister("f3FBs", function(module, exports) {

$parcel$export(module.exports, "InViewportImageObserver", () => $165b47ced6e32e3c$export$6523501d77d964c6);

var $74BVL = parcelRequire("74BVL");

var $8Id26 = parcelRequire("8Id26");
let $165b47ced6e32e3c$var$unbindFunctions = [];
class $165b47ced6e32e3c$export$6523501d77d964c6 {
    constructor(callback){
        this.imageLoadTimes = new Map();
        this.lastImageLoadTimestamp = 0;
        this.intersectionObserverCallback = (entries)=>{
            entries.forEach((entry)=>{
                const img = entry.target;
                const timestamp = this.imageLoadTimes.get(img);
                if (entry.isIntersecting && timestamp != null) {
                    (0, $8Id26.Logger).info('InViewportImageObserver.callback()', '::', 'timestamp =', timestamp);
                    this.callback(timestamp, img);
                }
                this.intersectionObserver.unobserve(img);
                this.imageLoadTimes.delete(img);
            });
        };
        // Error events on the `window` can be a `string` (legacy).
        // The built in TS DOM types don't have a (correct) narrower
        // type for the `Document`.
        this.handleLoadOrErrorEvent = (event)=>{
            if (typeof event !== 'string' && (event.target instanceof HTMLImageElement || event.target instanceof HTMLIFrameElement)) {
                (0, $8Id26.Logger).debug('InViewportImageObserver.handleLoadOrErrorEvent()', '::', 'event =', event);
                this.imageLoadTimes.set(event.target, event.timeStamp);
                this.intersectionObserver.observe(event.target);
            }
        };
        this.callback = callback;
        this.intersectionObserver = new IntersectionObserver(this.intersectionObserverCallback);
    }
    /** Start observing loading images. */ observe() {
        (0, $8Id26.Logger).info('InViewportImageObserver.observe()');
        const loadUnbindFn = (0, $74BVL.bind)(document, {
            type: 'load',
            listener: this.handleLoadOrErrorEvent,
            options: {
                capture: true
            }
        });
        const errorUnbindFn = (0, $74BVL.bind)(document, {
            type: 'error',
            listener: this.handleLoadOrErrorEvent,
            options: {
                capture: true
            }
        });
        $165b47ced6e32e3c$var$unbindFunctions.push(loadUnbindFn);
        $165b47ced6e32e3c$var$unbindFunctions.push(errorUnbindFn);
    }
    /** Stop observing loading images, and clean up. */ disconnect() {
        (0, $8Id26.Logger).info('InViewportImageObserver.disconnect()');
        this.lastImageLoadTimestamp = 0;
        this.imageLoadTimes.clear();
        this.intersectionObserver.disconnect();
        $165b47ced6e32e3c$var$unbindFunctions.forEach((unbind)=>{
            unbind();
        });
        $165b47ced6e32e3c$var$unbindFunctions = [];
    }
}

});

parcelRegister("bDlaU", function(module, exports) {

$parcel$export(module.exports, "InViewportMutationObserver", () => $f6949acf808f5be3$export$87e7c22ab525ab82);

var $8Id26 = parcelRequire("8Id26");
class $f6949acf808f5be3$export$87e7c22ab525ab82 {
    constructor(callback){
        this.mutationObserverConfig = {
            attributeFilter: [
                'hidden',
                'style',
                'src'
            ],
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        };
        this.mutations = new Map();
        this.mutationObserverCallback = (mutations)=>{
            (0, $8Id26.Logger).debug('InViewportMutationObserver.mutationObserverCallback()', '::', 'mutations =', mutations);
            mutations.forEach((mutation)=>{
                mutation.timestamp = performance.now();
                let target = null;
                if (mutation.target instanceof Element) target = mutation.target;
                if (mutation.target instanceof Text) target = mutation.target.parentElement;
                if (!target) return;
                switch(mutation.type){
                    case 'childList':
                        mutation.addedNodes.forEach((node)=>{
                            if (node instanceof HTMLElement) {
                                this.intersectionObserver.observe(node);
                                this.mutations.set(node, mutation);
                            }
                            if (node instanceof Text && node.parentElement != null) {
                                this.intersectionObserver.observe(node.parentElement);
                                this.mutations.set(node.parentElement, mutation);
                            }
                        });
                        break;
                    case 'attributes':
                    default:
                        this.intersectionObserver.observe(target);
                        this.mutations.set(target, mutation);
                }
            });
        };
        this.intersectionObserverCallback = (entries)=>{
            (0, $8Id26.Logger).debug('InViewportMutationObserver.intersectionObserverCallback()', '::', 'entries =', entries);
            entries.forEach((entry)=>{
                const mutation = this.mutations.get(entry.target);
                if (entry.isIntersecting && mutation != null) {
                    (0, $8Id26.Logger).info('InViewportMutationObserver.callback()', '::', 'mutation =', mutation);
                    this.callback(mutation);
                }
                this.mutations.delete(entry.target);
                this.intersectionObserver.unobserve(entry.target);
            });
        };
        this.callback = callback;
        this.mutationObserver = new MutationObserver(this.mutationObserverCallback);
        this.intersectionObserver = new IntersectionObserver(this.intersectionObserverCallback);
    }
    observe(target) {
        (0, $8Id26.Logger).info('InViewportMutationObserver.observe()', '::', 'target =', target);
        this.mutationObserver.observe(target, this.mutationObserverConfig);
    }
    disconnect() {
        (0, $8Id26.Logger).info('InViewportMutationObserver.disconnect()');
        this.mutationObserver.disconnect();
        this.intersectionObserver.disconnect();
    }
}

});

parcelRegister("iLF45", function(module, exports) {

$parcel$export(module.exports, "getNavigationType", () => $da6c87c2b13c86da$export$5ce4dcef8b4f05c6);
$parcel$export(module.exports, "getActivationStart", () => $da6c87c2b13c86da$export$d3e828b3c7b5b845);
// http://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigation/type
const $da6c87c2b13c86da$var$getDeprecatedNavigationType = ()=>{
    const { type: type } = window.performance.navigation;
    return type === 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate';
};
const $da6c87c2b13c86da$export$5ce4dcef8b4f05c6 = ()=>window.performance.getEntriesByType('navigation')[0]?.type || $da6c87c2b13c86da$var$getDeprecatedNavigationType();
const $da6c87c2b13c86da$export$d3e828b3c7b5b845 = ()=>window.performance.getEntriesByType('navigation')[0]?.activationStart || 0;

});

parcelRegister("3C9bt", function(module, exports) {

$parcel$export(module.exports, "requestAllIdleCallback", () => $a89987b0567802f6$export$739522c5f515da6e);

var $GWUpk = parcelRequire("GWUpk");

var $8Id26 = parcelRequire("8Id26");

var $8UbGj = parcelRequire("8UbGj");

var $ah3jM = parcelRequire("ah3jM");
function $a89987b0567802f6$export$739522c5f515da6e(callback) {
    const networkIdleObservable = (0, $8UbGj.getNetworkIdleObservable)();
    // state
    let networkIdle = networkIdleObservable.isIdle();
    let timeout;
    const handleNetworkChange = (message)=>{
        networkIdle = message === 'IDLE';
        if (networkIdle) (0, $ah3jM.requestIdleCallback)(handleCpuIdle);
        else {
            window.clearTimeout(timeout);
            timeout = undefined;
        }
    };
    const handleCpuIdle = ()=>{
        (0, $8Id26.Logger).debug('requestAllIdleCallback.handleCpuIdle()');
        if (networkIdle && !timeout) handleAllIdle();
    };
    const handleAllIdle = ()=>{
        timeout = window.setTimeout(()=>{
            // Did we have to clear a "hung" request from observable state?
            const didNetworkTimeOut = networkIdleObservable.didNetworkTimeOut();
            networkIdleObservable.resetDidNetworkTimeOut();
            (0, $8Id26.Logger).info('requestAllIdleCallback: ALL IDLE');
            callback(didNetworkTimeOut);
            unsubscribe();
        }, (0, $GWUpk.CONFIG).IDLE_TIMEOUT);
    };
    const unsubscribe = networkIdleObservable.subscribe(handleNetworkChange);
    // base case
    if (networkIdle) handleNetworkChange('IDLE');
}

});
parcelRegister("ah3jM", function(module, exports) {

$parcel$export(module.exports, "requestIdleCallback", () => $a5354aacdd713df1$export$9288a5d956b3efbe);
/**
 * Request a callback when we are confident that any synchronous CPU work has
 * been flushed from the task queue.
 */ const $a5354aacdd713df1$export$9288a5d956b3efbe = (callback)=>{
    // if browser supports it, wait until CPU is idle
    // eslint-disable-next-line compat/compat
    const requestCallback = window.requestIdleCallback ?? window.setTimeout;
    requestCallback(()=>{
        // wait *two* animation frames, to ensure the page has a chance to flush
        // pending changes to the DOM
        window.requestAnimationFrame(()=>window.requestAnimationFrame(callback));
    });
};

});


parcelRegister("l1659", function(module, exports) {

$parcel$export(module.exports, "waitForPageLoad", () => $70c7322478f9df44$export$96626fdeaeb544ce);

var $74BVL = parcelRequire("74BVL");
const $70c7322478f9df44$export$96626fdeaeb544ce = ()=>{
    if (document.readyState === 'complete') return Promise.resolve();
    return new Promise((resolve)=>{
        const unbind = (0, $74BVL.bind)(window, {
            type: 'load',
            listener: ()=>{
                resolve();
                unbind();
            }
        });
    });
};

});



parcelRegister("gnIbC", function(module, exports) {

$parcel$export(module.exports, "DefaultInteractionID", () => $1c3bceb67a3eb151$export$3109542b68df9ba1);
$parcel$export(module.exports, "default", () => $1c3bceb67a3eb151$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getInteractionId", () => $1c3bceb67a3eb151$export$37bca3107733ac1e);

var $eUqFw = parcelRequire("eUqFw");
const $1c3bceb67a3eb151$export$3109542b68df9ba1 = {
    current: null
};
var // We use a context to allow modals to have their own lifecycle
$1c3bceb67a3eb151$export$2e2bcd8739ae039 = (0, $eUqFw.createContext)($1c3bceb67a3eb151$export$3109542b68df9ba1);
const $1c3bceb67a3eb151$export$37bca3107733ac1e = ()=>$1c3bceb67a3eb151$export$3109542b68df9ba1;
const $1c3bceb67a3eb151$export$9f6000531b78127e = ()=>$1c3bceb67a3eb151$export$3109542b68df9ba1;

});

parcelRegister("5TiXm", function(module, exports) {

$parcel$export(module.exports, "getVCObserver", () => $72dcf30406e8d6e4$export$b3bc47985717b49e);

var $bi4nP = parcelRequire("bi4nP");
let $72dcf30406e8d6e4$var$instance = null;
const $72dcf30406e8d6e4$export$b3bc47985717b49e = (opts = {})=>{
    if ($72dcf30406e8d6e4$var$instance === null) $72dcf30406e8d6e4$var$instance = new (0, $bi4nP.VCObserver)(opts);
    return $72dcf30406e8d6e4$var$instance;
};

});
parcelRegister("bi4nP", function(module, exports) {

$parcel$export(module.exports, "VCObserver", () => $79a9e3cb3cb18c03$export$1f70d263701b1d01);

var $74BVL = parcelRequire("74BVL");

var $dj9Jl = parcelRequire("dj9Jl");

var $2P6VY = parcelRequire("2P6VY");
const $79a9e3cb3cb18c03$var$abortReason = {
    scroll: 'scroll',
    keypress: 'keypress',
    resize: 'resize',
    error: 'error'
};
function $79a9e3cb3cb18c03$var$getViewportWidth() {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
function $79a9e3cb3cb18c03$var$getViewportHeight() {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
class $79a9e3cb3cb18c03$export$1f70d263701b1d01 {
    constructor(options){
        /* abort logic */ this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.outOfBoundaryInfo = '';
        /** config * */ this.VCParts = [
            '25',
            '50',
            '75',
            '80',
            '85',
            '90',
            '95',
            '98',
            '99'
        ];
        this.viewport = {
            w: 0,
            h: 0
        };
        /* heatmap */ this.arraySize = 0;
        this.componentsLog = {};
        this.active = false;
        this.totalTime = 0;
        this.startTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            reactRendered: -1
        };
        this.unbind = {};
        this.getAbortReason = ()=>{
            if (this.abortReason.reason === null) return null;
            const info = this.abortReason.info !== '' ? ` ${this.abortReason.info}` : '';
            return `${this.abortReason.reason}${info}`;
        };
        this.getVCResult = ({ start: start, stop: stop, tti: tti, prefix: prefix })=>{
            this.measureStart();
            if (!this.active) {
                this.measureStop();
                return {};
            }
            const fullPrefix = prefix !== undefined && prefix !== '' ? `${prefix}:` : '';
            this.stop();
            const abortReason = this.getAbortReason();
            if (abortReason !== null && this.abortReason.blocking) {
                // exposing data to devtools
                try {
                    if (this.devToolsEnabled) window.__vcNotAvailableReason = abortReason;
                } catch (e) {}
                return {
                    [`${fullPrefix}vc:state`]: false,
                    [`${fullPrefix}vc:abort:reason`]: abortReason,
                    [`${fullPrefix}vc:abort:timestamp`]: this.abortReason.timestamp
                };
            }
            const { VC: VC, VCBox: VCBox, VCEntries: VCEntries, totalPainted: totalPainted } = this.calculateVC(this.ssrInclusiveHeatmap, true);
            const ssrVC = this.calculateVC(this.heatmap);
            const outOfBoundary = this.outOfBoundaryInfo ? {
                [`${fullPrefix}vc:oob`]: this.outOfBoundaryInfo
            } : {};
            const oldDomUpdates = this.oldDomUpdatesEnabled ? {
                [`${fullPrefix}vc:old:dom`]: ssrVC.VCBox
            } : {};
            this.measureStop();
            // exposing data to devtools
            try {
                if (this.devToolsEnabled) window.__vc = {
                    entries: VCEntries.rel,
                    log: this.componentsLog,
                    metrics: {
                        '75': VC['75'],
                        '80': VC['80'],
                        '85': VC['85'],
                        '90': VC['90'],
                        '95': VC['95'],
                        '98': VC['98'],
                        '99': VC['99'],
                        tti: tti,
                        ttai: stop - start
                    },
                    heatmap: this.heatmap
                };
            } catch (e) {
            /*  do nothing */ }
            // console.log('exposed data')
            const returnValue = {
                'metrics:vc': VC,
                [`${fullPrefix}vc:state`]: true,
                [`${fullPrefix}vc:clean`]: abortReason ? false : true,
                [`${fullPrefix}vc:dom`]: VCBox,
                [`${fullPrefix}vc:updates`]: VCEntries.rel.slice(0, 50),
                [`${fullPrefix}vc:size`]: {
                    ...this.viewport
                },
                [`${fullPrefix}vc:time`]: Math.round(this.totalTime + this.observers.getTotalTime()),
                [`${fullPrefix}vc:total`]: totalPainted,
                ...outOfBoundary,
                [`${fullPrefix}vc:old`]: ssrVC.VC,
                ...oldDomUpdates
            };
            return returnValue;
        };
        this.handleUpdate = (rawTime, intersectionRect, targetName, element, ignored)=>{
            this.measureStart();
            if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                const time = Math.round(rawTime - this.startTime);
                const mappedValues = this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                this.applyChangesToHeatMap(mappedValues, time, this.heatmap);
                if (!ignored) this.applyChangesToHeatMap(mappedValues, time, this.ssrInclusiveHeatmap);
                // console.log('handleUpdate', ignored, time, element === this.ssr.element, (intersectionRect.width * intersectionRect.height) / (this.viewport.w*this.viewport.h), element);
                if (!this.componentsLog[time]) this.componentsLog[time] = [];
                this.componentsLog[time].push({
                    element: element,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignored: ignored
                });
            }
            // devtools export
            this.measureStop();
        };
        this.mapPixelsToHeatmap = (left, top, width, height)=>{
            const { w: w, h: h } = this.viewport;
            const l = Math.floor(left / w * this.arraySize);
            const t = Math.floor(top / h * this.arraySize);
            const r = Math.ceil((left + width) / w * this.arraySize);
            const b = Math.ceil((top + height) / h * this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (this.outOfBoundaryInfo === '') {
                let outOfBoundaryInfo = '';
                if (r > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${left} ${width}`;
                if (b > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${top} ${height}`;
                this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            const result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(this.arraySize, r),
                b: Math.min(this.arraySize, b)
            };
            return result;
        };
        this.attachAbortListeners = ()=>{
            this.detachAbortListeners();
            const wheelUnbind = (0, $74BVL.bind)(window, {
                type: 'wheel',
                listener: (e)=>{
                    this.setAbortReason($79a9e3cb3cb18c03$var$abortReason.scroll, e.timeStamp);
                },
                options: {
                    passive: true,
                    once: true
                }
            });
            const keyDownUnbind = (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: (e)=>{
                    this.setAbortReason($79a9e3cb3cb18c03$var$abortReason.keypress, e.timeStamp);
                },
                options: {
                    once: true
                }
            });
            const resizeUnbind = (0, $74BVL.bind)(window, {
                type: 'resize',
                listener: (e)=>{
                    if ($79a9e3cb3cb18c03$var$getViewportWidth() !== this.viewport.w || $79a9e3cb3cb18c03$var$getViewportHeight() !== this.viewport.h) {
                        this.setAbortReason($79a9e3cb3cb18c03$var$abortReason.resize, e.timeStamp);
                        this.unbind.resize?.();
                        delete this.unbind.resize;
                    }
                }
            });
            this.unbind = {
                wheel: wheelUnbind,
                keyDown: keyDownUnbind,
                resize: resizeUnbind
            };
        };
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        this.observers = new (0, $2P6VY.Observers)({
            selectorConfig: options.selectorConfig || {
                id: false,
                testId: false,
                role: false,
                className: true,
                dataVC: true
            }
        });
        this.heatmap = this.getCleanHeatmap();
        this.ssrInclusiveHeatmap = this.getCleanHeatmap();
        if (options.devToolsEnabled) (0, $dj9Jl.initDevTools)();
    }
    start({ startTime: startTime }) {
        this.setViewportSize();
        this.resetState();
        this.startTime = startTime;
        this.active = true;
        this.attachAbortListeners();
        this.observers.subscribeResults(this.handleUpdate);
        this.observers.observe();
    }
    stop() {
        this.observers.disconnect();
        this.detachAbortListeners();
    }
    calculateVC(heatmap, addToPerformance = false) {
        const lastUpdate = {};
        let totalPainted = 0;
        heatmap.forEach((line)=>{
            line.forEach((entry)=>{
                const rounded = Math.floor(entry);
                totalPainted += entry > 0 ? 1 : 0;
                if (rounded > 0) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
            });
        });
        const entries = Object.entries(lastUpdate).map((a)=>[
                parseInt(a[0], 10),
                a[1]
            ]).sort((a, b)=>a[0] > b[0] ? 1 : -1);
        const VC = this.makeVCReturnObj();
        const VCBox = this.makeVCReturnObj();
        entries.reduce((acc = 0, v)=>{
            const VCRatio = v[1] / totalPainted + acc;
            const time = v[0];
            this.VCParts.forEach((key)=>{
                const value = parseInt(key, 10);
                if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                    VC[key] = time;
                    VCBox[key] = this.componentsLog[time]?.map((v)=>v.targetName);
                }
            });
            return VCRatio;
        }, 0);
        try {
            if (addToPerformance) this.VCParts.forEach((key)=>{
                const duration = VC[key];
                if (duration !== null && duration !== undefined) performance.measure(`VC${key}`, {
                    start: 0,
                    duration: duration
                });
            });
        } catch (e) {
        /* empty */ }
        const VCEntries = entries.reduce((acc, [timestamp, entryPainted], i)=>{
            const currentlyPainted = entryPainted + (acc.abs[i - 1]?.[1] || 0);
            const currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
            const logEntry = this.componentsLog[timestamp]?.map((v)=>v.targetName);
            acc.abs.push([
                timestamp,
                currentlyPainted
            ]);
            acc.rel.push({
                time: timestamp,
                vc: currentlyPaintedRatio,
                elements: logEntry
            });
            return acc;
        }, {
            abs: [],
            rel: []
        });
        return {
            VC: VC,
            VCBox: VCBox,
            VCEntries: VCEntries,
            totalPainted: totalPainted
        };
    }
    setSSRElement(element) {
        this.observers.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.observers.setReactRootRenderStart(startTime);
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.observers.setReactRootRenderStop(stopTime);
    }
    setAbortReason(abort, timestamp, info = '') {
        if (this.abortReason.reason === null || this.abortReason.blocking === false) {
            this.abortReason.reason = abort;
            this.abortReason.info = info;
            this.abortReason.timestamp = timestamp;
            this.abortReason.blocking = abort !== $79a9e3cb3cb18c03$var$abortReason.scroll;
            if (this.abortReason.blocking) this.detachAbortListeners();
        }
    }
    resetState() {
        this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.detachAbortListeners();
        this.heatmap = this.getCleanHeatmap();
        this.ssrInclusiveHeatmap = this.getCleanHeatmap();
        this.totalTime = 0;
        this.componentsLog = {};
    }
    getCleanHeatmap() {
        return Array(this.arraySize).fill('').map(()=>Array(this.arraySize).fill(0));
    }
    setViewportSize() {
        this.viewport.w = $79a9e3cb3cb18c03$var$getViewportWidth();
        this.viewport.h = $79a9e3cb3cb18c03$var$getViewportHeight();
    }
    applyChangesToHeatMap(a, time, heatmap) {
        const { l: l, t: t, r: r, b: b } = a;
        const localHeatmap = heatmap;
        for(let row = t; row < b; row++){
            for(let col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                try {
                    this.setAbortReason($79a9e3cb3cb18c03$var$abortReason.error, time, `index - ${row}`);
                } catch (e) {
                    this.setAbortReason($79a9e3cb3cb18c03$var$abortReason.error, time, 'row error');
                }
                return;
            } else localHeatmap[row][col] = time;
        }
    }
    makeVCReturnObj() {
        const vc = {};
        this.VCParts.forEach((v)=>{
            vc[v] = null;
        });
        return vc;
    }
    detachAbortListeners() {
        const unbindFns = Object.values(this.unbind);
        if (unbindFns.length > 0) unbindFns.forEach((fn)=>fn());
        this.unbind = {};
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
}

});
parcelRegister("dj9Jl", function(module, exports) {

$parcel$export(module.exports, "initDevTools", () => $1c04305329e6e8d8$export$93f430585c3f6d11);

const $1c04305329e6e8d8$export$93f430585c3f6d11 = ()=>{
    window.VCDevTools = (opts)=>(parcelRequire("gUpnv")).then(({ startVCDevTools: startVCDevTools })=>startVCDevTools?.(opts));
};

});
parcelRegister("gUpnv", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('eNmuD'),
            load('dsiAd'),
            load('hPzOn'),
            load('eIn4s')
        ]);
        const value = parcelRequire('hdXsd');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("eNmuD"),
        load("dsiAd"),
        load("hPzOn"),
        load("eIn4s")
    ]).then(()=>parcelRequire('hdXsd'));
}

});


parcelRegister("2P6VY", function(module, exports) {

$parcel$export(module.exports, "Observers", () => $69715e2642733a46$export$b65d046240060e78);

var $lF6TV = parcelRequire("lF6TV");
const $69715e2642733a46$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
class $69715e2642733a46$export$b65d046240060e78 {
    constructor(opts){
        this.observedMutations = new Map();
        this.elementsInView = new Set();
        this.callbacks = new Set();
        this.totalTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            state: $69715e2642733a46$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.selectorConfig = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.subscribeResults = (cb)=>{
            this.callbacks.add(cb);
        };
        this.observeElement = (node, mutation, _type, ignored)=>{
            this.intersectionObserver?.observe(node);
            this.observedMutations.set(node, {
                mutation: mutation,
                ignored: ignored
            });
        };
        this.selectorConfig = {
            ...this.selectorConfig,
            ...opts.selectorConfig
        };
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        this.ssrPlaceholderHandler = new (0, $lF6TV.SSRPlaceholderHandlers)();
    }
    observe() {
        this.totalTime = 0;
        this.ssr = {
            state: $69715e2642733a46$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.mutationObserver.observe(document.body, {
            attributeFilter: [
                'hidden',
                'style',
                'src'
            ],
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
    }
    disconnect() {
        this.mutationObserver.disconnect();
        this.intersectionObserver.disconnect();
        this.observedMutations = new Map();
        this.elementsInView = new Set();
        this.callbacks = new Set();
        this.ssr.reactRootElement = null;
        this.ssrPlaceholderHandler.clear();
    }
    getTotalTime() {
        return this.totalTime;
    }
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $69715e2642733a46$var$state.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    getMutationObserver() {
        return new MutationObserver((mutations)=>{
            this.measureStart();
            mutations.forEach((mutation)=>{
                // patching element if timestamp not automatically added
                // eslint-disable-next-line no-param-reassign
                mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                let ignored = false;
                if (this.ssr.state === $69715e2642733a46$var$state.waitingForFirstRender && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    this.ssr.state = $69715e2642733a46$var$state.ignoring;
                    if (this.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                    this.ssr.renderStop = mutation.timestamp + 500;
                    ignored = true;
                }
                if (this.ssr.state === $69715e2642733a46$var$state.ignoring && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    if (mutation.timestamp <= this.ssr.renderStop) ignored = true;
                    else this.ssr.state = $69715e2642733a46$var$state.normal;
                }
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node)=>{
                        if (node instanceof HTMLElement) {
                            if (this.ssrPlaceholderHandler.isPlaceholder(node)) {
                                this.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignored);
                                });
                                return;
                            }
                            if (this.ssrPlaceholderHandler.isPlaceholderReplacement(node)) {
                                this.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignored);
                                });
                                return;
                            }
                            this.observeElement(node, mutation, 'html', ignored);
                        }
                        if (node instanceof Text && node.parentElement != null) this.observeElement(node.parentElement, mutation, 'text', ignored);
                    });
                    mutation.removedNodes.forEach((node)=>{
                        if (node instanceof Element) {
                            this.elementsInView.delete(node);
                            this.intersectionObserver?.unobserve(node);
                        }
                    });
                } else if (mutation.type === 'attributes') mutation.addedNodes.forEach((node)=>{
                    if (node instanceof HTMLElement) this.observeElement(node, mutation, 'attr', ignored);
                });
            });
            this.measureStop();
        });
    }
    getElementName(element) {
        try {
            const tagName = element.localName;
            const dataVCAttr = element.getAttribute('data-vc');
            const dataVC = this.selectorConfig.dataVC && dataVCAttr ? `[data-vc="${dataVCAttr}"]` : '';
            const id = this.selectorConfig.id && element.id ? `#${element.id}` : '';
            let testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
            testId = testId ? `[testid=${testId}]` : '';
            let role = this.selectorConfig.role ? element.getAttribute('role') : '';
            role = role ? `[role=${role}]` : '';
            let classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
            classList = classList === '' ? '' : `.${classList}`;
            const attrs = dataVC ? dataVC : [
                id,
                testId,
                role
            ].join('');
            let idString = '';
            if (attrs === '' && classList === '') {
                const parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                idString = `${parent} > ${tagName}`;
            } else idString = [
                tagName,
                attrs || classList
            ].join('');
            return idString;
        } catch (e) {
            return 'error';
        }
    }
    getIntersectionObserver() {
        return new IntersectionObserver((entries)=>{
            this.measureStart();
            entries.forEach(({ isIntersecting: isIntersecting, intersectionRect: ir, target: target })=>{
                const data = this.observedMutations.get(target);
                this.observedMutations.delete(target);
                if (isIntersecting && ir.width > 0 && ir.height > 0) {
                    if (!(target instanceof HTMLElement)) return;
                    if (!data?.mutation) // ignore intersection report without recent mutation
                    return;
                    this.callbacks.forEach((callback)=>{
                        let elementName;
                        try {
                            elementName = this.getElementName(target);
                        } catch (e) {
                            elementName = 'error';
                        }
                        callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.ignored);
                    });
                    this.elementsInView.add(target);
                } else this.elementsInView.delete(target);
            });
            this.measureStop();
        });
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
}

});
parcelRegister("lF6TV", function(module, exports) {

$parcel$export(module.exports, "SSRPlaceholderHandlers", () => $cd4e8fff45985f92$export$c0102f1a1198d10f);
class $cd4e8fff45985f92$export$c0102f1a1198d10f {
    constructor(){
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
        this.intersectionObserverCallback = ({ target: target, boundingClientRect: boundingClientRect })=>{
            this.intersectionObserver.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            const staticKey = target.dataset.ssrPlaceholder || '';
            if (staticKey) {
                if (this.staticPlaceholders.has(staticKey) && this.callbacks.has(staticKey)) {
                    // validation
                    const resolve = this.callbacks.get(staticKey);
                    if (!resolve) return;
                    const rect = this.staticPlaceholders.get(staticKey);
                    const hasSameSizePosition = rect && rect.x === boundingClientRect.x && rect.y === boundingClientRect.y && rect.width === boundingClientRect.width && rect.height === boundingClientRect.height || false;
                    resolve(hasSameSizePosition);
                    this.callbacks.delete(staticKey);
                } else // initial check
                this.setSizeOfStaticElement(target, boundingClientRect);
            } else {
                // react component check
                const key = target.dataset.ssrPlaceholderReplace || '';
                const resolve = this.reactValidateCallbacks.get(key);
                if (!resolve) return;
                const rect = this.staticPlaceholders.get(key);
                const hasSameSizePosition = rect && rect.x === boundingClientRect.x && rect.y === boundingClientRect.y && rect.width === boundingClientRect.width && rect.height === boundingClientRect.height || false;
                resolve(hasSameSizePosition);
                this.staticPlaceholders.delete(staticKey);
                this.reactValidateCallbacks.delete(staticKey);
            }
        };
        this.intersectionObserver = new IntersectionObserver((entries)=>entries.forEach(this.intersectionObserverCallback));
        if (window.document) try {
            const existingElements = document.querySelectorAll('[data-ssr-placeholder]');
            existingElements.forEach((el)=>{
                if (el instanceof HTMLElement && el?.dataset?.ssrPlaceholder) {
                    this.staticPlaceholders.set(el.dataset.ssrPlaceholder, {
                        width: -1,
                        height: -1,
                        x: -1,
                        y: -1
                    });
                    this.intersectionObserver.observe(el);
                }
            });
        } catch (e) {}
    }
    clear() {
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
    }
    isPlaceholder(element) {
        return !!element.dataset.ssrPlaceholder;
    }
    isPlaceholderReplacement(element) {
        return !!element.dataset.ssrPlaceholderReplace;
    }
    checkIfExistedAndSizeMatching(el) {
        const id = el.dataset.ssrPlaceholder || '';
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.callbacks.set(id, resolve);
                this.intersectionObserver.observe(el);
            }
        });
    }
    getSize(el) {
        return new Promise((resolve)=>{
            this.getSizeCallbacks.set(el.dataset.ssrPlaceholder || '', resolve);
            this.intersectionObserver.observe(el);
        });
    }
    setSizeOfStaticElement(el, boundingClientRect) {
        const key = el.dataset.ssrPlaceholder || '';
        const entry = this.staticPlaceholders.get(key);
        if (!entry) return;
        this.staticPlaceholders.set(key, {
            x: boundingClientRect.x,
            y: boundingClientRect.y,
            width: boundingClientRect.width,
            height: boundingClientRect.height
        });
    }
    validateReactComponentMatchToPlaceholder(el) {
        const id = el.dataset.ssrPlaceholderReplace || '';
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.reactValidateCallbacks.set(id, resolve);
                this.intersectionObserver.observe(el);
            }
        });
    }
}

});




parcelRegister("hV9Mh", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b785915e5f06a7d$export$2e2bcd8739ae039);
const $2b785915e5f06a7d$var$interactions = new Map();
var $2b785915e5f06a7d$export$2e2bcd8739ae039 = $2b785915e5f06a7d$var$interactions;

});


parcelRegister("fOcYr", function(module, exports) {

$parcel$export(module.exports, "eventDataProcessor", () => $51a4e67b3315075e$export$896b6e121bbaec25);

var $b7nlA = parcelRequire("b7nlA");

var $ayvjR = parcelRequire("ayvjR");

var $gkLmF = parcelRequire("gkLmF");

var $foG86 = parcelRequire("foG86");

var $gfyvc = parcelRequire("gfyvc");

var $8lsjq = parcelRequire("8lsjq");

var $4Qdaz = parcelRequire("4Qdaz");

var $fovub = parcelRequire("fovub");

var $bDTYv = parcelRequire("bDTYv");

var $k91RE = parcelRequire("k91RE");

var $fo1lc = parcelRequire("fo1lc");

var $76eD5 = parcelRequire("76eD5");

var $lmk7N = parcelRequire("lmk7N");

var $8T0Cl = parcelRequire("8T0Cl");

var $kOEIL = parcelRequire("kOEIL");

var $9TLoo = parcelRequire("9TLoo");

var $gimhN = parcelRequire("gimhN");

var $dktqK = parcelRequire("dktqK");

var $6O4AV = parcelRequire("6O4AV");

var $fBMiE = parcelRequire("fBMiE");

var $3IDjd = parcelRequire("3IDjd");

var $6GVIC = parcelRequire("6GVIC");

var $e7CH5 = parcelRequire("e7CH5");

var $2dMAM = parcelRequire("2dMAM");

var $gKdv5 = parcelRequire("gKdv5");

var $4tEF5 = parcelRequire("4tEF5");

var $72ax2 = parcelRequire("72ax2");

var $dTM4L = parcelRequire("dTM4L");

var $1RdI4 = parcelRequire("1RdI4");

var $geOpN = parcelRequire("geOpN");

var $jwDGp = parcelRequire("jwDGp");

var $47HSw = parcelRequire("47HSw");

var $eFmVe = parcelRequire("eFmVe");

var $ai6Yc = parcelRequire("ai6Yc");

var $8INP8 = parcelRequire("8INP8");

var $fhb4b = parcelRequire("fhb4b");

var $b5Sjr = parcelRequire("b5Sjr");
const $51a4e67b3315075e$var$defaultSet = [
    (0, $k91RE.eventKey),
    (0, $kOEIL.eventType),
    (0, $76eD5.eventProduct),
    (0, $8T0Cl.eventRoute),
    (0, $fovub.eventId),
    (0, $fo1lc.eventLocalTime),
    (0, $lmk7N.eventRegion),
    (0, $foG86.appFramework),
    (0, $gfyvc.appVersion),
    (0, $8lsjq.bmVersion),
    (0, $geOpN.telemetryBrowser),
    (0, $jwDGp.telemetryCpu),
    (0, $47HSw.telemetryMemory),
    (0, $eFmVe.telemetryNetwork),
    (0, $4Qdaz.customData),
    (0, $9TLoo.featureFlags),
    (0, $gimhN.hostname),
    (0, $72ax2.productCustomData),
    (0, $ai6Yc.appTimings),
    (0, $fhb4b.resourceTimings)
];
const $51a4e67b3315075e$var$pageLoadCommon = [
    ...$51a4e67b3315075e$var$defaultSet,
    (0, $gKdv5.pageVisibleState),
    (0, $4tEF5.pageVisibleValue),
    (0, $bDTYv.eventInitial),
    (0, $6GVIC.pageLoadMetrics),
    (0, $8INP8.bundleEvalTimings)
];
const $51a4e67b3315075e$var$initialPageLoadSet = [
    ...$51a4e67b3315075e$var$pageLoadCommon,
    (0, $6O4AV.initialPageLoadMetrics),
    (0, $3IDjd.navigationMetrics),
    (0, $1RdI4.ssrSuccess),
    (0, $dTM4L.ssrFeatureFlags)
];
const $51a4e67b3315075e$var$spaTransitionSet = [
    ...$51a4e67b3315075e$var$pageLoadCommon
];
const $51a4e67b3315075e$var$pageSegmentLoadSet = [
    ...$51a4e67b3315075e$var$defaultSet,
    (0, $e7CH5.pageSegmentLoadMetrics),
    (0, $gKdv5.pageVisibleState),
    (0, $4tEF5.pageVisibleValue),
    (0, $bDTYv.eventInitial),
    (0, $8INP8.bundleEvalTimings)
];
const $51a4e67b3315075e$var$interactionSet = [
    ...$51a4e67b3315075e$var$defaultSet,
    (0, $gKdv5.pageVisibleState),
    (0, $4tEF5.pageVisibleValue),
    (0, $fBMiE.interactionMetrics)
];
const $51a4e67b3315075e$var$customMetricSet = [
    ...$51a4e67b3315075e$var$defaultSet,
    (0, $gKdv5.pageVisibleState),
    (0, $4tEF5.pageVisibleValue),
    (0, $dktqK.customEventMetrics)
];
// pageVisibleState and pageVisibleValue has been handled within webVitalsMetrics.
const $51a4e67b3315075e$var$webVitalsMetricSet = [
    ...$51a4e67b3315075e$var$defaultSet,
    (0, $2dMAM.webVitalsMetrics)
];
// Function that returns a promise which resolves after clsWaitTimeMs + 500ms
// so that clsData is guaranteed to be attached to window
const $51a4e67b3315075e$var$waitForCLS = (delay = (0, $b7nlA.clsWaitTimeMs) + 500)=>{
    return new Promise((resolve)=>setTimeout(resolve, delay));
};
const $51a4e67b3315075e$export$896b6e121bbaec25 = async (globalConfig, data)=>{
    if (data.start === null || data.stop === null) {
        (0, $ayvjR.logger).log(`eventDataProcessor: Metric "${data.key}" start or stop are incorrect; start: ${data.start}; stop: ${data.stop}`);
        return null;
    }
    let set = [];
    if (data.config.type === (0, $b5Sjr.BMEventsType).PAGE_LOAD && (0, $gkLmF.isPageLoadMetricData)(data) && data.isInitial) set = $51a4e67b3315075e$var$initialPageLoadSet;
    if (data.config.type === (0, $b5Sjr.BMEventsType).PAGE_LOAD && (0, $gkLmF.isPageLoadMetricData)(data) && !data.isInitial) set = $51a4e67b3315075e$var$spaTransitionSet;
    if (data.config.type === (0, $b5Sjr.BMEventsType).PAGE_SEGMENT_LOAD && (0, $gkLmF.isPageSegmentLoadMetricData)(data)) set = $51a4e67b3315075e$var$pageSegmentLoadSet;
    if (data.config.type === (0, $b5Sjr.BMEventsType).INLINE_RESULT) set = $51a4e67b3315075e$var$interactionSet;
    if (data.config.type === (0, $b5Sjr.BMEventsType).CUSTOM) set = $51a4e67b3315075e$var$customMetricSet;
    if (data.config.type === (0, $b5Sjr.BMEventsType).WEB_VITALS) {
        set = $51a4e67b3315075e$var$webVitalsMetricSet;
        // Wait for CLS to be recorded before proceeding to run plugin and attach CLS data
        await $51a4e67b3315075e$var$waitForCLS();
    }
    //TODO if type is different - do not send at all
    const plugins = [];
    for (const plugin of set){
        const result = await plugin(data.config, data, globalConfig);
        if (result) plugins.push(result);
    }
    const pluginResults = await Promise.all(plugins);
    const generated = {};
    pluginResults.forEach((pluginResult)=>{
        if (pluginResult === null) return;
        Object.keys(pluginResult).forEach((key)=>{
            const keyResult = pluginResult[key];
            if (keyResult !== null && keyResult !== undefined) generated[key] = keyResult;
        });
    });
    return generated;
};

});
parcelRegister("gkLmF", function(module, exports) {

$parcel$export(module.exports, "isPageLoadMetricData", () => $2eafd62f3e9fa0bf$export$b0e12e7abb0bff11);
$parcel$export(module.exports, "isPageSegmentLoadMetricData", () => $2eafd62f3e9fa0bf$export$83d0099ee6dbb5b0);
$parcel$export(module.exports, "isPageLoadConfig", () => $2eafd62f3e9fa0bf$export$8672fa27ba8bba88);
$parcel$export(module.exports, "isPageSegmentLoadConfig", () => $2eafd62f3e9fa0bf$export$abe063537ef4987b);
$parcel$export(module.exports, "isInteractionConfig", () => $2eafd62f3e9fa0bf$export$ae68674b6a9353be);
$parcel$export(module.exports, "isCustomConfig", () => $2eafd62f3e9fa0bf$export$b493eb8b2ba87421);

var $b5Sjr = parcelRequire("b5Sjr");
const $2eafd62f3e9fa0bf$export$b0e12e7abb0bff11 = (data)=>{
    return data.type === (0, $b5Sjr.BMEventsType).PAGE_LOAD;
};
const $2eafd62f3e9fa0bf$export$83d0099ee6dbb5b0 = (data)=>{
    return data.type === (0, $b5Sjr.BMEventsType).PAGE_SEGMENT_LOAD;
};
const $2eafd62f3e9fa0bf$export$8672fa27ba8bba88 = (data)=>{
    return data.type === (0, $b5Sjr.BMEventsType).PAGE_LOAD;
};
const $2eafd62f3e9fa0bf$export$abe063537ef4987b = (data)=>{
    return data.type === (0, $b5Sjr.BMEventsType).PAGE_SEGMENT_LOAD;
};
const $2eafd62f3e9fa0bf$export$ae68674b6a9353be = (data)=>{
    return data.type === (0, $b5Sjr.BMEventsType).INLINE_RESULT;
};
const $2eafd62f3e9fa0bf$export$b493eb8b2ba87421 = (data)=>{
    return data.type === (0, $b5Sjr.BMEventsType).CUSTOM;
};

});

parcelRegister("foG86", function(module, exports) {

$parcel$export(module.exports, "appFramework", () => $1efa084420e663c4$export$e34e4529b979f74c);
const $1efa084420e663c4$export$e34e4529b979f74c = (_config, _data, globalConfig)=>{
    if (!globalConfig.app.framework) return null;
    return {
        'app:framework:name': globalConfig.app.framework.name,
        'app:framework:version': globalConfig.app.framework.version
    };
};

});

parcelRegister("gfyvc", function(module, exports) {

$parcel$export(module.exports, "appVersion", () => $4a3086ae07326b41$export$82ae485178b37419);
const $4a3086ae07326b41$export$82ae485178b37419 = (_config, _data, globalConfig)=>{
    const pluginData = {
        'app:web:version': globalConfig.app.version.web
    };
    if (globalConfig.app.version.ssr) pluginData['app:ssr:version'] = globalConfig.app.version.ssr;
    return pluginData;
};

});

parcelRegister("8lsjq", function(module, exports) {

$parcel$export(module.exports, "bmVersion", () => $d8645d49def49b76$export$5cafa465fc876895);
const $d8645d49def49b76$export$5cafa465fc876895 = ()=>{
    return {
        'bm:version': 3
    };
};

});

parcelRegister("4Qdaz", function(module, exports) {

$parcel$export(module.exports, "customData", () => $5a3182bbbb64b8ab$export$f7e743c7db162193);
const $5a3182bbbb64b8ab$export$f7e743c7db162193 = (_config, data)=>{
    const custom = {};
    let changed = false;
    if (data.custom) Object.entries(data.custom).forEach(([key, value])=>{
        changed = true;
        custom[`custom:${key}`] = value;
    });
    return changed ? custom : null;
};

});

parcelRegister("fovub", function(module, exports) {

$parcel$export(module.exports, "eventId", () => $82e200d75462a7e8$export$aed28df7ac07d79a);
const $82e200d75462a7e8$export$aed28df7ac07d79a = (config)=>{
    return {
        'event:id': config.key
    };
};

});

parcelRegister("bDTYv", function(module, exports) {

$parcel$export(module.exports, "eventInitial", () => $ab8c1dbbedd1cae7$export$fa8e91d436b3ef8b);

var $gkLmF = parcelRequire("gkLmF");
const $ab8c1dbbedd1cae7$export$fa8e91d436b3ef8b = (_config, data)=>{
    if (!(0, $gkLmF.isPageLoadMetricData)(data) && !(0, $gkLmF.isPageSegmentLoadMetricData)(data)) return null;
    return {
        'event:initial': data.isInitial
    };
};

});

parcelRegister("k91RE", function(module, exports) {

$parcel$export(module.exports, "eventKey", () => $aa4e9b814d71c0be$export$10be2d3a558d3f88);

var $2K6Sm = parcelRequire("2K6Sm");
const $aa4e9b814d71c0be$export$10be2d3a558d3f88 = (config, _data, globalConfig)=>{
    return {
        'event:key': `${globalConfig.product}.fe.${(0, $2K6Sm.mapEventType)(config.type)}.${config.key}`
    };
};

});
parcelRegister("2K6Sm", function(module, exports) {

$parcel$export(module.exports, "mapEventType", () => $a732dcf995a0244f$export$b334d07f11140768);

var $b5Sjr = parcelRequire("b5Sjr");
const $a732dcf995a0244f$export$b334d07f11140768 = (type)=>{
    switch(type){
        case (0, $b5Sjr.BMEventsType).CUSTOM:
            return (0, $b5Sjr.StorableBMEventsType).CUSTOM;
        case (0, $b5Sjr.BMEventsType).INLINE_RESULT:
            return (0, $b5Sjr.StorableBMEventsType).INLINE_RESULT;
        case (0, $b5Sjr.BMEventsType).PAGE_LOAD:
            return (0, $b5Sjr.StorableBMEventsType).PAGE_LOAD;
        case (0, $b5Sjr.BMEventsType).PAGE_SEGMENT_LOAD:
            return (0, $b5Sjr.StorableBMEventsType).PAGE_SEGMENT_LOAD;
        case (0, $b5Sjr.BMEventsType).WEB_VITALS:
            return (0, $b5Sjr.StorableBMEventsType).WEB_VITALS;
        default:
            return 'unknown';
    }
};

});


parcelRegister("fo1lc", function(module, exports) {

$parcel$export(module.exports, "eventLocalTime", () => $10e1381172856c3e$export$5219854ae7ec45da);

var $EN9B6 = parcelRequire("EN9B6");
const $10e1381172856c3e$export$5219854ae7ec45da = ()=>({
        'event:localHour': parseInt((0, $EN9B6.default)(new Date(), 'H'), 10),
        'event:localDayOfWeek': parseInt((0, $EN9B6.default)(new Date(), 'i'), 10)
    });

});

parcelRegister("76eD5", function(module, exports) {

$parcel$export(module.exports, "eventProduct", () => $b618e7909b9cd9cb$export$a7df4e8088db8843);
const $b618e7909b9cd9cb$export$a7df4e8088db8843 = (_config, _data, globalConfig)=>{
    return {
        'event:product': `${globalConfig.product}`
    };
};

});

parcelRegister("lmk7N", function(module, exports) {

$parcel$export(module.exports, "eventRegion", () => $f8070b7d71e9570c$export$d0117b71adcdebc0);
const $f8070b7d71e9570c$export$d0117b71adcdebc0 = (_config, _data, globalConfig)=>{
    return {
        'event:region': `${globalConfig.region}`
    };
};

});

parcelRegister("8T0Cl", function(module, exports) {

$parcel$export(module.exports, "eventRoute", () => $6c05def811f796b5$export$44d3627af289ca16);
const $6c05def811f796b5$export$44d3627af289ca16 = (_config, data)=>{
    if (!data.route) return null;
    return {
        'event:route': data.route
    };
};

});

parcelRegister("kOEIL", function(module, exports) {

$parcel$export(module.exports, "eventType", () => $0bdf49a8a37bc1f4$export$4c045e605d532c98);

var $2K6Sm = parcelRequire("2K6Sm");
const $0bdf49a8a37bc1f4$export$4c045e605d532c98 = (config)=>{
    return {
        'event:type': (0, $2K6Sm.mapEventType)(config.type)
    };
};

});

parcelRegister("9TLoo", function(module, exports) {

$parcel$export(module.exports, "featureFlags", () => $b7e67523e42b593a$export$e62953d023125748);
const $b7e67523e42b593a$export$e62953d023125748 = (config, _data, globalConfig)=>{
    const localFeatureFlags = config.featureFlags?.reduce((acc, ffName)=>{
        acc[ffName] = globalConfig.ffClient.getValue(ffName);
        return acc;
    }, {}) || null;
    if ((!globalConfig.featureFlags || Object.keys(globalConfig.featureFlags).length === 0) && (!localFeatureFlags || Object.keys(localFeatureFlags).length === 0)) return null;
    return {
        featureFlags: {
            ...localFeatureFlags,
            ...globalConfig.featureFlags
        }
    };
};

});

parcelRegister("gimhN", function(module, exports) {

$parcel$export(module.exports, "hostname", () => $63d7441bc99d3c46$export$640106f6dc7d2706);
const $63d7441bc99d3c46$export$640106f6dc7d2706 = (_config, _data, globalConfig)=>{
    return {
        hostname: globalConfig.hostname
    };
};

});

parcelRegister("dktqK", function(module, exports) {

$parcel$export(module.exports, "customEventMetrics", () => $450413befd594bef$export$cab039265c52a2e9);

var $gkLmF = parcelRequire("gkLmF");
const $450413befd594bef$export$cab039265c52a2e9 = (config, data, globalConfig)=>{
    if (!(0, $gkLmF.isCustomConfig)(config)) return null;
    const payload = {
        'metric:duration': Math.round(data.stop - data.start)
    };
    if (config.slo?.threshold !== undefined) {
        payload['metric:duration:slo'] = payload['metric:duration'] <= config.slo?.threshold;
        payload['metric:duration:slo:threshold'] = config.slo?.threshold;
    }
    if (config.histogram?.duration) payload['metric:duration:histogramBuckets'] = config.histogram.duration;
    else if (globalConfig.histogram) payload['metric:duration:histogramBuckets'] = globalConfig.histogram.duration;
    return payload;
};

});

parcelRegister("6O4AV", function(module, exports) {

$parcel$export(module.exports, "initialPageLoadMetrics", () => $9ef5e47946085112$export$cc95aa3f6ea8e5cb);
const $9ef5e47946085112$export$cc95aa3f6ea8e5cb = ()=>{
    const metrics = {};
    performance.getEntriesByType('paint').forEach((entry)=>{
        if (entry.name === 'first-paint') metrics['metric:fp'] = Math.round(entry.startTime);
        if (entry.name === 'first-contentful-paint') metrics['metric:fcp'] = Math.round(entry.startTime);
    });
    return metrics;
};

});

parcelRegister("fBMiE", function(module, exports) {

$parcel$export(module.exports, "interactionMetrics", () => $000e501904fafac4$export$86db56030b57ba34);

var $gkLmF = parcelRequire("gkLmF");

var $b5Sjr = parcelRequire("b5Sjr");
const $000e501904fafac4$export$86db56030b57ba34 = (config, data, globalConfig)=>{
    if (!(0, $gkLmF.isInteractionConfig)(config)) return null;
    const result = {
        'metric:result': Math.round(data.stop - data.start)
    };
    if (config.histogram?.result) result['metric:result:histogramBuckets'] = config.histogram.result;
    else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        if (histogram.result !== undefined) result['metric:result:histogramBuckets'] = histogram[(0, $b5Sjr.BMInteractionMetrics).result];
    }
    if (config.slo && (0, $b5Sjr.isInteractionMetricsSlo)(config.slo) && config.slo.result) {
        result['metric:result:slo'] = result['metric:result'] <= config.slo.result.threshold;
        result['metric:result:slo:threshold'] = config.slo.result.threshold;
    }
    if (data.marks['feedback']) {
        result['metric:response'] = Math.round((data.marks['feedback'] || data.stop) - data.start);
        if (config.histogram?.response) result['metric:response:histogramBuckets'] = config.histogram[(0, $b5Sjr.BMInteractionMetrics).response];
        else if (globalConfig.histogram) {
            const histogram = globalConfig.histogram;
            if (histogram.result !== undefined) result['metric:response:histogramBuckets'] = histogram[(0, $b5Sjr.BMInteractionMetrics).response];
        }
        if (config.slo && (0, $b5Sjr.isInteractionMetricsSlo)(config.slo) && config.slo.response) {
            result['metric:response:slo'] = result['metric:response'] <= config.slo.response.threshold;
            result['metric:response:slo:threshold'] = config.slo.response.threshold;
        }
    }
    return result;
};

});

parcelRegister("3IDjd", function(module, exports) {

$parcel$export(module.exports, "navigationMetrics", () => $683323a016484933$export$b88d990436be0f8a);
const $683323a016484933$export$b88d990436be0f8a = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("6GVIC", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetrics", () => $2015b145068e5231$export$2878bf482e539059);

var $gkLmF = parcelRequire("gkLmF");

var $b5Sjr = parcelRequire("b5Sjr");
const $2015b145068e5231$var$getThreshold = (isInitial, metric)=>{
    return (0, $b5Sjr.isDetailedPageLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
const $2015b145068e5231$var$getHistogram = (isInitial, metric, histogram)=>{
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
const $2015b145068e5231$export$2878bf482e539059 = (config, data, globalConfig)=>{
    if (!(0, $gkLmF.isPageLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page load data for non-page-load config');
    const fmp = data.marks[(0, $b5Sjr.BMPageLoadMetrics).fmp] || data.stop;
    const result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $2015b145068e5231$var$getHistogram(data.isInitial, (0, $b5Sjr.BMPageLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $2015b145068e5231$var$getHistogram(data.isInitial, (0, $b5Sjr.BMPageLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $2015b145068e5231$var$getHistogram(data.isInitial, (0, $b5Sjr.BMPageLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $2015b145068e5231$var$getHistogram(data.isInitial, (0, $b5Sjr.BMPageLoadMetrics).tti, histogram);
    }
    if (config.slo && config.slo.fmp) {
        const threshold = $2015b145068e5231$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if (config.slo && config.slo.tti) {
        const threshold = $2015b145068e5231$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= threshold;
        result['metric:tti:slo:threshold'] = threshold;
    }
    return result;
};

});

parcelRegister("e7CH5", function(module, exports) {

$parcel$export(module.exports, "pageSegmentLoadMetrics", () => $d4afe7dea853373e$export$ba86cb47f2f22db5);

var $5Bdpp = parcelRequire("5Bdpp");

var $gkLmF = parcelRequire("gkLmF");

var $b5Sjr = parcelRequire("b5Sjr");
const $d4afe7dea853373e$var$getThreshold = (isInitial, metric)=>{
    return (0, $b5Sjr.isDetailedPageSegmentLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
const $d4afe7dea853373e$var$getHistogram = (isInitial, metric, histogram)=>{
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
const $d4afe7dea853373e$export$ba86cb47f2f22db5 = (config, data, globalConfig)=>{
    if (!(0, $gkLmF.isPageSegmentLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page segment load data for non-page-segment-load config');
    const fmp = data.marks[(0, $b5Sjr.BMPageSegmentLoadMetrics).fmp] || data.stop;
    const result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $d4afe7dea853373e$var$getHistogram(data.isInitial, (0, $b5Sjr.BMPageSegmentLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $d4afe7dea853373e$var$getHistogram(data.isInitial, (0, $b5Sjr.BMPageSegmentLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $d4afe7dea853373e$var$getHistogram(data.isInitial, (0, $b5Sjr.BMPageSegmentLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $d4afe7dea853373e$var$getHistogram(data.isInitial, (0, $b5Sjr.BMPageSegmentLoadMetrics).tti, histogram);
    }
    if (config.slo?.fmp) {
        const threshold = $d4afe7dea853373e$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if (config.slo?.tti) {
        const threshold = $d4afe7dea853373e$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= threshold;
        result['metric:tti:slo:threshold'] = threshold;
    }
    if (config.includePageLoadTimings === (0, $b5Sjr.PageSegmentPageLoadMetricsOptions).IF_PRESENT || config.includePageLoadTimings === (0, $b5Sjr.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT) {
        const pageLoadData = (0, $5Bdpp.pageLoadMetaMetric).getData();
        const fmp = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round((pageLoadData.marks[(0, $b5Sjr.BMPageLoadMetrics).fmp] || pageLoadData.stop) - pageLoadData.start) : null;
        const tti = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round(pageLoadData.stop - pageLoadData.start) : null;
        result['pageLoad'] = {
            fmp: fmp,
            tti: tti
        };
    }
    return result;
};

});

parcelRegister("2dMAM", function(module, exports) {

$parcel$export(module.exports, "webVitalsMetrics", () => $f739e8ec57ca87be$export$3731db279f590f30);

var $csrXc = parcelRequire("csrXc");

var $au6tI = parcelRequire("au6tI");

var $67ejG = parcelRequire("67ejG");

var $4tEF5 = parcelRequire("4tEF5");
const $f739e8ec57ca87be$export$3731db279f590f30 = async (config, data, globalConfig)=>{
    let pageVisibleState = data.pageVisibleState;
    const setPageVisibleStateToMixed = ()=>{
        pageVisibleState = (0, $csrXc.PageVisibleState).MIXED;
    };
    (0, $au6tI.visibilityChangeObserver).subscribe(setPageVisibleStateToMixed);
    const ttciEnabled = globalConfig.webVitals?.ttciEnabled !== undefined ? globalConfig.webVitals?.ttciEnabled : true;
    const webVitalMetrics = await $f739e8ec57ca87be$export$193ae490b52081dd(ttciEnabled, globalConfig.webVitals?.timeout || 30000);
    (0, $au6tI.visibilityChangeObserver).unsubscribe(setPageVisibleStateToMixed);
    return {
        ...webVitalMetrics,
        'pageVisible:state': pageVisibleState,
        ...(0, $4tEF5.pageVisibleValue)(config, data, globalConfig)
    };
};
const $f739e8ec57ca87be$export$193ae490b52081dd = async (ttciEnabled, timeout)=>{
    // wait for webVitalsObserver.ttciDetermined if ttciEnabled is true
    await (ttciEnabled ? (0, $67ejG.webVitalsObserver).ttciDetermined : Promise.resolve());
    // wait up to $timeout ms longer for web-vitals until returning
    const timeoutWindow = new Promise((resolve)=>setTimeout(resolve, timeout));
    await Promise.race([
        timeoutWindow,
        (0, $67ejG.webVitalsObserver).webVitalsDetermined
    ]);
    return (0, $67ejG.webVitalsObserver).data;
};

});
parcelRegister("4tEF5", function(module, exports) {

$parcel$export(module.exports, "pageVisibleValue", () => $b7848b16843e72bb$export$177b923114656380);

var $csrXc = parcelRequire("csrXc");
var $b5Sjr = parcelRequire("b5Sjr");
const $b7848b16843e72bb$export$177b923114656380 = (_config, data, globalConfig)=>{
    const value = globalConfig.pageVisibleValueOrigin === (0, $b5Sjr.PageVisibleValueOrigin).documentHidden ? !document.hidden || false : data.pageVisibleState === (0, $csrXc.PageVisibleState).VISIBLE;
    return {
        'pageVisible:value': value
    };
};

});


parcelRegister("gKdv5", function(module, exports) {

$parcel$export(module.exports, "pageVisibleState", () => $817fc5d28e12a40a$export$723b4c298aca63af);
const $817fc5d28e12a40a$export$723b4c298aca63af = (_config, data)=>{
    return {
        'pageVisible:state': data.pageVisibleState
    };
};

});

parcelRegister("72ax2", function(module, exports) {

$parcel$export(module.exports, "productCustomData", () => $c80cbc7ceae5b7a1$export$fa2af6e412815a74);
const $c80cbc7ceae5b7a1$export$fa2af6e412815a74 = async (_config, data, globalConfig)=>{
    if (!globalConfig.custom && !globalConfig.plugins) return null;
    const result = {};
    if (globalConfig.custom) Object.entries(globalConfig.custom).forEach(([key, value])=>{
        result[`${globalConfig.product}:${key}`] = value;
    });
    if (globalConfig.plugins) {
        const pluginOutputs = await Promise.all(globalConfig.plugins.map((plugin)=>plugin({
                start: data.start,
                stop: data.stop,
                key: data.key
            })));
        pluginOutputs.forEach((pluginOutput)=>{
            if (pluginOutput === null) return;
            Object.entries(pluginOutput).forEach(([key, value])=>{
                result[`${globalConfig.product}:${key}`] = value;
            });
        });
    }
    return result;
};

});

parcelRegister("dTM4L", function(module, exports) {

$parcel$export(module.exports, "ssrFeatureFlags", () => $5289acc51fffd4ab$export$fdbea518c19dfa8);

var $b5Sjr = parcelRequire("b5Sjr");
const $5289acc51fffd4ab$var$retrieveFeatureFlags = async (getFeatureFlags)=>{
    try {
        const featureFlags = await getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};
const $5289acc51fffd4ab$export$fdbea518c19dfa8 = async (config, _data, globalConfig)=>{
    // no config or missing
    if (!globalConfig.ssr?.getFeatureFlags) return null;
    const includeFeatureFlags = config.ssr?.includeFeatureFlags || globalConfig.ssr?.includeFeatureFlags || (0, $b5Sjr.IncludeSSRFeatureFlagsConfig).WHEN_FMP;
    if (includeFeatureFlags === (0, $b5Sjr.IncludeSSRFeatureFlagsConfig).WHEN_AVAILABLE || config.ssr?.doneAsFmp && includeFeatureFlags === (0, $b5Sjr.IncludeSSRFeatureFlagsConfig).WHEN_FMP) return await $5289acc51fffd4ab$var$retrieveFeatureFlags(globalConfig.ssr.getFeatureFlags);
    return null;
};

});

parcelRegister("1RdI4", function(module, exports) {

$parcel$export(module.exports, "ssrSuccess", () => $05e4709ddb7a057d$export$a3dc8251cf55b2e0);
const $05e4709ddb7a057d$export$a3dc8251cf55b2e0 = (config, _data, globalConfig)=>{
    if (config.ssr && config.ssr.doneAsFmp && globalConfig.ssr && globalConfig.ssr.getDoneMark && globalConfig.ssr.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("geOpN", function(module, exports) {

$parcel$export(module.exports, "telemetryBrowser", () => $af924ee45c872ef0$export$386b10ac64a50b1);

var $amtAu = parcelRequire("amtAu");
const $af924ee45c872ef0$export$386b10ac64a50b1 = ()=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($amtAu))).getParser) return null;
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($amtAu))).getParser(window.navigator.userAgent);
    return {
        'telemetry:browser:name': browser.getBrowserName(),
        'telemetry:browser:version': browser.getBrowserVersion()
    };
};

});

parcelRegister("jwDGp", function(module, exports) {

$parcel$export(module.exports, "telemetryCpu", () => $75d0d71228b506e1$export$9f84cb359ed29139);
const $75d0d71228b506e1$export$9f84cb359ed29139 = ()=>{
    if (!navigator.hardwareConcurrency) return null;
    return {
        'telemetry:cpus': navigator.hardwareConcurrency
    };
};

});

parcelRegister("47HSw", function(module, exports) {

$parcel$export(module.exports, "telemetryMemory", () => $15cc079cfaf11a15$export$496c14d72b257e07);
const $15cc079cfaf11a15$export$496c14d72b257e07 = ()=>{
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'telemetry:memory': navigator.deviceMemory
    };
};

});

parcelRegister("eFmVe", function(module, exports) {

$parcel$export(module.exports, "telemetryNetwork", () => $3135d59ccc7848f2$export$88bf7b55f7fc4e8e);
const $3135d59ccc7848f2$export$88bf7b55f7fc4e8e = ()=>{
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("ai6Yc", function(module, exports) {

$parcel$export(module.exports, "appTimings", () => $b6ebcd4948c744e0$export$e952f50a4f2d02da);

var $b5Sjr = parcelRequire("b5Sjr");

var $1tZ1d = parcelRequire("1tZ1d");

var $fXBcU = parcelRequire("fXBcU");
const $b6ebcd4948c744e0$export$e952f50a4f2d02da = (config, data, globalConfig)=>{
    const explicitTimings = config.type === (0, $b5Sjr.BMEventsType).PAGE_LOAD && data.explicitTimings || null;
    const timings = (0, $1tZ1d.customTimings)(config, data);
    const ssr = config.type === (0, $b5Sjr.BMEventsType).PAGE_LOAD && data.isInitial ? (0, $fXBcU.ssrTimings)(config, data, globalConfig) : null;
    const timingsApp = (explicitTimings || timings || ssr) && {
        ...explicitTimings,
        ...timings,
        ...ssr
    };
    if (!timingsApp) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("1tZ1d", function(module, exports) {

$parcel$export(module.exports, "customTimings", () => $15f8932323853905$export$6126f85083a72c6e);

const $15f8932323853905$var$retrieveTimings = (config, data, relativeTo = 0, prefix = '')=>{
    const configTimings = config.timings || [];
    const timings = configTimings.reduce((entries, timing)=>{
        if (timing.startMark && !data.marks[timing.startMark]) return entries;
        if (timing.endMark && !data.marks[timing.endMark]) return entries;
        if (data.start === null || data.stop === null) return null;
        const startTime = Math.round((data.marks[timing.startMark] !== undefined ? data.marks[timing.startMark] : data.start) - data.start + relativeTo);
        const duration = Math.round((data.marks[timing.endMark] !== undefined ? data.marks[timing.endMark] : data.stop) - data.start - startTime + relativeTo);
        entries[`${prefix}${timing.key}`] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
const $15f8932323853905$export$6126f85083a72c6e = (config, data)=>{
    if (!config.timings && data.submetrics.length === 0) return null;
    const timings = $15f8932323853905$var$retrieveTimings(config, data);
    data.submetrics.forEach((submetric)=>{
        if (submetric.start !== null && submetric.stop !== null) {
            const submetricPrefix = `include:${submetric.config.key}`;
            timings[submetricPrefix] = {
                startTime: Math.round(submetric.start - data.start),
                duration: Math.round(submetric.stop - submetric.start)
            };
            Object.assign(timings, $15f8932323853905$var$retrieveTimings(submetric.config, submetric, submetric.start - data.start, submetricPrefix + (0, $2005e07c976eea8a$export$b98e411ae80c806f)));
        }
    });
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});
const $2005e07c976eea8a$export$b98e411ae80c806f = '/';


parcelRegister("fXBcU", function(module, exports) {

$parcel$export(module.exports, "ssrTimings", () => $0b04c31063c972ff$export$130f411261a599c5);

const $0b04c31063c972ff$var$filterEntry = (entry)=>{
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
const $0b04c31063c972ff$var$mapEntry = (entry)=>{
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
const $0b04c31063c972ff$var$SSR_PREFIX = 'ssr';
const $0b04c31063c972ff$var$mapKey = (key)=>{
    if (key === 'total') return $0b04c31063c972ff$var$SSR_PREFIX;
    return `${$0b04c31063c972ff$var$SSR_PREFIX}${0, $2005e07c976eea8a$export$b98e411ae80c806f}${key}`;
};
const $0b04c31063c972ff$export$130f411261a599c5 = (_config, _data, globalConfig)=>{
    if (!globalConfig.ssr || !globalConfig.ssr.getTimings) return null;
    const timings = globalConfig.ssr.getTimings();
    if (!timings) return null;
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($0b04c31063c972ff$var$filterEntry(entry[1])) acc[$0b04c31063c972ff$var$mapKey(entry[0])] = $0b04c31063c972ff$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});


parcelRegister("8INP8", function(module, exports) {

$parcel$export(module.exports, "bundleEvalTimings", () => $b8d13f03293bacc3$export$1a2bb347935fc536);
const $b8d13f03293bacc3$var$bundleEvalTimingsInternal = (_config, data, globalConfig, performance = window.performance)=>{
    const started = {};
    const timings = {};
    const enableBundleEvalTimings = globalConfig?.enableBundleEvalTimings ?? true;
    performance.getEntriesByType('mark').forEach((mark)=>{
        if (!globalConfig.bundleEvalTimings) return;
        const result = globalConfig.bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result) return;
        const { type: type, name: name } = result;
        if (type === 'start' && data.start !== null && mark.startTime >= data.start) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.start),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (globalConfig.bundleEvalTimings && globalConfig.bundleEvalTimings.additionalTimings && data.start !== null && enableBundleEvalTimings) {
        const result = globalConfig.bundleEvalTimings.additionalTimings(data.start);
        if (result) Object.entries(result).forEach(([key, value])=>{
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};
const $b8d13f03293bacc3$export$1a2bb347935fc536 = (...args)=>{
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve($b8d13f03293bacc3$var$bundleEvalTimingsInternal(...args));
        });
    });
};

});

parcelRegister("fhb4b", function(module, exports) {

$parcel$export(module.exports, "resourceTimings", () => $50211f4337764418$export$81a7d52441a06b50);
const $50211f4337764418$var$cacheableTypes = [
    'script',
    'link'
];
const $50211f4337764418$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $50211f4337764418$var$CACHE_NETWORK = 'network';
const $50211f4337764418$var$CACHE_MEMORY = 'memory';
const $50211f4337764418$var$CACHE_DISK = 'disk';
const $50211f4337764418$var$calculateTransferType = (type, duration, size)=>{
    if (!$50211f4337764418$var$cacheableTypes.includes(type)) return $50211f4337764418$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $50211f4337764418$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $50211f4337764418$var$CACHE_DISK;
    if (size === undefined) return null;
    return $50211f4337764418$var$CACHE_NETWORK;
};
const $50211f4337764418$var$hasAccessToResourceSize = (url, type, hasTimingHeaders)=>{
    return !$50211f4337764418$var$cacheableTypes.includes(type) || url.includes('localhost') || url.includes(window.location.hostname) || hasTimingHeaders(url);
};
const $50211f4337764418$var$getReportedInitiatorTypes = (xhrEnabled)=>{
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
const $50211f4337764418$var$withoutHeaders = ()=>false;
const $50211f4337764418$var$evaluateAccessToResourceTimings = (entry)=>{
    if (entry.responseStart === 0 && entry.startTime > entry.responseStart) return false;
    return true;
};
const $50211f4337764418$var$getEvaluatedTimingHeader = (entry, enabled = false, hasTimingHeaders = $50211f4337764418$var$withoutHeaders)=>{
    if (!enabled) return null;
    const manualResolution = entry.name.includes('localhost') || entry.name.includes(window.location.hostname) || hasTimingHeaders(entry.name);
    const autoResolution = $50211f4337764418$var$evaluateAccessToResourceTimings(entry);
    return {
        m_h: manualResolution,
        a_h: autoResolution
    };
};
const $50211f4337764418$var$getSizeObject = (size)=>size !== undefined ? {
        size: size
    } : null;
const $50211f4337764418$var$getNetworkData = (item, eventStart, hasTimingHeaders = $50211f4337764418$var$withoutHeaders)=>{
    const { name: name, duration: duration, transferSize: size, initiatorType: type, responseStart: responseStart } = item;
    const ttfb = Math.round(responseStart - eventStart);
    if (!$50211f4337764418$var$hasAccessToResourceSize(name, type, hasTimingHeaders)) return {};
    if ($50211f4337764418$var$cacheableTypes.includes(type)) {
        const transferType = $50211f4337764418$var$calculateTransferType(type, duration, size);
        if (!transferType) return {
            ttfb: ttfb,
            ...$50211f4337764418$var$getSizeObject(size)
        };
        if (transferType !== $50211f4337764418$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return {
            ttfb: ttfb,
            transferType: transferType,
            ...$50211f4337764418$var$getSizeObject(size)
        };
    }
    return {
        ttfb: ttfb,
        ...$50211f4337764418$var$getSizeObject(size)
    };
};
const $50211f4337764418$export$81a7d52441a06b50 = (_config, data, globalConfig, performance = window.performance)=>{
    if (data.start === null) return null;
    const resources = performance.getEntriesByType('resource').filter((entry)=>entry.startTime >= data.start);
    if (!resources.length) return null;
    const resourceTiming = {};
    const { xhrFilter: xhrFilter } = globalConfig.resourceTimings;
    const reportedInitiatorTypes = $50211f4337764418$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: type } = item;
        if (!name) return;
        if (type === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        const url = $50211f4337764418$var$resourceTypes.includes(type) ? globalConfig.resourceTimings.sanitiseEndpoints(name) : globalConfig.resourceTimings.mapResources(name);
        if (resourceTiming[url]) return;
        resourceTiming[url] = {
            startTime: Math.round(startTime - data.start),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.start), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.start), 0),
            type: type,
            ...$50211f4337764418$var$getNetworkData(item, data.start, globalConfig.resourceTimings.hasTimingHeaders),
            ...$50211f4337764418$var$getEvaluatedTimingHeader(item, globalConfig.resourceTimings.experimental__reportEvaluatedTimingHeaders, globalConfig.resourceTimings.hasTimingHeaders)
        };
    });
    return {
        'timings:resource': resourceTiming
    };
};

});


parcelRegister("2lyt0", function(module, exports) {

$parcel$export(module.exports, "makeShareableGlobalConfig", () => $0d84d98040ee5ee6$export$5b4fb14409a2a825);

var $b5Sjr = parcelRequire("b5Sjr");
const $0d84d98040ee5ee6$var$makeFeatureFlags = (allFeatureFlags, eventTypeFeatureFlags)=>{
    const featureFlagsForType = [];
    if (allFeatureFlags) featureFlagsForType.push(...allFeatureFlags);
    if (eventTypeFeatureFlags) featureFlagsForType.push(...eventTypeFeatureFlags);
    return featureFlagsForType;
};
const $0d84d98040ee5ee6$var$makeGlobalConfigPerType = (global, ffClient, allEventsConfig, eventConfig)=>{
    const allEventsConfigCustom = allEventsConfig && allEventsConfig.custom;
    const eventConfigCustom = eventConfig && eventConfig.custom;
    const custom = (allEventsConfigCustom || eventConfigCustom) && {
        ...allEventsConfigCustom,
        ...eventConfigCustom
    } || undefined;
    const allEventsConfigPlugins = allEventsConfig && allEventsConfig.plugins;
    const eventConfigPlugins = eventConfig && eventConfig.plugins;
    const plugins = (allEventsConfigPlugins || eventConfigPlugins) && [
        ...allEventsConfigPlugins || [],
        ...eventConfigPlugins || []
    ] || undefined;
    const pageVisibleValueOrigin = eventConfig?.pageVisibleValueOrigin ?? allEventsConfig?.pageVisibleValueOrigin ?? (0, $b5Sjr.PageVisibleValueOrigin).documentHidden;
    return Object.freeze({
        ...global,
        featureFlags: Object.freeze($0d84d98040ee5ee6$var$makeFeatureFlags(allEventsConfig && allEventsConfig.featureFlags, eventConfig && eventConfig.featureFlags).reduce((acc, value)=>{
            acc[value] = ffClient.getValue(value);
            return acc;
        }, {})),
        custom: custom,
        plugins: plugins,
        histogram: eventConfig?.histogram,
        pageVisibleValueOrigin: pageVisibleValueOrigin,
        enableBundleEvalTimings: eventConfig?.enableBundleEvalTimings
    });
};
const $0d84d98040ee5ee6$export$5b4fb14409a2a825 = async (globalConfig)=>{
    const ffClient = await globalConfig.plugins.featureFlags.client;
    const global = {
        app: globalConfig.info.app,
        product: globalConfig.info.product,
        region: globalConfig.info.region,
        resourceTimings: globalConfig.plugins.resourceTimings,
        bundleEvalTimings: globalConfig.plugins.bundleEvalTimings,
        ffClient: ffClient,
        hostname: globalConfig.info.hostname || window.location.hostname,
        ssr: globalConfig.ssr,
        enableReactUFOTracker: globalConfig.enableReactUFOTracker,
        webVitals: {
            enabled: globalConfig.events[(0, $b5Sjr.BMEventsType).WEB_VITALS]?.enabled,
            timeout: globalConfig.events[(0, $b5Sjr.BMEventsType).WEB_VITALS]?.timeout,
            ttciEnabled: globalConfig.events[(0, $b5Sjr.BMEventsType).WEB_VITALS]?.ttciEnabled
        }
    };
    return {
        [(0, $b5Sjr.BMEventsType).PAGE_LOAD]: $0d84d98040ee5ee6$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $b5Sjr.BMEventsType).PAGE_LOAD]),
        [(0, $b5Sjr.BMEventsType).PAGE_SEGMENT_LOAD]: $0d84d98040ee5ee6$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $b5Sjr.BMEventsType).PAGE_SEGMENT_LOAD]),
        [(0, $b5Sjr.BMEventsType).INLINE_RESULT]: $0d84d98040ee5ee6$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $b5Sjr.BMEventsType).INLINE_RESULT]),
        [(0, $b5Sjr.BMEventsType).CUSTOM]: $0d84d98040ee5ee6$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $b5Sjr.BMEventsType).CUSTOM]),
        [(0, $b5Sjr.BMEventsType).WEB_VITALS]: $0d84d98040ee5ee6$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $b5Sjr.BMEventsType).WEB_VITALS])
    };
};

});



parcelRegister("5pGvH", function(module, exports) {

$parcel$export(module.exports, "addTimingFromPerformanceMark", () => $2d31717a652c2a6a$export$758b9a33800fa436);
$parcel$export(module.exports, "getTimings", () => $2d31717a652c2a6a$export$6d488733a547304);
const $2d31717a652c2a6a$var$timings = [];
function $2d31717a652c2a6a$export$758b9a33800fa436(name, startMark, stopMark, cleanStart = false, cleanStop = false) {
    $2d31717a652c2a6a$var$timings.push({
        name: name,
        startMark: startMark,
        stopMark: stopMark,
        cleanStart: cleanStart,
        cleanStop: cleanStop
    });
}
function $2d31717a652c2a6a$export$6d488733a547304() {
    const reportedTimingsObj = {};
    $2d31717a652c2a6a$var$timings.forEach(({ name: name, startMark: startMark, stopMark: stopMark, cleanStart: cleanStart, cleanStop: cleanStop })=>{
        const startEntryList = performance.getEntriesByName(startMark);
        const stopEntryList = performance.getEntriesByName(stopMark);
        if (startEntryList?.length > 0 && stopEntryList?.length > 0) {
            const startEntry = startEntryList[startEntryList.length - 1];
            const stopEntry = stopEntryList[stopEntryList.length - 1];
            const { startTime: startTime } = startEntry;
            const duration = stopEntry.startTime - startTime;
            const timing = {
                startTime: Math.round(startTime),
                duration: Math.round(duration)
            };
            reportedTimingsObj[name] = timing;
        }
        if (cleanStart) performance.clearMarks(startMark);
        if (cleanStop) performance.clearMarks(stopMark);
    });
    return reportedTimingsObj;
}

});

parcelRegister("L0eva", function(module, exports) {

$parcel$export(module.exports, "ufologger", () => $9f24bc16664dc9d9$export$4ab84f6f04f6566d);
$parcel$export(module.exports, "ufolog", () => $9f24bc16664dc9d9$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $9f24bc16664dc9d9$export$d53d07b6034c4560);
class $9f24bc16664dc9d9$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($9f24bc16664dc9d9$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($9f24bc16664dc9d9$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $9f24bc16664dc9d9$export$4ab84f6f04f6566d = new $9f24bc16664dc9d9$var$UFOLogger();
const $9f24bc16664dc9d9$export$b4958caff08a0960 = (...args)=>{
    $9f24bc16664dc9d9$export$4ab84f6f04f6566d.log(...args);
};
const $9f24bc16664dc9d9$export$d53d07b6034c4560 = (...args)=>{
    $9f24bc16664dc9d9$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("1vxVh", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", () => $f0750c5929fb2dfa$export$15e172712955e18f);
const $f0750c5929fb2dfa$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});

parcelRegister("2OtXX", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", () => $0c0a4798e2fb12c7$export$6123a44dc2384540);
$parcel$export(module.exports, "setGlobalEventStream", () => $0c0a4798e2fb12c7$export$c1522520b417b066);
$parcel$export(module.exports, "subscribeEvent", () => $0c0a4798e2fb12c7$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $0c0a4798e2fb12c7$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $0c0a4798e2fb12c7$export$7c957416596ca127);

var $L0eva = parcelRequire("L0eva");

var $2mh9F = parcelRequire("2mh9F");
const $0c0a4798e2fb12c7$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $0c0a4798e2fb12c7$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $0c0a4798e2fb12c7$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $0c0a4798e2fb12c7$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $L0eva.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $0c0a4798e2fb12c7$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $2mh9F.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $0c0a4798e2fb12c7$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $2mh9F.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $0c0a4798e2fb12c7$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $2mh9F.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("2mh9F", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $02245a7f4fb1ca29$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $02245a7f4fb1ca29$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $02245a7f4fb1ca29$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $02245a7f4fb1ca29$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $02245a7f4fb1ca29$export$837e0f79a8056912);
var $02245a7f4fb1ca29$export$96253c35c37cf96b;
(function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
})($02245a7f4fb1ca29$export$96253c35c37cf96b || ($02245a7f4fb1ca29$export$96253c35c37cf96b = {}));
var $02245a7f4fb1ca29$export$a12c67b37a306b13;
(function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
})($02245a7f4fb1ca29$export$a12c67b37a306b13 || ($02245a7f4fb1ca29$export$a12c67b37a306b13 = {}));
var $02245a7f4fb1ca29$export$66b33c055cbb625e;
(function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
})($02245a7f4fb1ca29$export$66b33c055cbb625e || ($02245a7f4fb1ca29$export$66b33c055cbb625e = {}));
var $02245a7f4fb1ca29$export$3ce489cbe02dc21b;
(function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
})($02245a7f4fb1ca29$export$3ce489cbe02dc21b || ($02245a7f4fb1ca29$export$3ce489cbe02dc21b = {}));
var $02245a7f4fb1ca29$export$341b330828bd3906;
(function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
})($02245a7f4fb1ca29$export$341b330828bd3906 || ($02245a7f4fb1ca29$export$341b330828bd3906 = {}));
var $02245a7f4fb1ca29$export$b9b20160f581e4f8;
(function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
})($02245a7f4fb1ca29$export$b9b20160f581e4f8 || ($02245a7f4fb1ca29$export$b9b20160f581e4f8 = {}));
const $02245a7f4fb1ca29$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $02245a7f4fb1ca29$export$9f2bf58999404c75 = 'fmp';
const $02245a7f4fb1ca29$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("1zivP", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $4ae65a64ff35e07a$export$13e680397ec8f3eb);

var $1vxVh = parcelRequire("1vxVh");
class $4ae65a64ff35e07a$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $1vxVh.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $4ae65a64ff35e07a$export$13e680397ec8f3eb = new $4ae65a64ff35e07a$var$VisibilityChangeObserver();

});

parcelRegister("12kyE", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", () => $0c4063df3b65d57f$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $0c4063df3b65d57f$export$cc26007c03242fff);
var $0c4063df3b65d57f$export$994164cf3ae1cc9a;
(function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
})($0c4063df3b65d57f$export$994164cf3ae1cc9a || ($0c4063df3b65d57f$export$994164cf3ae1cc9a = {}));
var $0c4063df3b65d57f$export$cc26007c03242fff;
(function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
})($0c4063df3b65d57f$export$cc26007c03242fff || ($0c4063df3b65d57f$export$cc26007c03242fff = {}));

});

parcelRegister("5iuyH", function(module, exports) {

$parcel$export(module.exports, "default", () => $606b4e1d81465f64$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useInteractionContext", () => $606b4e1d81465f64$export$11bcb6e9af2aca35);

var $eUqFw = parcelRequire("eUqFw");

var $jsCXU = parcelRequire("jsCXU");
var $606b4e1d81465f64$export$2e2bcd8739ae039 = (0, $jsCXU.default);
function $606b4e1d81465f64$export$11bcb6e9af2aca35() {
    return (0, $eUqFw.useContext)((0, $jsCXU.default));
}

});

parcelRegister("aPkDp", function(module, exports) {

$parcel$export(module.exports, "payloadPublisher", () => $319a80c62bf661e1$export$edb879ae55bb9be3);

var $12kyE = parcelRequire("12kyE");
var $1zivP = parcelRequire("1zivP");

var $2OtXX = parcelRequire("2OtXX");

var $L0eva = parcelRequire("L0eva");

var $2mh9F = parcelRequire("2mh9F");


var $eHCgh = parcelRequire("eHCgh");

var $j5bIs = parcelRequire("j5bIs");

var $f1nv9 = parcelRequire("f1nv9");

var $gUblJ = parcelRequire("gUblJ");

var $lV8BK = parcelRequire("lV8BK");

var $1PXK2 = parcelRequire("1PXK2");

var $7vyp8 = parcelRequire("7vyp8");

var $f9lWA = parcelRequire("f9lWA");

var $eGF6g = parcelRequire("eGF6g");

var $egMS7 = parcelRequire("egMS7");

var $6nw1o = parcelRequire("6nw1o");

var $iiWds = parcelRequire("iiWds");

var $gdF3f = parcelRequire("gdF3f");

var $49Nga = parcelRequire("49Nga");

var $kJPF2 = parcelRequire("kJPF2");

var $i4h4J = parcelRequire("i4h4J");

var $5QkPy = parcelRequire("5QkPy");
const $319a80c62bf661e1$var$UNKNOWN_VALUE = 'unknown';
const $319a80c62bf661e1$var$DEFAULT_PAYLOAD_DATA = {
    schemaVersion: $319a80c62bf661e1$var$UNKNOWN_VALUE,
    id: $319a80c62bf661e1$var$UNKNOWN_VALUE,
    uuid: $319a80c62bf661e1$var$UNKNOWN_VALUE,
    state: {
        id: $319a80c62bf661e1$var$UNKNOWN_VALUE
    },
    result: {
        startTime: 0,
        duration: 0,
        success: false
    },
    type: (0, $12kyE.ExperienceTypes).Experience,
    category: $319a80c62bf661e1$var$UNKNOWN_VALUE,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    metadata: {},
    explicitTimings: {},
    metrics: {
        startTime: 0,
        endTime: 0,
        marks: []
    },
    platform: null,
    children: [],
    pageVisibleState: (0, $2mh9F.PageVisibleState).MIXED,
    isSSROutputAsFMP: false,
    timings: [],
    featureFlags: []
};
class $319a80c62bf661e1$var$Publisher {
    publish(data) {
        const payloadStart = (0, $5QkPy.getPerformanceObject)()?.now() || 0;
        const experienceKey = this.getExperienceKey(data);
        if (!this.allowlist(experienceKey, data)) {
            (0, $L0eva.ufowarn)(`experience ${experienceKey} does not meet requirements of allowlist`);
            return;
        }
        // it is used to setup default properties on the data to prevent errors
        const supportedData = {
            ...$319a80c62bf661e1$var$DEFAULT_PAYLOAD_DATA,
            ...data
        };
        const payload = {
            actionSubject: 'experience',
            action: 'measured',
            source: 'measured',
            tags: [
                'observability'
            ],
            attributes: {
                properties: {
                    'event:source': {
                        name: 'ufo/web',
                        version: supportedData.schemaVersion
                    },
                    'event:schema': (0, $7b1a38b2ca9b29be$export$93809551debf385f) || $319a80c62bf661e1$var$UNKNOWN_VALUE,
                    'event:product': this.product,
                    'event:region': this.region,
                    'event:hostname': this.hostname,
                    'event:route': this.route.getRoute(),
                    ...(0, $f9lWA.eventBrowserPlugin)(),
                    ...(0, $eGF6g.eventCpusPlugin)(),
                    ...(0, $6nw1o.eventMemoryPlugin)(),
                    ...(0, $iiWds.eventNetworkPlugin)(),
                    ...(0, $1PXK2.appFramework)(this.app),
                    ...(0, $7vyp8.appVersion)(this.app),
                    'experience:name': supportedData.id,
                    // platform.fe.page-load|interaction|custom|page-segment.editor
                    'experience:key': experienceKey,
                    'experience:status': supportedData.state.id,
                    'experience:duration': supportedData.result.duration,
                    ...supportedData.result.startTime !== null ? {
                        'experience:startTime': supportedData.result.startTime
                    } : null,
                    ...supportedData.uuid ? {
                        'experience:spanId': supportedData.uuid
                    } : null,
                    ...this.tenantType !== (0, $eHCgh.TenantType).RealUser ? {
                        'event:tenantType': this.tenantType
                    } : null,
                    ...this.mapMetadataToPayload(supportedData.metadata),
                    ...this.extractPageLoadData(supportedData),
                    ...(0, $gUblJ.pageVisibleState)(supportedData),
                    ...(0, $i4h4J.isInitialPageLoad)(supportedData) && (0, $49Nga.ssrSuccess)(this.ssr),
                    ...(0, $i4h4J.isInitialPageLoad)(supportedData) && (0, $gdF3f.ssrFeatureFlags)(this.ssr),
                    ...this.featureFlagClient && (0, $egMS7.featureFlags)(this.featureFlagClient, this.featureFlags, supportedData)
                },
                performance: this.getPerformanceMetrics(supportedData),
                task: supportedData.id
            }
        };
        const payloadEnd = (0, $5QkPy.getPerformanceObject)()?.now() || 0;
        payload.attributes.performance.payloadTime = payloadEnd - payloadStart;
        if (this.gasv3) this.gasv3.sendOperationalEvent(payload);
        else this.buffer.push(payload);
        (0, $L0eva.ufolog)('PAYLOAD:', JSON.stringify(payload, null, 2));
    }
    setGlobalEventStream() {
        if (!((0, $2OtXX.getGlobalEventStream)() instanceof (0, $j5bIs.UFOGlobalEventStream))) {
            const eventStream = new (0, $j5bIs.UFOGlobalEventStream)();
            eventStream.push({
                type: (0, $2mh9F.UFOGlobalEventStreamEventType).SUBSCRIBE,
                payload: {
                    experienceId: '__SUBSCRIBE_ALL__',
                    callback: this.publish.bind(this)
                }
            });
            (0, $2OtXX.setGlobalEventStream)(eventStream);
        }
    }
    setRoute(newRoute) {
        this.route.setRoute(newRoute);
    }
    setup(config) {
        (0, $1zivP.visibilityChangeObserver).start();
        (0, $lV8BK.resourceTimingBuffer).start();
        if (!this.product) this.product = config.product || '';
        if (config.allowlist) this.allowlist = config.allowlist;
        if (config.tenantType) this.tenantType = config.tenantType;
        if (config.hostname) this.hostname = config.hostname;
        if (config.region) this.region = config.region;
        if (config.app) this.app = config.app;
        if (config.featureFlagClient) this.featureFlagClient = config.featureFlagClient;
        if (config.featureFlags) this.featureFlags = config.featureFlags;
        if (config.ssr) this.ssr = config.ssr;
        if (config.bundleEvalTimings) this.bundleEvalTimings = config.bundleEvalTimings;
        if (config.resourceTimings) this.resourceTimings = config.resourceTimings;
        if (config.performanceConfig) this.performanceConfig = config.performanceConfig;
        if (config.plugins) this.plugins = config.plugins;
        this.setGlobalEventStream();
        if (!this.gasv3) {
            this.gasv3 = config.gasv3;
            this.buffer.forEach(this.gasv3.sendOperationalEvent);
        }
    }
    mapMetadataToPayload(metadata) {
        const payload = {};
        Object.entries(metadata).forEach(([key, value])=>{
            if (value !== undefined) payload[`custom:${key}`] = value;
        });
        return payload;
    }
    extractPageLoadData(data) {
        if ('initial' in data) return {
            'experience:pageLoadType': data.initial ? 'initial' : 'transition'
        };
        return {};
    }
    getPrefix(data) {
        if (data.platform !== null) return 'platform';
        return this.product;
    }
    getExperienceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.type
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.performanceType
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceType(data) {
        return data.performanceType;
    }
    getPerformanceMetrics(data) {
        return {
            'event:key': this.getExperiencePerformanceKey(data),
            'event:type': this.getExperiencePerformanceType(data),
            ...(0, $f1nv9.getPerformancePayload)(data, this.ssr, this.bundleEvalTimings, this.resourceTimings, this.performanceConfig),
            ...this.getPluginsMetrics(data)
        };
    }
    constructor(){
        this.gasv3 = null;
        this.product = '';
        this.region = $319a80c62bf661e1$var$UNKNOWN_VALUE;
        this.hostname = (0, $5QkPy.getWindowObject)()?.location?.hostname || '';
        this.tenantType = (0, $eHCgh.TenantType).RealUser;
        this.app = {
            version: {
                web: $319a80c62bf661e1$var$UNKNOWN_VALUE
            }
        };
        this.performanceConfig = {};
        this.buffer = [];
        this.featureFlagClient = null;
        this.featureFlags = [];
        this.ssr = null;
        this.resourceTimings = null;
        this.bundleEvalTimings = null;
        this.route = (0, $kJPF2.Route);
        this.plugins = null;
        this.allowlist = ()=>true;
        this.getPluginsMetrics = (data)=>{
            const result = {};
            if (this.plugins) this.plugins.forEach((plugin)=>{
                const pluginOutput = plugin({
                    ...data
                });
                if (pluginOutput === null || typeof pluginOutput !== 'object') return;
                Object.entries(pluginOutput).forEach(([key, value])=>{
                    result[`${this.product}:${key}`] = value;
                });
            });
            return result;
        };
    }
}
const $319a80c62bf661e1$export$edb879ae55bb9be3 = new $319a80c62bf661e1$var$Publisher();

});
// temp solution until a proper versioning
const $7b1a38b2ca9b29be$export$93809551debf385f = '0.1.7';

parcelRegister("eHCgh", function(module, exports) {

$parcel$export(module.exports, "TenantType", () => $13ee15273756759e$export$92a757ac1398962f);

var $13ee15273756759e$export$92a757ac1398962f;
(function(TenantType) {
    TenantType["RealUser"] = "real-user";
    TenantType["Synthetic"] = "synthetic";
})($13ee15273756759e$export$92a757ac1398962f || ($13ee15273756759e$export$92a757ac1398962f = {}));

});

parcelRegister("j5bIs", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStream", () => $d97114714a3dd32e$export$faf4c91b80fc830e);

var $L0eva = parcelRequire("L0eva");

var $2mh9F = parcelRequire("2mh9F");
class $d97114714a3dd32e$export$faf4c91b80fc830e {
    push(event) {
        (0, $L0eva.ufolog)('EVENT STREAM push', event.type, event.payload);
        if (event.type === (0, $2mh9F.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD) this.publish(event.payload);
        if (event.type === (0, $2mh9F.UFOGlobalEventStreamEventType).SUBSCRIBE) this.subscribe(event.payload.experienceId, event.payload.callback);
        if (event.type === (0, $2mh9F.UFOGlobalEventStreamEventType).UNSUBSCRIBE) this.unsubscribe(event.payload.experienceId, event.payload.callback);
    }
    publish(eventPayload) {
        if (this.subscribers[0, $2mh9F.SUBSCRIBE_ALL]) this.subscribers[0, $2mh9F.SUBSCRIBE_ALL].forEach((fn)=>{
            fn(eventPayload);
        });
        this.subscribers[eventPayload.id]?.forEach((fn)=>{
            fn(eventPayload);
        });
    }
    subscribe(experienceId, fn) {
        (0, $L0eva.ufolog)('EVENT STREAM subscribe', experienceId);
        if (!this.subscribers[experienceId]) this.subscribers[experienceId] = [];
        this.subscribers[experienceId].push(fn);
    }
    unsubscribe(experienceId, fn) {
        const index = this.subscribers[experienceId].findIndex((entry)=>entry === fn);
        if (index !== -1) this.subscribers[experienceId].splice(index, 1);
    }
    constructor(){
        this.__buffer_only__ = false;
        this.subscribers = {};
    }
}

});

parcelRegister("f1nv9", function(module, exports) {

$parcel$export(module.exports, "getPerformancePayload", () => $1a314f755130a189$export$738d24377baf6a5e);

var $12kyE = parcelRequire("12kyE");

var $2mh9F = parcelRequire("2mh9F");

var $i4h4J = parcelRequire("i4h4J");

var $2H6KE = parcelRequire("2H6KE");

var $8X7ky = parcelRequire("8X7ky");

var $kRMqD = parcelRequire("kRMqD");

var $cl9el = parcelRequire("cl9el");
const $1a314f755130a189$var$LoadMetricKeys = {
    tti: 'metric:tti',
    fmp: 'metric:fmp',
    ttiHistograms: 'metric:tti:histogramBuckets',
    fmpHistograms: 'metric:fmp:histogramBuckets'
};
const $1a314f755130a189$var$InlineResultMetricKeys = {
    result: 'metric:result',
    response: 'metric:response',
    resultHistograms: 'metric:result:histogramBuckets',
    responseHistograms: 'metric:response:histogramBuckets'
};
const $1a314f755130a189$var$CustomMetricKeys = {
    duration: 'metric:duration',
    durationHistograms: 'metric:duration:histogramBuckets'
};
const $1a314f755130a189$var$getHistogram = (data, performanceConfig, isInitial)=>{
    let histogram = {};
    if (data.performanceConfig?.histogram) histogram = data.performanceConfig.histogram;
    else if (performanceConfig?.histogram) histogram = performanceConfig.histogram;
    if (histogram) {
        const histograms = histogram[data.performanceType];
        switch(data.performanceType){
            case (0, $12kyE.ExperiencePerformanceTypes).PageLoad:
            case (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad:
                const histogramType = isInitial !== undefined && isInitial === true ? 'initial' : 'transition';
                return histograms ? {
                    [$1a314f755130a189$var$LoadMetricKeys.ttiHistograms]: histograms[histogramType].tti,
                    [$1a314f755130a189$var$LoadMetricKeys.fmpHistograms]: histograms[histogramType].fmp
                } : {};
            case (0, $12kyE.ExperiencePerformanceTypes).InlineResult:
                return histograms ? {
                    [$1a314f755130a189$var$InlineResultMetricKeys.resultHistograms]: histograms.result,
                    [$1a314f755130a189$var$InlineResultMetricKeys.responseHistograms]: histograms.response
                } : {};
            case (0, $12kyE.ExperiencePerformanceTypes).Custom:
                return histograms ? {
                    [$1a314f755130a189$var$CustomMetricKeys.durationHistograms]: histograms.duration
                } : {};
        }
    }
};
const $1a314f755130a189$export$bd4e6d81a822ece6 = (data, ssr, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === (0, $2mh9F.FMP_MARK))?.time || (0, $i4h4J.isInitialPageLoad)(data) && ssr?.getDoneMark();
    const tti = data.metrics.endTime - data.metrics.startTime;
    const fmp = typeof fmpMark === 'number' ? fmpMark - data.metrics.startTime : tti;
    return {
        [$1a314f755130a189$var$LoadMetricKeys.tti]: Math.round(tti),
        [$1a314f755130a189$var$LoadMetricKeys.fmp]: Math.round(fmp),
        ...$1a314f755130a189$var$getHistogram(data, performanceConfig)
    };
};
const $1a314f755130a189$export$47f0208fd62dffce = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const responseMark = data.metrics.marks.find((mark)=>mark.name === (0, $2mh9F.INLINE_RESPONSE_MARK));
    const result = data.metrics.endTime - data.metrics.startTime;
    const response = responseMark ? responseMark.time - data.metrics.startTime : result;
    return {
        [$1a314f755130a189$var$InlineResultMetricKeys.result]: Math.round(result),
        [$1a314f755130a189$var$InlineResultMetricKeys.response]: Math.round(response),
        ...$1a314f755130a189$var$getHistogram(data, performanceConfig)
    };
};
const $1a314f755130a189$export$c25c1b3ff2ce92cf = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const duration = data.metrics.endTime - data.metrics.startTime;
    return {
        [$1a314f755130a189$var$CustomMetricKeys.duration]: Math.round(duration),
        ...$1a314f755130a189$var$getHistogram(data, performanceConfig)
    };
};
const $1a314f755130a189$var$getPerformanceMetrics = (data, ssr, performanceConfig)=>{
    switch(data.performanceType){
        case (0, $12kyE.ExperiencePerformanceTypes).PageLoad:
        case (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad:
            return $1a314f755130a189$export$bd4e6d81a822ece6(data, ssr, performanceConfig);
        case (0, $12kyE.ExperiencePerformanceTypes).InlineResult:
            return $1a314f755130a189$export$47f0208fd62dffce(data, performanceConfig);
        case (0, $12kyE.ExperiencePerformanceTypes).Custom:
            return $1a314f755130a189$export$c25c1b3ff2ce92cf(data, performanceConfig);
    }
};
const $1a314f755130a189$export$738d24377baf6a5e = (data, ssr, bundleEvalConfig, resourceConfig, performanceConfig)=>{
    return {
        ...$1a314f755130a189$var$getPerformanceMetrics(data, ssr, performanceConfig),
        ...(0, $cl9el.resourceTimings)(data, resourceConfig),
        ...(0, $kRMqD.bundleEvalTimings)(data, bundleEvalConfig),
        ...(0, $8X7ky.appTimings)(data, ssr),
        ...(0, $i4h4J.isInitialPageLoad)(data) ? (0, $2H6KE.navigationMetrics)() : null
    };
};

});
parcelRegister("i4h4J", function(module, exports) {

$parcel$export(module.exports, "isInitialPageLoad", () => $a663081c3bb81f0a$export$7167d96e9881d500);

var $12kyE = parcelRequire("12kyE");
const $a663081c3bb81f0a$export$7167d96e9881d500 = (data)=>{
    return data.performanceType === (0, $12kyE.ExperiencePerformanceTypes).PageLoad && data.initial === true;
};

});

parcelRegister("2H6KE", function(module, exports) {

$parcel$export(module.exports, "navigationMetrics", () => $750a8a159690dd53$export$b88d990436be0f8a);
const $750a8a159690dd53$export$b88d990436be0f8a = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("8X7ky", function(module, exports) {

$parcel$export(module.exports, "appTimings", () => $109d16338e8d80ef$export$e952f50a4f2d02da);

var $12kyE = parcelRequire("12kyE");

var $i4h4J = parcelRequire("i4h4J");

var $2E6O3 = parcelRequire("2E6O3");

var $9yiSs = parcelRequire("9yiSs");
const $109d16338e8d80ef$export$e952f50a4f2d02da = (data, ssrConfig)=>{
    const explicitTimings = data.performanceType === (0, $12kyE.ExperiencePerformanceTypes).PageLoad && data.explicitTimings || null;
    const timings = (0, $2E6O3.customTimings)(data);
    const ssr = (0, $i4h4J.isInitialPageLoad)(data) ? (0, $9yiSs.ssrTimings)(ssrConfig) : null;
    const timingsApp = (explicitTimings || timings || ssr) && {
        ...explicitTimings,
        ...timings,
        ...ssr
    };
    if (!timingsApp || Object.keys(timingsApp).length === 0) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("2E6O3", function(module, exports) {

$parcel$export(module.exports, "customTimings", () => $abe3c4f915cfbd73$export$6126f85083a72c6e);
const $abe3c4f915cfbd73$var$retrieveTimings = (data)=>{
    const configTimings = data.timings || [];
    const timings = configTimings.reduce((entries, timing)=>{
        const startMark = data.metrics.marks.find((mark)=>mark.name === timing.startMark);
        if (timing.startMark && !startMark) return entries;
        const endMark = data.metrics.marks.find((mark)=>mark.name === timing.endMark);
        if (timing.endMark && !endMark) return entries;
        if (data.metrics.startTime === null || data.metrics.endTime === null) return null;
        const startTime = Math.round((startMark ? startMark.time : data.metrics.startTime) - data.metrics.startTime);
        const duration = Math.round((endMark ? endMark.time : data.metrics.endTime) - data.metrics.startTime - startTime);
        entries[`${timing.key}`] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
const $abe3c4f915cfbd73$export$6126f85083a72c6e = (data)=>{
    if (!data.timings) return null;
    const timings = $abe3c4f915cfbd73$var$retrieveTimings(data);
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});

parcelRegister("9yiSs", function(module, exports) {

$parcel$export(module.exports, "ssrTimings", () => $c54f87029da64e82$export$130f411261a599c5);

const $c54f87029da64e82$var$filterEntry = (entry)=>{
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
const $c54f87029da64e82$var$mapEntry = (entry)=>{
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
const $c54f87029da64e82$var$SSR_PREFIX = 'ssr';
const $c54f87029da64e82$var$mapKey = (key)=>{
    if (key === 'total') return $c54f87029da64e82$var$SSR_PREFIX;
    return `${$c54f87029da64e82$var$SSR_PREFIX}${0, $46a1f52dfe9104f8$export$b98e411ae80c806f}${key}`;
};
const $c54f87029da64e82$export$130f411261a599c5 = (ssr)=>{
    if (!ssr?.getTimings) return null;
    const timings = ssr.getTimings();
    if (!timings) return null;
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($c54f87029da64e82$var$filterEntry(entry[1])) acc[$c54f87029da64e82$var$mapKey(entry[0])] = $c54f87029da64e82$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});
const $46a1f52dfe9104f8$export$b98e411ae80c806f = '/';



parcelRegister("kRMqD", function(module, exports) {

$parcel$export(module.exports, "bundleEvalTimings", () => $9bbd12134a2712ff$export$1a2bb347935fc536);

var $5QkPy = parcelRequire("5QkPy");
const $9bbd12134a2712ff$export$1a2bb347935fc536 = (data, bundleEvalTimings, performance = (0, $5QkPy.getPerformanceObject)() || undefined)=>{
    if (!bundleEvalTimings) return null;
    const started = {};
    const timings = {};
    performance?.getEntriesByType('mark').forEach((mark)=>{
        const result = bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result || data.result.startTime === null) return;
        const { type: type, name: name } = result;
        if (type === 'start' && mark.startTime >= data.result.startTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.result.startTime),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (bundleEvalTimings?.additionalTimings && data.result.startTime !== null) {
        const result = bundleEvalTimings.additionalTimings(data.result.startTime);
        if (result) Object.entries(result).forEach(([key, value])=>{
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};

});
parcelRegister("5QkPy", function(module, exports) {

$parcel$export(module.exports, "getWindowObject", () => $42148b795dd54235$export$9aa44f85591248d9);
$parcel$export(module.exports, "getPerformanceObject", () => $42148b795dd54235$export$8cd0c777b0eb66a0);
$parcel$export(module.exports, "getPerformanceObserverObject", () => $42148b795dd54235$export$74560fd4e61fd440);
const $42148b795dd54235$export$9aa44f85591248d9 = ()=>{
    return typeof window !== 'undefined' && !!window ? window : undefined;
};
const $42148b795dd54235$export$8cd0c777b0eb66a0 = ()=>{
    const { performance: performance } = $42148b795dd54235$export$9aa44f85591248d9() || {};
    return performance;
};
const $42148b795dd54235$export$74560fd4e61fd440 = ()=>{
    const { PerformanceObserver: PerformanceObserver } = $42148b795dd54235$export$9aa44f85591248d9() || {};
    return PerformanceObserver;
};

});


parcelRegister("cl9el", function(module, exports) {

$parcel$export(module.exports, "resourceTimings", () => $6fb2e0b4a02928d6$export$81a7d52441a06b50);

var $5QkPy = parcelRequire("5QkPy");

var $lV8BK = parcelRequire("lV8BK");
const $6fb2e0b4a02928d6$var$cacheableTypes = [
    'script',
    'link'
];
const $6fb2e0b4a02928d6$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $6fb2e0b4a02928d6$var$CACHE_NETWORK = 'network';
const $6fb2e0b4a02928d6$var$CACHE_MEMORY = 'memory';
const $6fb2e0b4a02928d6$var$CACHE_DISK = 'disk';
const $6fb2e0b4a02928d6$var$calculateTransferType = (type, duration, size)=>{
    if (!$6fb2e0b4a02928d6$var$cacheableTypes.includes(type)) return $6fb2e0b4a02928d6$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $6fb2e0b4a02928d6$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $6fb2e0b4a02928d6$var$CACHE_DISK;
    if (size === undefined) return null;
    return $6fb2e0b4a02928d6$var$CACHE_NETWORK;
};
const $6fb2e0b4a02928d6$var$hasAccessToResourceSize = (url, type, entry, hasTimingHeaders)=>{
    return !$6fb2e0b4a02928d6$var$cacheableTypes.includes(type) || url.includes('localhost') || !!(0, $5QkPy.getWindowObject)() && url.includes(window.location.hostname) || hasTimingHeaders(url, entry);
};
const $6fb2e0b4a02928d6$var$getReportedInitiatorTypes = (xhrEnabled)=>{
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
const $6fb2e0b4a02928d6$var$evaluateAccessToResourceTimings = (_url, entry)=>{
    return !(entry.responseStart === 0 && entry.startTime > entry.responseStart);
};
const $6fb2e0b4a02928d6$var$getSizeObject = (size)=>size !== undefined ? {
        size: size
    } : null;
const $6fb2e0b4a02928d6$var$getNetworkData = (item, eventStart, hasTimingHeaders = $6fb2e0b4a02928d6$var$evaluateAccessToResourceTimings)=>{
    const { name: name, duration: duration, transferSize: transferSize, initiatorType: initiatorType, responseStart: responseStart } = item;
    const ttfb = Math.round(responseStart - eventStart);
    if (!$6fb2e0b4a02928d6$var$hasAccessToResourceSize(name, initiatorType, item, hasTimingHeaders)) return {};
    if ($6fb2e0b4a02928d6$var$cacheableTypes.includes(initiatorType)) {
        const transferType = $6fb2e0b4a02928d6$var$calculateTransferType(initiatorType, duration, transferSize);
        if (!transferType) return {
            ttfb: ttfb,
            ...$6fb2e0b4a02928d6$var$getSizeObject(transferSize)
        };
        if (transferType !== $6fb2e0b4a02928d6$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return {
            ttfb: ttfb,
            transferType: transferType,
            ...$6fb2e0b4a02928d6$var$getSizeObject(transferSize)
        };
    }
    return {
        ttfb: ttfb,
        ...$6fb2e0b4a02928d6$var$getSizeObject(transferSize)
    };
};
const $6fb2e0b4a02928d6$export$81a7d52441a06b50 = (data, resourceTimings, performance = (0, $5QkPy.getPerformanceObject)() || undefined)=>{
    if (data.result.startTime === null || !resourceTimings?.sanitiseEndpoints) return null;
    const resources = (0, $lV8BK.getResourceTimings)(data.result.startTime, performance);
    if (!resources?.length) return null;
    const resourceTiming = {};
    const { xhrFilter: xhrFilter } = resourceTimings;
    const reportedInitiatorTypes = $6fb2e0b4a02928d6$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: initiatorType } = item;
        if (!name || data.result.startTime === null) return;
        if (initiatorType === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        const url = $6fb2e0b4a02928d6$var$resourceTypes.includes(initiatorType) ? resourceTimings.sanitiseEndpoints(name) : resourceTimings.mapResources(name);
        if (!url || resourceTiming[url]) return;
        resourceTiming[url] = {
            startTime: Math.round(startTime - data.result.startTime),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.result.startTime), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.result.startTime), 0),
            type: initiatorType,
            ...$6fb2e0b4a02928d6$var$getNetworkData(item, data.result.startTime, resourceTimings.hasTimingHeaders)
        };
    });
    return {
        'timings:resource': resourceTiming
    };
};

});
parcelRegister("lV8BK", function(module, exports) {

$parcel$export(module.exports, "resourceTimingBuffer", () => $96484df306d42410$export$bea963256235a63e);
$parcel$export(module.exports, "getResourceTimings", () => $96484df306d42410$export$9eebb59359c2e9e5);
// @flow strict-local

var $L0eva = parcelRequire("L0eva");

var $5QkPy = parcelRequire("5QkPy");
const $96484df306d42410$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource: (entry)=>({
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: Math.round(entry.startTime),
            duration: Math.round(entry.duration),
            fetchStart: Math.round(entry.fetchStart || 0),
            workerStart: Math.round(entry.workerStart || 0),
            responseStart: Math.round(entry.responseStart || 0)
        }),
    start: (performance = (0, $5QkPy.getPerformanceObject)(), PerformanceObserver1 = (0, $5QkPy.getPerformanceObserverObject)())=>{
        if (!PerformanceObserver1 || !performance || typeof PerformanceObserver1 === 'undefined') return;
        if ($96484df306d42410$export$bea963256235a63e.observer) {
            (0, $L0eva.ufologger).warn('Observer is already running');
            return;
        }
        const resources = performance.getEntriesByType?.('resource');
        if (resources) $96484df306d42410$export$bea963256235a63e.timings = resources.map((resource)=>$96484df306d42410$export$bea963256235a63e.transformResource(resource));
        $96484df306d42410$export$bea963256235a63e.observer = new PerformanceObserver1($96484df306d42410$export$bea963256235a63e.addTimings);
        $96484df306d42410$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop: ()=>{
        if ($96484df306d42410$export$bea963256235a63e.observer) {
            $96484df306d42410$export$bea963256235a63e.observer.disconnect();
            $96484df306d42410$export$bea963256235a63e.observer = null;
        }
        $96484df306d42410$export$bea963256235a63e.timings = [];
    },
    addTimings: (list)=>{
        const entries = list.getEntries().map((entry)=>$96484df306d42410$export$bea963256235a63e.transformResource(entry));
        const overflow = $96484df306d42410$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $96484df306d42410$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $96484df306d42410$export$bea963256235a63e.maxSize;
            $96484df306d42410$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $96484df306d42410$export$bea963256235a63e.timings.push(...entries);
    }
};
const $96484df306d42410$export$9eebb59359c2e9e5 = (startTime, performance = (0, $5QkPy.getPerformanceObject)())=>{
    if (!PerformanceObserver || !$96484df306d42410$export$bea963256235a63e.observer) {
        const resources = performance?.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>timing.startTime >= startTime);
        return null;
    }
    return $96484df306d42410$export$bea963256235a63e.timings.filter((timing)=>timing.startTime >= startTime);
};

});



parcelRegister("gUblJ", function(module, exports) {

$parcel$export(module.exports, "pageVisibleState", () => $741fefa297283344$export$723b4c298aca63af);

var $2mh9F = parcelRequire("2mh9F");
const $741fefa297283344$export$723b4c298aca63af = (data)=>{
    return {
        'experience:pageVisible': data.pageVisibleState ?? (document.hidden ? (0, $2mh9F.PageVisibleState).HIDDEN : (0, $2mh9F.PageVisibleState).VISIBLE)
    };
};

});

parcelRegister("1PXK2", function(module, exports) {

$parcel$export(module.exports, "appFramework", () => $f13efc3b6faf5cea$export$e34e4529b979f74c);
const $f13efc3b6faf5cea$export$e34e4529b979f74c = (config)=>{
    if (!config.framework) return null;
    return {
        'app:framework:name': config.framework.name,
        'app:framework:version': config.framework.version
    };
};

});

parcelRegister("7vyp8", function(module, exports) {

$parcel$export(module.exports, "appVersion", () => $998453b7abe3eae8$export$82ae485178b37419);
const $998453b7abe3eae8$export$82ae485178b37419 = (config)=>{
    const pluginData = {
        'app:web:version': config.version.web
    };
    if (config.version.ssr) pluginData['app:ssr:version'] = config.version.ssr;
    return pluginData;
};

});

parcelRegister("f9lWA", function(module, exports) {

$parcel$export(module.exports, "eventBrowserPlugin", () => $05c84b1c690a1546$export$f435c2789ca334a7);

var $amtAu = parcelRequire("amtAu");

var $5iWql = parcelRequire("5iWql");

var $5QkPy = parcelRequire("5QkPy");
const $05c84b1c690a1546$export$f435c2789ca334a7 = (0, $5iWql.default)(()=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($amtAu))).getParser) return null;
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($amtAu))).getParser((0, $5QkPy.getWindowObject)()?.navigator?.userAgent || '');
    return {
        'event:browser:name': browser.getBrowserName(),
        'event:browser:version': browser.getBrowserVersion()
    };
});

});

parcelRegister("eGF6g", function(module, exports) {

$parcel$export(module.exports, "eventCpusPlugin", () => $0b76c37ccde31515$export$db7649b8854107ad);

var $5iWql = parcelRequire("5iWql");
const $0b76c37ccde31515$export$db7649b8854107ad = (0, $5iWql.default)(()=>{
    if (!navigator.hardwareConcurrency) return null;
    return {
        'event:cpus': navigator.hardwareConcurrency
    };
});

});

parcelRegister("egMS7", function(module, exports) {

$parcel$export(module.exports, "featureFlags", () => $b369f133c84cbc4d$export$e62953d023125748);
const $b369f133c84cbc4d$export$e62953d023125748 = (featureFlagClient, featureFlags, data)=>{
    const allFeatureFlags = [
        ...featureFlags,
        ...data.featureFlags || []
    ];
    if (allFeatureFlags.length === 0) return null;
    const initialMemo = [];
    allFeatureFlags.reduce((memo, featureFlagKey)=>{
        const ffVal = featureFlagClient.getValue(featureFlagKey);
        if (ffVal !== undefined && ffVal !== null) memo.push([
            featureFlagKey,
            ffVal
        ]);
        return memo;
    }, initialMemo);
    const mappedFeatureFlags = Object.fromEntries(initialMemo);
    return {
        featureFlags: mappedFeatureFlags
    };
};

});

parcelRegister("6nw1o", function(module, exports) {

$parcel$export(module.exports, "eventMemoryPlugin", () => $bdd4b40bc68453c4$export$81efaf8414879a1a);

var $5iWql = parcelRequire("5iWql");
const $bdd4b40bc68453c4$export$81efaf8414879a1a = (0, $5iWql.default)(()=>{
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'event:memory': navigator.deviceMemory
    };
});

});

parcelRegister("iiWds", function(module, exports) {

$parcel$export(module.exports, "eventNetworkPlugin", () => $809db2fde62cfdf3$export$ce1cf816dce1da56);
const $809db2fde62cfdf3$export$ce1cf816dce1da56 = ()=>{
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("gdF3f", function(module, exports) {

$parcel$export(module.exports, "ssrFeatureFlags", () => $091cbf54f91fc2bf$export$fdbea518c19dfa8);
const $091cbf54f91fc2bf$export$fdbea518c19dfa8 = (ssr)=>{
    if (!ssr?.getFeatureFlags) return null;
    try {
        const featureFlags = ssr.getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};

});

parcelRegister("49Nga", function(module, exports) {

$parcel$export(module.exports, "ssrSuccess", () => $86c6fb253dbfd3c9$export$a3dc8251cf55b2e0);
const $86c6fb253dbfd3c9$export$a3dc8251cf55b2e0 = (ssr)=>{
    if (ssr?.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("kJPF2", function(module, exports) {

$parcel$export(module.exports, "Route", () => $6e6c395ee37fd93c$export$e7b0ac011bb776c6);
const $6e6c395ee37fd93c$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute (newRoute) {
        this.route = newRoute;
    },
    getRoute () {
        return this.route;
    }
};

});


// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $6bb2437d634f2335$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

const $80f8efc879637eec$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $80f8efc879637eec$export$f005e2e9f707cb5f = 'commercial';
const $80f8efc879637eec$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $80f8efc879637eec$export$a739cd5aac835909 = 'stg';
const $80f8efc879637eec$export$42dd0cdd351a4a9 = 'prod';
const $80f8efc879637eec$export$404582bc18fe4d9e = 'dev';

const $28470208e5f4eca0$export$42f4885608027d0c = 'non_boolean';

// same types defined in analytics-web-client but avoid creating dependency with that
const $662e33bb7444ae33$export$a1562d08625f5d7e = 'ui';
const $662e33bb7444ae33$export$947dac6c72b26f81 = 'track';
const $662e33bb7444ae33$export$f1d537d508d2945a = 'screen';
const $662e33bb7444ae33$export$12346a674644c156 = 'operational';
const $662e33bb7444ae33$export$b055de0e665cb20c = 'unknown';

const $595550bfc4684751$export$cf090d5281b5ae06 = 10000;
const $595550bfc4684751$export$8575e30be0feb909 = 30000;

const $246e515cf63acef1$export$3288b14b6745c572 = 204;
const $246e515cf63acef1$export$c09e7ea0fc79f34f = 409;
const $246e515cf63acef1$export$974c37534b0191b1 = 503;


$parcel$global.rlb("i5RRW")
//# sourceMappingURL=shared~commons~atlassian~ar.06db4eb0.js.map
